import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Badge,
  Form,
  Card,
  Modal,
} from "react-bootstrap";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaSave } from "react-icons/fa";
import { MdCancel } from "react-icons/md";

import { toast } from "react-toastify";
import moment from "moment";
import { fetchProjectDetails, updateProject } from "../Api/ViewProjects";
import { fetchProjectRemarks, addProjectRemark } from "../Api/ViewProjects";
import "./ProjectView.css";
import {
  getTasksByProject,
  updateTask,
  getAllTaskStatus,
} from "../Api/TaskMaster";
import {
  startTaskWork,
  stopTaskWork,
  getTaskAssignmentsByTaskId,
  pauseTaskWork,
  createTaskWorkLog,
  getTaskLogsByTaskId,
  getTaskListByAssignedUser,
} from "../Api/TaskMaster";
import TaskEditModal from "./TaskEditModal";
import TaskViewSidebar from "./TaskViewSidebar";
import { getTeamsByOrg, getTeamById } from "../Api/TeamMaster";
import { getUsersByIds } from "../Api/Auth";
import { getTicketsByProjectId } from "../Api/TicketApiOrg";
import {
  getTicketByTicketId,
  addTicketWorkLog,
  getTicketLogsByTicketId,
} from "../Api/TicketApiOrg";
import { FaArrowCircleLeft } from "react-icons/fa";
import { fetchCusVenCpByCusVenType } from "../Api/CusVenCpMasterApi";
import {
  getAssignmentsByTicketId,
  startWork,
  stopWork,
} from "../Api/TicketApiOrg";
import TaskTemplateModal from "./TaskTemplateModal";
import SprintTab from "./SprintTab";
import { getTemplatesByOrg, deleteTaskTemplate } from "../Api/TaskTemplate";
import {
  getPartnersByOrg,
  createPartner,
  updatePartner,
  getPartnersByProject,
} from "../Api/PartnerMaster";
import PartnerModal from "./PartnerModal";
import { getVendorById } from "../Api/MerchantMaster";
import CommercialModal from "./CommercialModal";
import ResourceModal from "./ResourceModal";
import {
  deleteResource,
  fetchResourcesByProject,
} from "../Api/projectResourceService";
import {
  fetchResourceById,
  fetchProjectTypes,
  fetchProjectTypeById,
  fetchCustomersByOrgId,
  fetchResourceByOrgId,
} from "../Api/InvoiceApi";
import {
  uploadMultipleProjectDocuments,
  getDocumentsByProject,
  deleteDocumentWithFile,
  downloadDocument,
  validateFile,
  handleFileDownload,
  updateProjectFavourite,
} from "../Api/ProjectMaster";
import { getAllProjectStatus } from "../Api/ProjectStatusApi";
import MilestoneModal from "./MilestoneModal";
import {
  getAllMilestones,
  getMilestonesByProjectAndOrg,
  createMilestone,
  updateMilestone,
} from "../Api/MilestoneMaster";
import StageModal from "./StageModal";
import {
  fetchStagesByProject,
  createStage,
  updateStage,
} from "../Api/StageMaster";
import {
  getTasksByProjectAndStage,
  createTasksFromExcel,
} from "../Api/TaskMaster";
import { fetchEventByCode } from "../Api/ViewEvent";

import {
  getBuildingBlocksByOrg,
  createBuildingBlock,
  getTasksByBuildingBlock,
  getBuildingBlocksByOrgAndProject,
  mapTaskToBuildingBlock,
  getBlockSummary,
  updateBuildingBlock, // 👈 ADD THIS
  getTicketsByBuildingBlock,
  mapTicketToBuildingBlock,
  removeTicketMapping,
  removeSpecificTaskMapping,
} from "../Api/BuildingBlockMaster";

import ProjectEvents from "./ProjectEvents";

import { getCommercialsByProject } from "../Api/CommercialMaster";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import * as XLSX from "xlsx";
import { MdAddChart } from "react-icons/md";
import { TfiViewListAlt } from "react-icons/tfi";
import { FaEdit } from "react-icons/fa";
import { Gantt, ViewMode } from "gantt-task-react";
import "gantt-task-react/dist/index.css";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { saveAs } from "file-saver";

const ProjectView = () => {
  // =========================================================================
  // STATE DECLARATIONS
  // =========================================================================

  // User and Project State
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userRoles = userDetails?.roles || [];
  console.log(userRoles);
  const userId = userDetails?.userId;
  const orgId = userDetails?.organisationId;
  const { projectId } = useParams();
  const navigate = useNavigate();

  // Define role constants
  const PROJECT_ADMIN_ROLE = "Project_admin";
  const PROJECT_MANAGER_ROLE = "Project_Manager";
  const PROJECT_COMMERCIAL_ROLE = "Project_Commercial";

  // Role checking functions
  const hasProjectAdminRole = () => {
    return userRoles.includes(PROJECT_ADMIN_ROLE);
  };

  const hasProjectManagerRole = () => {
    return userRoles.includes(PROJECT_MANAGER_ROLE);
  };

  const hasProjectCommercialRole = () => {
    return userRoles.includes(PROJECT_COMMERCIAL_ROLE);
  };

  const hasEditPermission = () => {
    // Project Admin and Project Manager can edit
    return hasProjectAdminRole() || hasProjectManagerRole();
  };

  const hasViewPermission = () => {
    // All three roles can view all tasks
    return (
      hasProjectAdminRole() ||
      hasProjectManagerRole() ||
      hasProjectCommercialRole()
    );
  };

  // UI State
  const [activeTab, setActiveTab] = useState("overview");
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showTaskSidebar, setShowTaskSidebar] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [expandedMilestones, setExpandedMilestones] = useState({});

  // Project Data State
  const [project, setProject] = useState(null);
  const [originalProject, setOriginalProject] = useState(null);
  const [projectStatuses, setProjectStatuses] = useState([]);
  const [projectStatusesLoading, setProjectStatusesLoading] = useState(false);
  const [projectTypes, setProjectTypes] = useState([]);
  const [projectTypeLoading, setProjectTypeLoading] = useState(false);
  const [projectTypeDesc, setProjectTypeDesc] = useState("");
  const [customers, setCustomers] = useState([]);
  const [customersLoading, setCustomersLoading] = useState(false);
  const [selectedCustomerName, setSelectedCustomerName] = useState("");

  // Team and Resource State
  const [teams, setTeams] = useState([]);
  const [selectedTeamId, setSelectedTeamId] = useState("");
  const [teamData, setTeamData] = useState(null);
  const [teamMemberDetails, setTeamMemberDetails] = useState([]);
  const [loadingTeamMembers, setLoadingTeamMembers] = useState(false);
  const [resourcesByOrg, setResourcesByOrg] = useState([]);
  const [resourcesByOrgLoading, setResourcesByOrgLoading] = useState(false);
  const [projectManagerName, setProjectManagerName] = useState("");
  const [salespersonName, setSalespersonName] = useState("");
  const [loadingManager, setLoadingManager] = useState(false);
  const [loadingSalesperson, setLoadingSalesperson] = useState(false);

  // Task State
  const [tasks, setTasks] = useState([]);
  const [tasksLoading, setTasksLoading] = useState(false);
  const [taskAssignedUsers, setTaskAssignedUsers] = useState({});
  // Task Assignment Dialog State
  const [showTaskDialog, setShowTaskDialog] = useState(false);
  const [taskForDialog, setTaskForDialog] = useState(null);
  const [taskAssignments, setTaskAssignments] = useState([]);
  const [taskAssignLoading, setTaskAssignLoading] = useState(false);
  const [assignTaskUserId, setAssignTaskUserId] = useState("");
  const [taskAssignmentsByTask, setTaskAssignmentsByTask] = useState({}); // { [taskId]: [assignments] }

  const [showTaskEditModal, setShowTaskEditModal] = useState(false);
  const [editingTaskId, setEditingTaskId] = useState(null);

  const [collapsedStages, setCollapsedStages] = useState({});

  // Add this near other state declarations
  const [taskStatusMap, setTaskStatusMap] = useState({});
  const [taskStatusesLoading, setTaskStatusesLoading] = useState(false);

  const toggleStage = (stageId) => {
    setCollapsedStages((prev) => ({
      ...prev,
      [stageId]: !prev[stageId],
    }));
  };

  // Add near other state declarations
  const [taskBuildingBlocks, setTaskBuildingBlocks] = useState({}); // { [taskId]: { buildingBlockId, buildingBlockName } }
  const [taskBuildingBlocksLoading, setTaskBuildingBlocksLoading] =
    useState(false);

  // Board Tab State
  const [boardGroupBy, setBoardGroupBy] = useState("status");

  // Add near other state declarations
  const [showTaskOptions, setShowTaskOptions] = useState(false);
  const [showExcelUploadModal, setShowExcelUploadModal] = useState(false);
  const [excelFile, setExcelFile] = useState(null);
  const [uploadingExcel, setUploadingExcel] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredStageTasks, setFilteredStageTasks] = useState({});

  const [ganttTasks, setGanttTasks] = useState([]);
  const [viewMode, setViewMode] = useState(ViewMode.Week);

  // Gantt Controls
  const [columnWidth, setColumnWidth] = useState(65);
  const [timePeriod, setTimePeriod] = useState("Day");
  const [ganttLoading, setGanttLoading] = useState(false);

  const scrollToToday = () => {
    const today = new Date();
    const ganttElement = document.querySelector(".gantt-container");

    if (!ganttElement) return;

    // Calculate approximate scroll position
    const daysFromStart =
      (today - finalGanttTasks[0]?.start) / (1000 * 60 * 60 * 24);

    ganttElement.scrollLeft = daysFromStart * columnWidth;
  };

  // 🔍 Gantt Sorting & Filtering
  const [sortBy, setSortBy] = useState("startDate");
  const [showFilterPanel, setShowFilterPanel] = useState(false);

  const [filterStatus, setFilterStatus] = useState([]);
  const [filterPriority, setFilterPriority] = useState([]);
  const [filterAssignee, setFilterAssignee] = useState([]);
  const [filterStage, setFilterStage] = useState([]);

  const [showClosed, setShowClosed] = useState(false);

  // Manual work log states
  const [workLogUserId, setWorkLogUserId] = useState("");
  const [workValue, setWorkValue] = useState("");
  const [workUnit, setWorkUnit] = useState("HOUR");
  const [savingWorkLog, setSavingWorkLog] = useState(false);

  // ================= PROJECT REMARKS =================
  const [remarks, setRemarks] = useState([]);
  const [remarkText, setRemarkText] = useState("");
  const [remarksLoading, setRemarksLoading] = useState(false);
  const [addingRemark, setAddingRemark] = useState(false);

  // Task Logs (manual + updates)
  const [taskLogs, setTaskLogs] = useState([]);
  const [taskLogsLoading, setTaskLogsLoading] = useState(false);

  // Stage State
  const [stages, setStages] = useState([]);
  const [stagesLoading, setStagesLoading] = useState(false);
  // const [showStageModal, setShowStageModal] = useState(false);
  const [editingStage, setEditingStage] = useState(null);
  const [stageTasks, setStageTasks] = useState({});
  const [tasksLoadingByStage, setTasksLoadingByStage] = useState({});

  const [showStageModal, setShowStageModal] = useState(false);
  const [selectedStage, setSelectedStage] = useState(null);

  // Ticket State
  const [tickets, setTickets] = useState([]);
  const [ticketsLoading, setTicketsLoading] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [priorityFilter, setPriorityFilter] = useState("");

  // Ticket quick dialog + assignments
  const [showTicketDialog, setShowTicketDialog] = useState(false);
  const [ticketForDialog, setTicketForDialog] = useState(null);
  const [assignmentsByTicket, setAssignmentsByTicket] = useState({}); // { [ticketId]: [...] }
  const [assignmentsLoading, setAssignmentsLoading] = useState(false);
  const [assignLoading, setAssignLoading] = useState(false);
  const [assignUserId, setAssignUserId] = useState(""); // selected team member userId
  const [ticketNameMap, setTicketNameMap] = useState({});

  // Ticket work log states
  const [ticketWorkUserId, setTicketWorkUserId] = useState("");
  const [ticketWorkValue, setTicketWorkValue] = useState("");
  const [ticketWorkUnit, setTicketWorkUnit] = useState("HOURS");
  const [savingTicketWorkLog, setSavingTicketWorkLog] = useState(false);

  // Ticket logs
  const [ticketLogs, setTicketLogs] = useState([]);
  const [ticketLogsLoading, setTicketLogsLoading] = useState(false);

  // Template State
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [eventNameMap, setEventNameMap] = useState({});

  // Partner State
  const [partners, setPartners] = useState([]);
  const [partnersLoading, setPartnersLoading] = useState(false);
  const [showPartnerModal, setShowPartnerModal] = useState(false);
  const [editingPartner, setEditingPartner] = useState(null);
  const [vendorMap, setVendorMap] = useState({});
  // { SUP0000003: [ {contactPerName, contactPerEmail...} ] }
  const [vendorContactsMap, setVendorContactsMap] = useState({});
  const [loadingVendorContacts, setLoadingVendorContacts] = useState({});

  // Commercial State
  const [commercials, setCommercials] = useState([]);
  const [commercialsLoading, setCommercialsLoading] = useState(false);
  const [showCommercialModal, setShowCommercialModal] = useState(false);
  const [editingCommercial, setEditingCommercial] = useState(null);

  // Milestone State
  const [milestones, setMilestones] = useState([]);
  const [milestonesLoading, setMilestonesLoading] = useState(false);
  const [showMilestoneModal, setShowMilestoneModal] = useState(false);
  const [editingMilestone, setEditingMilestone] = useState(null);
  const [milestoneTasks, setMilestoneTasks] = useState({});

  // Resource Allocation State
  const [resources, setResources] = useState([]);
  const [resourcesLoading, setResourcesLoading] = useState(false);
  const [showResourceModal, setShowResourceModal] = useState(false);
  const [editingResource, setEditingResource] = useState(null);
  const [resourceDetails, setResourceDetails] = useState({});
  const [loadingResourceDetails, setLoadingResourceDetails] = useState({});

  // Document State
  const [documents, setDocuments] = useState([]);
  const [documentsLoading, setDocumentsLoading] = useState(false);
  const [uploadingDocuments, setUploadingDocuments] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [documentTitle, setDocumentTitle] = useState("");
  const [documentType, setDocumentType] = useState("");

  // Building Block State
  const [buildingBlocks, setBuildingBlocks] = useState([]);
  const [blocksLoading, setBlocksLoading] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showTaskMapModal, setShowTaskMapModal] = useState(false);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [projectTasksForMapping, setProjectTasksForMapping] = useState([]);
  const [selectedTaskIds, setSelectedTaskIds] = useState([]);
  const [mappingLoading, setMappingLoading] = useState(false);
  const [blockSummaries, setBlockSummaries] = useState({});
  const [showBlockTasksModal, setShowBlockTasksModal] = useState(false);
  const [blockTasks, setBlockTasks] = useState([]);
  const [isEditingBlock, setIsEditingBlock] = useState(false);
  const [editingBlockId, setEditingBlockId] = useState(null);
  const [blockViewType, setBlockViewType] = useState("TASK");
  const [summaryLoading, setSummaryLoading] = useState(false);

  const [allBlocks, setAllBlocks] = useState([]);
  const [ticketBlocks, setTicketBlocks] = useState([]);
  const [selectedBlockId, setSelectedBlockId] = useState("");
  const [blockMappingLoading, setBlockMappingLoading] = useState(false);

  const today = new Date();

  const styledTasks = ganttTasks.map((task) => {
    if (task.type !== "project" && task.end < today && task.progress < 100) {
      return {
        ...task,
        styles: {
          progressColor: "#ff4d4f",
          progressSelectedColor: "#ff4d4f",
        },
      };
    }
    return task;
  });

  // const handleTaskChange = async (task) => {
  //   try {
  //     await updateTask(task.id, {
  //       taskStartDate: task.start,
  //       taskEndDate: task.end,
  //     });

  //     toast.success("Task updated");
  //   } catch (error) {
  //     toast.error("Failed to update task");
  //   }
  // };

  const formatDateOnly = (date) => {
    if (!date) return null;
    return new Date(date).toISOString().split("T")[0];
  };

  const handleTaskChange = async (task) => {
    try {
      await updateTask(task.id, {
        TaskStartDate: moment(task.start).format("YYYY-MM-DD"),
        TaskEndDate: moment(task.end).format("YYYY-MM-DD"),
        EditedBy: String(userDetails?.userId),
      });

      toast.success("Task updated");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update task");
    }
  };

  const [blockForm, setBlockForm] = useState({
    orgId: "",
    buildingBlockName: "",
    buildingBlockStatus: "Not Started",
    buildingBlockDescription: "",
    buildingBlockProcessPoc: "",
    buildingBlockTechPoc: "",
    buildingBlockTypes: "",
    actualStartDate: "",
    actualEndDate: "",
  });

  // Available task fields configuration
  const availableFields = [
    {
      field: "taskName",
      displayName: "Task Name",
      type: "text",
      required: true,
    },
    {
      field: "taskDescription",
      displayName: "Task Description",
      type: "textarea",
      required: false,
    },
    {
      field: "assignedTo",
      displayName: "Assigned To",
      type: "select",
      required: false,
    },
    {
      field: "taskStartDate",
      displayName: "Planned Start Date",
      type: "date",
      required: false,
    },
    {
      field: "taskEndDate",
      displayName: "Planned End Date",
      type: "date",
      required: false,
    },
    {
      field: "actualStartDate",
      displayName: "Actual Start Date",
      type: "date",
      required: false,
    },
    {
      field: "actualEndDate",
      displayName: "Actual End Date",
      type: "date",
      required: false,
    },
    {
      field: "taskType",
      displayName: "Task Type",
      type: "select",
      required: false,
    },
    {
      field: "taskPriority",
      displayName: "Priority",
      type: "select",
      required: false,
    },
    {
      field: "taskStatus",
      displayName: "Status",
      type: "select",
      required: false,
    },
  ];

  // =========================================================================
  // GENERAL PROJECT DATA FUNCTIONS
  // =========================================================================

  // Load main project details
  const loadProjectDetails = async () => {
    try {
      const data = await fetchProjectDetails(projectId);
      console.log("Fetched project details:", data);
      setProject(data);
      setOriginalProject(data);
    } catch (error) {
      toast.error("Error loading project details");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // In the handleFieldChange function, check permissions
  const handleFieldChange = (field, value) => {
    if (!hasEditPermission()) {
      toast.error("You don't have permission to edit this project");
      return;
    }

    if (!isEditing) {
      setIsEditing(true);
    }
    setProject((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const loadTicketLogs = async (ticketId) => {
    if (!ticketId) return;

    try {
      setTicketLogsLoading(true);
      const logs = await getTicketLogsByTicketId(ticketId);

      // Sort latest first
      const sorted = [...logs].sort(
        (a, b) =>
          new Date(b.createdDate + " " + b.createdTime) -
          new Date(a.createdDate + " " + a.createdTime),
      );

      setTicketLogs(sorted);
    } catch (err) {
      console.error("Failed to load ticket logs", err);
      setTicketLogs([]);
    } finally {
      setTicketLogsLoading(false);
    }
  };

  // Save project changes
  const handleSave = async () => {
    if (!hasEditPermission()) {
      toast.error("You don't have permission to edit this project");
      return;
    }
    if (!project) return;

    setSaving(true);
    try {
      const updateData = {
        prTitle: project.prTitle,
        prDescription: project.prDescription,
        prTags: project.prTags,
        prStartDate: project.prStartDate,
        prEndDate: project.prEndDate,
        prClient: project.prClient,
        prTypes: project.prTypes,
        teamAssigned: project.teamId,
        projectStatus: project.projectStatus,
        projectCategory: project.projectCategory,
        comments: project.comments,
        salespersonCode: project.salespersonCode,
        currentProjectManager: project.currentProjectManager,
        usersId: project.usersId,
        revenue: project.revenue,
      };

      await updateProject(project.projectId, updateData);
      setOriginalProject(project);
      setIsEditing(false);
      toast.success("Project updated successfully");

      // Refresh the manager and salesperson names after update
      if (project.currentProjectManager) {
        fetchProjectManagerName(project.currentProjectManager);
      }
      if (project.salespersonCode) {
        fetchSalespersonName(project.salespersonCode);
      }
    } catch (error) {
      console.error("Error updating project:", error);
      toast.error("Failed to update project");
    } finally {
      setSaving(false);
    }
  };

  // Cancel editing
  // const handleCancel = () => {
  //   setProject(originalProject);
  //   setIsEditing(false);
  // };

  // Cancel editing
  const handleCancel = () => {
    if (!hasEditPermission()) return;

    setProject(originalProject);
    setIsEditing(false);
  };

  // Toggle favorite status
  const handleToggleFavorite = async () => {
    if (!project || !userId) return;

    const newFavoriteStatus = !project.isFavourite;

    try {
      // Optimistically update UI
      setProject((prev) => ({
        ...prev,
        isFavourite: newFavoriteStatus,
      }));

      // Call API
      await updateProjectFavourite(
        project.projectId,
        newFavoriteStatus,
        userId,
      );

      // Update original project state
      setOriginalProject((prev) => ({
        ...prev,
        isFavourite: newFavoriteStatus,
      }));

      toast.success(
        newFavoriteStatus
          ? "Project added to favorites!"
          : "Project removed from favorites!",
      );
    } catch (error) {
      // Revert on error
      setProject((prev) => ({
        ...prev,
        isFavourite: !newFavoriteStatus,
      }));

      console.error("Error updating favorite status:", error);
      toast.error("Failed to update favorite status");
    }
  };

  // =========================================================================
  // OVERVIEW TAB FUNCTIONS
  // =========================================================================

  // Load project statuses
  const loadProjectStatuses = async () => {
    setProjectStatusesLoading(true);
    try {
      const statusesData = await getAllProjectStatus();
      console.log("Loaded project statuses:", statusesData);
      setProjectStatuses(statusesData || []);
    } catch (error) {
      console.error("Error loading project statuses:", error);
      toast.error("Failed to load project statuses");
      setProjectStatuses([]);
    } finally {
      setProjectStatusesLoading(false);
    }
  };

  // Load project remarks
  const loadProjectRemarks = async () => {
    if (!projectId) return;

    try {
      setRemarksLoading(true);
      const data = await fetchProjectRemarks(projectId);
      console.log(data);
      setRemarks(Array.isArray(data) ? data : data?.data || []);
    } catch (error) {
      console.error("Error loading remarks:", error);
      toast.error("Failed to load remarks");
    } finally {
      setRemarksLoading(false);
    }
  };

  // Add new remark
  const handleAddRemark = async () => {
    if (!remarkText.trim()) {
      toast.error("Please enter a remark");
      return;
    }

    try {
      setAddingRemark(true);

      await addProjectRemark({
        projectId: projectId,
        remarks: remarkText,
        userId: String(userId),
      });

      toast.success("Remark added");

      setRemarkText("");
      loadProjectRemarks();
    } catch (error) {
      console.error(error);
      toast.error("Failed to add remark");
    } finally {
      setAddingRemark(false);
    }
  };

  // Load customers
  const loadCustomers = async () => {
    if (!orgId) return;

    setCustomersLoading(true);
    try {
      const customersData = await fetchCustomersByOrgId(orgId);
      console.log("Loaded customers:", customersData);
      setCustomers(customersData || []);
    } catch (error) {
      console.error("Error loading customers:", error);
      toast.error("Failed to load customers");
      setCustomers([]);
    } finally {
      setCustomersLoading(false);
    }
  };

  // Handle customer selection
  const handleCustomerChange = (customerCode) => {
    const selectedCustomer = customers.find(
      (cust) => cust.customerCode === customerCode,
    );
    if (selectedCustomer) {
      setSelectedCustomerName(selectedCustomer.name);
    }
    handleFieldChange("prClient", customerCode);
  };

  // Load teams
  const loadTeams = async () => {
    try {
      const teamsData = await getTeamsByOrg(orgId);
      console.log("Loaded teams:", teamsData);
      setTeams(teamsData);
    } catch (error) {
      console.error("Error loading teams:", error);
      toast.error("Failed to load teams");
    }
  };

  // Fetch project types
  const fetchProjectTypesList = async () => {
    if (!orgId) return;

    setProjectTypeLoading(true);
    try {
      const projectTypesData = await fetchProjectTypes(orgId);
      console.log("Loaded project types:", projectTypesData);
      setProjectTypes(projectTypesData || []);
    } catch (error) {
      console.error("Error loading project types:", error);
      toast.error("Failed to load project types");
      setProjectTypes([]);
    } finally {
      setProjectTypeLoading(false);
    }
  };

  // Fetch project type description
  const fetchProjectTypeDescription = async (projectTypeId) => {
    if (!projectTypeId) {
      setProjectTypeDesc("");
      return;
    }

    try {
      const response = await fetchProjectTypeById(projectTypeId);
      console.log("Project Type details:", response);
      setProjectTypeDesc(response.projectTypeDesc || projectTypeId);
    } catch (error) {
      console.error("Error fetching project type description:", error);
      setProjectTypeDesc(projectTypeId);
    }
  };

  // Fetch project manager name
  const fetchProjectManagerName = async (managerCode) => {
    if (!managerCode) {
      setProjectManagerName("Not assigned");
      return;
    }

    setLoadingManager(true);
    try {
      const response = await fetchResourceById(managerCode);
      console.log("Project Manager details:", response);
      setProjectManagerName(response.name || managerCode);
    } catch (error) {
      console.error("Error fetching project manager details:", error);
      setProjectManagerName(managerCode);
    } finally {
      setLoadingManager(false);
    }
  };

  // Fetch salesperson name
  const fetchSalespersonName = async (salespersonCode) => {
    if (!salespersonCode) {
      setSalespersonName("Not assigned");
      return;
    }

    setLoadingSalesperson(true);
    try {
      const response = await fetchResourceById(salespersonCode);
      console.log("Salesperson details:", response);
      setSalespersonName(response.name || salespersonCode);
    } catch (error) {
      console.error("Error fetching salesperson details:", error);
      setSalespersonName(salespersonCode);
    } finally {
      setLoadingSalesperson(false);
    }
  };

  // Load resources by organization
  const loadResourcesByOrg = async () => {
    if (!orgId) return;

    setResourcesByOrgLoading(true);
    try {
      const resourcesData = await fetchResourceByOrgId(orgId);
      console.log("Loaded resources by org:", resourcesData);
      setResourcesByOrg(resourcesData || []);
    } catch (error) {
      console.error("Error loading resources by org:", error);
      toast.error("Failed to load resources");
      setResourcesByOrg([]);
    } finally {
      setResourcesByOrgLoading(false);
    }
  };

  // =========================================================================
  // TASKS TAB FUNCTIONS
  // =========================================================================

  // Load project tasks

  // In the loadProjectTasksByStages function, modify it to handle tasks without stages:

  // const loadProjectTasksByStages = async () => {
  //   if (!project?.projectId) {
  //     setTasksLoading(false);
  //     return;
  //   }

  //   setTasksLoading(true);
  //   try {
  //     let allTasksData;

  //     // Check user roles to determine which tasks to load
  //     if (hasViewPermission()) {
  //       // Users with admin, manager, or commercial roles can view all tasks
  //       allTasksData = await getTasksByProject(project.projectId);
  //       console.log("All project tasks (full access):", allTasksData);
  //     } else {
  //       // Regular users only see tasks assigned to them
  //       allTasksData = await getTaskListByAssignedUser(userId);
  //       console.log(`Tasks assigned to user ${userId}:`, allTasksData);
  //     }

  //     // If no stages exist, just set tasks without stage grouping
  //     if (!stages || stages.length === 0) {
  //       setStageTasks({ "no-stage": allTasksData || [] });
  //       setFilteredStageTasks({ "no-stage": allTasksData || [] });

  //       // Fetch user details for assigned tasks
  //       if (allTasksData && allTasksData.length > 0) {
  //         await fetchTaskAssignedUsers(allTasksData);
  //         await loadAllTaskAssignments(allTasksData);
  //       }

  //       setTasksLoadingByStage({ "no-stage": false });
  //       return;
  //     }

  //     const tasksByStage = {};
  //     const loadingStates = {};

  //     // Initialize loading states for each stage + "No Stage"
  //     stages.forEach((stage) => {
  //       loadingStates[stage.stageId] = true;
  //     });
  //     loadingStates["no-stage"] = true;

  //     setTasksLoadingByStage(loadingStates);

  //     // Separate tasks by stage
  //     const tasksWithoutStage = [];

  //     (allTasksData || []).forEach((task) => {
  //       if (task.stageBelong) {
  //         const stageId = task.stageBelong;
  //         if (!tasksByStage[stageId]) {
  //           tasksByStage[stageId] = [];
  //         }
  //         tasksByStage[stageId].push(task);
  //       } else {
  //         tasksWithoutStage.push(task);
  //       }
  //     });

  //     // Add tasks without stage to the tasksByStage object
  //     if (tasksWithoutStage.length > 0) {
  //       tasksByStage["no-stage"] = tasksWithoutStage;
  //     }

  //     // Update loading states
  //     const updatedLoadingStates = { ...loadingStates };
  //     Object.keys(tasksByStage).forEach((stageId) => {
  //       updatedLoadingStates[stageId] = false;
  //     });
  //     setTasksLoadingByStage(updatedLoadingStates);

  //     // Fetch user details and assignments
  //     if (allTasksData && allTasksData.length > 0) {
  //       await fetchTaskAssignedUsers(allTasksData);
  //       await loadAllTaskAssignments(allTasksData);
  //     }

  //     setStageTasks(tasksByStage);
  //     setFilteredStageTasks(tasksByStage); // Initialize filtered tasks
  //   } catch (error) {
  //     console.error("Error loading project tasks by stages:", error);
  //     toast.error("Failed to load project tasks");
  //     setStageTasks({});
  //     setFilteredStageTasks({});
  //   } finally {
  //     setTasksLoading(false);
  //   }
  // };

  // Add this function near other load functions
  const loadTaskBuildingBlocks = async (tasks) => {
    if (!tasks || tasks.length === 0) return;

    try {
      setTaskBuildingBlocksLoading(true);
      const blocksMap = {};

      // Get all building blocks for this project
      const allBlocks = await getBuildingBlocksByOrgAndProject(
        String(orgId),
        String(project.projectId),
      );

      // For each block, get its tasks and create a mapping
      for (const block of allBlocks) {
        const blockTasks = await getTasksByBuildingBlock(block.buildingBlockId);

        // Map each task to its building block
        blockTasks.forEach((task) => {
          if (!blocksMap[task.taskId]) {
            blocksMap[task.taskId] = {
              buildingBlockId: block.buildingBlockId,
              buildingBlockName: block.buildingBlockName,
            };
          }
        });
      }

      setTaskBuildingBlocks(blocksMap);
    } catch (error) {
      console.error("Error loading task building blocks:", error);
    } finally {
      setTaskBuildingBlocksLoading(false);
    }
  };

  const loadProjectTasksByStages = async () => {
    if (!project?.projectId) {
      setTasksLoading(false);
      return;
    }

    setTasksLoading(true);
    try {
      let allTasksData;

      // Check user roles to determine which tasks to load
      if (hasViewPermission()) {
        // Users with admin, manager, or commercial roles can view all tasks
        allTasksData = await getTasksByProject(project.projectId);
        console.log("All project tasks (full access):", allTasksData);
      } else {
        // Regular users only see tasks assigned to them
        allTasksData = await getTaskListByAssignedUser(userId);
        console.log(`Tasks assigned to user ${userId}:`, allTasksData);
      }

      // Load building block mappings for tasks
      if (allTasksData && allTasksData.length > 0) {
        await loadTaskBuildingBlocks(allTasksData);
      }

      // If no stages exist, just set tasks without stage grouping
      if (!stages || stages.length === 0) {
        setStageTasks({ "no-stage": allTasksData || [] });
        setFilteredStageTasks({ "no-stage": allTasksData || [] });

        // Fetch user details for assigned tasks
        if (allTasksData && allTasksData.length > 0) {
          await fetchTaskAssignedUsers(allTasksData);
          await loadAllTaskAssignments(allTasksData);
        }

        setTasksLoadingByStage({ "no-stage": false });
        return;
      }

      const tasksByStage = {};
      const loadingStates = {};

      // Initialize loading states for each stage + "No Stage"
      stages.forEach((stage) => {
        loadingStates[stage.stageId] = true;
      });
      loadingStates["no-stage"] = true;

      setTasksLoadingByStage(loadingStates);

      // Separate tasks by stage
      const tasksWithoutStage = [];

      (allTasksData || []).forEach((task) => {
        if (task.stageBelong) {
          const stageId = task.stageBelong;
          if (!tasksByStage[stageId]) {
            tasksByStage[stageId] = [];
          }
          tasksByStage[stageId].push(task);
        } else {
          tasksWithoutStage.push(task);
        }
      });

      // Add tasks without stage to the tasksByStage object
      if (tasksWithoutStage.length > 0) {
        tasksByStage["no-stage"] = tasksWithoutStage;
      }

      // Update loading states
      const updatedLoadingStates = { ...loadingStates };
      Object.keys(tasksByStage).forEach((stageId) => {
        updatedLoadingStates[stageId] = false;
      });
      setTasksLoadingByStage(updatedLoadingStates);

      // Fetch user details and assignments
      if (allTasksData && allTasksData.length > 0) {
        await fetchTaskAssignedUsers(allTasksData);
        await loadAllTaskAssignments(allTasksData);
      }

      setStageTasks(tasksByStage);
      setFilteredStageTasks(tasksByStage); // Initialize filtered tasks
    } catch (error) {
      console.error("Error loading project tasks by stages:", error);
      toast.error("Failed to load project tasks");
      setStageTasks({});
      setFilteredStageTasks({});
    } finally {
      setTasksLoading(false);
    }
  };

  // Fetch user details for assigned tasks
  const fetchTaskAssignedUsers = async (tasks) => {
    const assignedUserIds = tasks
      .map((task) => task.assignedTo)
      .filter((userId) => userId && userId !== "")
      .map((id) => parseInt(id))
      .filter((id) => !isNaN(id));

    if (assignedUserIds.length === 0) return;

    try {
      const response = await getUsersByIds(assignedUserIds);
      if (response && response.users) {
        const usersMap = {};
        response.users.forEach((user) => {
          usersMap[user.userId] = user.username;
        });
        setTaskAssignedUsers(usersMap);
      }
    } catch (error) {
      console.error("Error fetching task assigned users:", error);
    }
  };

  // Task edit modal handlers
  const handleEditTask = (taskId) => {
    setSelectedTaskId(taskId);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedTaskId(null);
    setSelectedTask(null);
  };

  const handleTaskUpdated = () => {
    loadProjectTasks();
  };

  // Handle task name clicks
  const handleTaskNameClick = (taskId) => {
    setSelectedTaskId(taskId);
    setShowTaskSidebar(true);
  };

  const loadEventName = async (eventCode) => {
    if (!eventCode) return;

    // prevent duplicate API calls
    if (eventNameMap[eventCode]) return;

    try {
      const event = await fetchEventByCode(orgId, eventCode);

      setEventNameMap((prev) => ({
        ...prev,
        [eventCode]: event?.eventName || eventCode,
      }));
    } catch (err) {
      console.error("Failed to fetch event", eventCode, err);

      setEventNameMap((prev) => ({
        ...prev,
        [eventCode]: eventCode,
      }));
    }
  };

  // ======================= TASK ASSIGNMENT FUNCTIONS =======================

  // Load assignments for all tasks in the table
  const loadAllTaskAssignments = async (tasks) => {
    if (!tasks || tasks.length === 0) return;

    try {
      const assignmentsMap = {};

      // Fetch assignments for each task
      for (const task of tasks) {
        try {
          const assignments = await getTaskAssignmentsByTaskId(task.taskId);
          assignmentsMap[task.taskId] = assignments || [];
        } catch (error) {
          console.error(
            `Error loading assignments for task ${task.taskId}:`,
            error,
          );
          assignmentsMap[task.taskId] = [];
        }
      }

      setTaskAssignmentsByTask(assignmentsMap);
    } catch (error) {
      console.error("Error loading task assignments:", error);
    }
  };

  // Add this function near other load functions
  const loadAllTaskStatuses = async () => {
    try {
      setTaskStatusesLoading(true);
      const statuses = await getAllTaskStatus();
      console.log("Loaded statuses:", statuses); // Add this

      // Create a mapping from statusGuid to statusName
      const statusMap = {};
      statuses.forEach((status) => {
        console.log(`Mapping ${status.statusGuid} -> ${status.statusName}`); // Add this

        statusMap[status.statusGuid.toLowerCase()] = status.statusName;
      });

      setTaskStatusMap(statusMap);
    } catch (error) {
      console.error("Error loading task statuses:", error);
      toast.error("Failed to load task statuses");
    } finally {
      setTaskStatusesLoading(false);
    }
  };

  // Add this helper function
  const getTaskStatusName = (statusGuid) => {
    if (!statusGuid) return "No Status";

    // Convert to lowercase for case-insensitive comparison
    const lowerGuid = statusGuid.toLowerCase();

    // Return the mapped name or show "Loading..." if still loading
    if (taskStatusesLoading) return "Loading...";

    return taskStatusMap[lowerGuid] || statusGuid; // Fallback to GUID if not found
  };

  // Load assignments for a specific task
  const loadTaskAssignmentsForTask = async (taskId) => {
    try {
      const assignments = await getTaskAssignmentsByTaskId(taskId);
      setTaskAssignmentsByTask((prev) => ({
        ...prev,
        [taskId]: assignments || [],
      }));
      return assignments || [];
    } catch (error) {
      console.error(`Error loading assignments for task ${taskId}:`, error);
      setTaskAssignmentsByTask((prev) => ({
        ...prev,
        [taskId]: [],
      }));
      return [];
    }
  };

  // Update the loadProjectTasks function to also load assignments:
  const loadProjectTasks = async () => {
    if (!project?.projectId) return;

    setTasksLoading(true);
    try {
      const tasksData = await getTasksByProject(project.projectId);
      console.log("Loaded tasks:", tasksData);
      setTasks(tasksData);

      // Load assignments for all tasks
      await loadAllTaskAssignments(tasksData);

      // Fetch user details for assigned tasks (keep this for fallback)
      await fetchTaskAssignedUsers(tasksData);
    } catch (error) {
      console.error("Error loading tasks:", error);
      toast.error("Failed to load project tasks");
    } finally {
      setTasksLoading(false);
    }
  };

  // Helper function to get active assignments for a task
  const getActiveAssignmentsForTask = (taskId) => {
    const assignments = taskAssignmentsByTask[taskId] || [];
    return assignments.filter(
      (assign) => assign.isActive === true || assign.isActive === 1,
    );
  };

  // Helper function to get all assigned users for a task (including historical)
  const getAllAssignedUsersForTask = (taskId) => {
    const assignments = taskAssignmentsByTask[taskId] || [];
    return assignments.map((assign) => assign.assignedUserId);
  };

  // Helper function to get current assigned users (active or most recent)
  const getCurrentAssignedUsersForTask = (taskId) => {
    const assignments = taskAssignmentsByTask[taskId] || [];

    // First, get active assignments
    const activeAssignments = assignments.filter(
      (assign) => assign.isActive === true || assign.isActive === 1,
    );

    if (activeAssignments.length > 0) {
      return activeAssignments;
    }

    // If no active assignments, get the most recent completed assignment
    if (assignments.length > 0) {
      const sorted = [...assignments].sort(
        (a, b) =>
          new Date(b.endTime || b.startTime) -
          new Date(a.endTime || a.startTime),
      );
      return [sorted[0]];
    }

    return [];
  };

  // Add this helper function
  const getUsernameFromId = (userId) => {
    if (!userId) return "Unknown";

    // Try to find in teamMemberDetails first
    const userDetail = teamMemberDetails.find(
      (user) => String(user.userId) === String(userId),
    );

    if (userDetail) return userDetail.username;

    // Fallback to taskAssignedUsers
    const mappedUser = taskAssignedUsers[parseInt(userId)];
    if (mappedUser) return mappedUser;

    return userId; // Return ID if no name found
  };

  // Refresh task assignments
  // Refresh task assignments with cache busting
  const refreshTaskAssignments = async (taskId) => {
    try {
      setTaskAssignLoading(true);
      const data = await getTaskAssignmentsByTaskId(taskId);

      // Update both the dialog state and the main assignments map
      setTaskAssignments(data || []);
      setTaskAssignmentsByTask((prev) => ({
        ...prev,
        [taskId]: data || [],
      }));

      return data || [];
    } catch (err) {
      console.error("Error loading task assignments:", err);
      toast.error("Failed to load task assignments");
      return [];
    } finally {
      setTaskAssignLoading(false);
    }
  };

  const loadTaskLogs = async (taskId) => {
    try {
      setTaskLogsLoading(true);
      const logs = await getTaskLogsByTaskId(taskId);
      setTaskLogs(logs || []);
    } catch (err) {
      console.error("Failed to load task logs:", err);
      toast.error("Failed to load task logs");
      setTaskLogs([]);
    } finally {
      setTaskLogsLoading(false);
    }
  };

  const openTaskDialog = async (task) => {
    setTaskAssignments([]);
    setTaskLogs([]); // ✅ reset logs
    setTaskForDialog(task);
    setShowTaskDialog(true);
    setAssignTaskUserId("");

    // Load assignments
    const freshAssignments = await loadTaskAssignmentsForTask(task.taskId);
    setTaskAssignments(freshAssignments);

    // 🔥 Load task logs
    await loadTaskLogs(task.taskId);
  };

  // Also update the closeTaskDialog to reset assignments
  const closeTaskDialog = () => {
    setShowTaskDialog(false);
    setTaskForDialog(null);
    setTaskAssignments([]); // Clear assignments when closing
    setAssignTaskUserId("");
  };

  // Get active assignment for user on this task
  const getActiveAssignmentForTaskUser = (taskId, userId) => {
    const list = taskAssignments || [];
    return list.find(
      (x) =>
        String(x.assignedUserId) === String(userId) &&
        (x.isActive === true || x.isActive === 1),
    );
  };

  const isNotStarted = (a) => !a.startTime && !a.endTime;
  const isActive = (a) => a.isActive === true && !!a.startTime;
  const isPaused = (a) => a.isPaused === true;

  // Handle assign/start
  const handleAssignAndStartTask = async () => {
    if (!taskForDialog?.taskId) {
      toast.error("No task selected");
      return;
    }
    if (!assignTaskUserId) {
      toast.error("Please select a team member");
      return;
    }

    const active = getActiveAssignmentForTaskUser(
      taskForDialog.taskId,
      assignTaskUserId,
    );
    if (active) {
      toast.info("This user already has an active session on this task");
      return;
    }

    try {
      setTaskAssignLoading(true);
      await startTaskWork(taskForDialog.taskId, assignTaskUserId, orgId);
      toast.success("Task work session started");
      await refreshTaskAssignments(taskForDialog.taskId);
      setAssignTaskUserId("");
    } catch (err) {
      console.error("Start work failed:", err);
      toast.error(
        err?.response?.data || err?.message || "Failed to start work",
      );
    } finally {
      setTaskAssignLoading(false);
    }
  };

  const handleAssignUserOnly = async () => {
    if (!taskForDialog?.taskId || !assignTaskUserId) {
      toast.error("Please select a team member");
      return;
    }

    try {
      setTaskAssignLoading(true);

      await updateTask(taskForDialog.taskId, {
        assignedTo: assignTaskUserId,
        CreatedBy: String(userId),
        EditedBy: String(userId),
      });

      toast.success("User assigned to task");

      // 🔄 Assignment already created by backend
      await refreshTaskAssignments(taskForDialog.taskId);

      setAssignTaskUserId("");
    } catch {
      toast.error("Failed to assign user");
    } finally {
      setTaskAssignLoading(false);
    }
  };

  const hasAnyAssignment = (taskId, userId) => {
    return (taskAssignmentsByTask[taskId] || []).some(
      (a) => String(a.assignedUserId) === String(userId),
    );
  };

  // Stop work
  const handleStopTaskWork = async (assignmentId) => {
    if (!assignmentId) return;
    try {
      await stopTaskWork(assignmentId);
      toast.success("Stopped task work session");
      await refreshTaskAssignments(taskForDialog?.taskId);
    } catch (err) {
      console.error("Stop work failed:", err);
      toast.error(err?.response?.data || err?.message || "Failed to stop work");
    }
  };

  // 🔎 Search by Stage Name + Task Name
  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredStageTasks(stageTasks);
      return;
    }

    const lowerQuery = searchQuery.toLowerCase();
    const filtered = {};

    Object.keys(stageTasks).forEach((stageId) => {
      const stage = stages.find((s) => s.stageId === stageId);
      const stageNameMatch = stage?.stageName
        ?.toLowerCase()
        .includes(lowerQuery);

      // Filter tasks by task name
      const matchingTasks = stageTasks[stageId].filter((task) =>
        task.taskName?.toLowerCase().includes(lowerQuery),
      );

      // If stage name matches → show ALL tasks of that stage
      if (stageNameMatch) {
        filtered[stageId] = stageTasks[stageId];
      }
      // If only some tasks match → show only matching tasks
      else if (matchingTasks.length > 0) {
        filtered[stageId] = matchingTasks;
      }
    });

    setFilteredStageTasks(filtered);
  }, [searchQuery, stageTasks, stages]);

  const handleSaveWorkLog = async () => {
    if (!taskForDialog?.taskId) {
      toast.error("No task selected");
      return;
    }

    if (!workLogUserId || !workValue) {
      toast.error("Please select user and work value");
      return;
    }

    try {
      setSavingWorkLog(true);

      const payload = {
        taskId: taskForDialog.taskId,
        projectId: project.projectId, // ✅ NEW
        orgId: String(orgId),
        assignedUserId: workLogUserId,
        workValue: parseFloat(workValue),
        workUnit,
        logType: "WORK_LOG",
        logDescription: `Manual work log: ${workValue} ${workUnit}`,
        createdBy: String(userId),
      };

      console.log("Creating work log with payload:", payload);

      await createTaskWorkLog(payload);

      toast.success("Work log added");

      // refresh logs immediately
      await loadTaskLogs(taskForDialog.taskId);

      // reset
      setWorkLogUserId("");
      setWorkValue("");
      setWorkUnit("HOUR");

      // OPTIONAL: refresh task logs / history later
    } catch (err) {
      console.error(err);
      toast.error("Failed to add work log");
    } finally {
      setSavingWorkLog(false);
    }
  };

  const handleSelect = (task, isSelected) => {
    if (!task || task.type !== "project") return;

    // Only toggle when row is actively clicked (not deselected)
    if (!isSelected) return;

    const stageId = task.id.replace("stage-", "");

    setCollapsedStages((prev) => ({
      ...prev,
      [stageId]: !prev[stageId],
    }));
  };

  const handleTimePeriodChange = (value) => {
    setTimePeriod(value);

    switch (value) {
      case "Day":
        setViewMode(ViewMode.Day);
        setColumnWidth(65);
        break;

      case "Week":
        setViewMode(ViewMode.Week);
        setColumnWidth(85);
        break;

      case "Month":
        setViewMode(ViewMode.Month);
        setColumnWidth(300);
        break;

      case "Quarter":
        setViewMode(ViewMode.Month);
        setColumnWidth(500); // Larger month width
        break;

      case "Year":
        setViewMode(ViewMode.Year);
        setColumnWidth(350);
        break;

      case "Flexible":
        setViewMode(ViewMode.Month);
        setColumnWidth(200);
        break;

      default:
        break;
    }
  };

  const handleAutoFit = () => {
    if (!finalGanttTasks.length) return;

    const taskOnly = finalGanttTasks.filter((t) => t.type !== "project");

    const minDate = new Date(
      Math.min(...taskOnly.map((t) => new Date(t.start))),
    );

    const maxDate = new Date(Math.max(...taskOnly.map((t) => new Date(t.end))));

    const totalDays = (maxDate - minDate) / (1000 * 60 * 60 * 24);

    if (totalDays <= 14) {
      setViewMode(ViewMode.Day);
      setColumnWidth(65);
      setTimePeriod("Day");
    } else if (totalDays <= 90) {
      setViewMode(ViewMode.Week);
      setColumnWidth(85);
      setTimePeriod("Week");
    } else if (totalDays <= 365) {
      setViewMode(ViewMode.Month);
      setColumnWidth(300);
      setTimePeriod("Month");
    } else {
      setViewMode(ViewMode.Year);
      setColumnWidth(350);
      setTimePeriod("Year");
    }
  };

  const exportPNG = async () => {
    const element = document.getElementById("gantt-container");
    const canvas = await html2canvas(element);
    const link = document.createElement("a");
    link.download = "gantt.png";
    link.href = canvas.toDataURL();
    link.click();
  };

  const exportPDF = async () => {
    const element = document.getElementById("gantt-container");
    const canvas = await html2canvas(element);

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("landscape");
    pdf.addImage(imgData, "PNG", 10, 10, 280, 150);
    pdf.save("gantt.pdf");
  };

  const exportExcel = () => {
    const taskOnly = finalGanttTasks.filter((t) => t.type !== "project");

    const data = taskOnly.map((t) => ({
      Task: t.name,
      Start: moment(t.start).format("YYYY-MM-DD"),
      End: moment(t.end).format("YYYY-MM-DD"),
      Progress: t.progress,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Gantt");

    XLSX.writeFile(workbook, "gantt.xlsx");
  };

  const sortTasks = (tasks) => {
    const sorted = [...tasks];

    switch (sortBy) {
      case "startDate":
        return sorted.sort((a, b) => new Date(a.start) - new Date(b.start));

      case "endDate":
        return sorted.sort((a, b) => new Date(a.end) - new Date(b.end));

      case "status":
        return sorted.sort((a, b) =>
          (a.taskStatus || "").localeCompare(b.taskStatus || ""),
        );

      case "priority":
        return sorted.sort((a, b) =>
          (a.taskPriority || "").localeCompare(b.taskPriority || ""),
        );

      case "assignee":
        return sorted.sort((a, b) =>
          (a.assignedTo || "").localeCompare(b.assignedTo || ""),
        );

      case "duration":
        return sorted.sort(
          (a, b) =>
            new Date(a.end) -
            new Date(a.start) -
            (new Date(b.end) - new Date(b.start)),
        );

      default:
        return sorted;
    }
  };

  // 1️⃣ Separate stages and tasks
  const stageRows = ganttTasks.filter((t) => t.type === "project");
  const taskRows = ganttTasks.filter((t) => t.type !== "project");

  // 2️⃣ Apply filters
  let filteredTasks = taskRows.filter((task) => {
    if (!showClosed && task.progress === 100) return false;

    if (filterStatus.length && !filterStatus.includes(task.taskStatus))
      return false;

    if (filterPriority.length && !filterPriority.includes(task.taskPriority))
      return false;

    if (
      filterAssignee.length &&
      !filterAssignee.includes(String(task.assignedTo))
    )
      return false;

    return true;
  });

  // 3️⃣ Apply sorting
  filteredTasks = sortTasks(filteredTasks);

  // 4️⃣ Group by stage
  const tasksGroupedByStage = {};

  filteredTasks.forEach((task) => {
    const stageId = task.project;

    if (!tasksGroupedByStage[stageId]) {
      tasksGroupedByStage[stageId] = [];
    }

    tasksGroupedByStage[stageId].push(task);
  });

  const getGanttTaskStyleByStatus = (status) => {
    switch (status) {
      case "Not Started":
        return {
          backgroundColor: "#94a3b8", // Gray
          backgroundSelectedColor: "#64748b",
          progressColor: "#64748b",
          progressSelectedColor: "#64748b",
        };

      case "In Progress":
        return {
          backgroundColor: "#3b82f6", // Blue
          backgroundSelectedColor: "#2563eb",
          progressColor: "#1d4ed8",
          progressSelectedColor: "#1d4ed8",
        };

      case "On Hold":
        return {
          backgroundColor: "#f59e0b", // Orange
          backgroundSelectedColor: "#d97706",
          progressColor: "#b45309",
          progressSelectedColor: "#b45309",
        };

      case "Completed":
        return {
          backgroundColor: "#10b981", // Green
          backgroundSelectedColor: "#059669",
          progressColor: "#047857",
          progressSelectedColor: "#047857",
        };

      case "Cancelled":
        return {
          backgroundColor: "#ef4444", // Red
          backgroundSelectedColor: "#dc2626",
          progressColor: "#b91c1c",
          progressSelectedColor: "#b91c1c",
        };

      default:
        return {
          backgroundColor: "#6b7280", // Default gray
          backgroundSelectedColor: "#4b5563",
          progressColor: "#4b5563",
          progressSelectedColor: "#4b5563",
        };
    }
  };

  // 1️⃣ Build final tasks directly from filteredStageTasks
  let finalGanttTasks = [];

  // 1️⃣ Convert stages to array with tasks
  let stageArray = Object.keys(filteredStageTasks).map((stageId) => {
    const stage = stages.find((s) => s.stageId === stageId);

    const tasks = (filteredStageTasks[stageId] || []).filter((task) => {
      if (!showClosed && task.taskStatus === "Completed") return false;

      if (filterStatus.length && !filterStatus.includes(task.taskStatus))
        return false;

      if (filterPriority.length && !filterPriority.includes(task.taskPriority))
        return false;

      if (
        filterAssignee.length &&
        !filterAssignee.includes(String(task.assignedTo))
      )
        return false;

      return true;
    });

    return {
      stageId,
      stage,
      tasks,
    };
  });

  // 2️⃣ Stage Level Sorting
  if (sortBy === "stageStart") {
    stageArray.sort(
      (a, b) =>
        new Date(a.stage?.stageStartDateTime) -
        new Date(b.stage?.stageStartDateTime),
    );
  }

  if (sortBy === "stageEnd") {
    stageArray.sort(
      (a, b) =>
        new Date(a.stage?.stageEndDateTime) -
        new Date(b.stage?.stageEndDateTime),
    );
  }

  // 3️⃣ Task Level Sorting
  if (sortBy === "taskStart") {
    stageArray.forEach((stageObj) => {
      stageObj.tasks.sort(
        (a, b) => new Date(a.taskStartDate) - new Date(b.taskStartDate),
      );
    });

    // Move stage based on earliest task
    stageArray.sort(
      (a, b) =>
        new Date(a.tasks[0]?.taskStartDate) -
        new Date(b.tasks[0]?.taskStartDate),
    );
  }

  if (sortBy === "taskEnd") {
    stageArray.forEach((stageObj) => {
      stageObj.tasks.sort(
        (a, b) => new Date(a.taskEndDate) - new Date(b.taskEndDate),
      );
    });

    // Move stage based on latest task
    stageArray.sort(
      (a, b) =>
        new Date(a.tasks[a.tasks.length - 1]?.taskEndDate) -
        new Date(b.tasks[b.tasks.length - 1]?.taskEndDate),
    );
  }

  // 4️⃣ Build final gantt structure
  stageArray.forEach(({ stageId, stage, tasks }) => {
    if (!stage || tasks.length === 0) return;

    finalGanttTasks.push({
      id: `stage-${stageId}`,
      name: stage.stageName,
      type: "project",
      start: new Date(stage.stageStartDateTime),
      end: new Date(stage.stageEndDateTime),
      progress: 0,
      hideChildren: collapsedStages[stageId] || false,
    });

    if (!collapsedStages[stageId]) {
      tasks.forEach((task) => {
        finalGanttTasks.push({
          id: task.taskId,
          name: task.taskName,
          start: new Date(task.taskStartDate),
          end: new Date(task.taskEndDate),
          progress: task.taskStatus === "Completed" ? 100 : 50,
          project: `stage-${stageId}`,
          taskStatus: task.taskStatus,
          taskPriority: task.taskPriority,
          assignedTo: String(task.assignedTo),
          styles: getGanttTaskStyleByStatus(task.taskStatus),
        });
      });
    }
  });

  const handleResetFilters = () => {
    setFilterStatus([]);
    setFilterPriority([]);
    setFilterAssignee([]);
    setFilterStage([]);
    setShowClosed(false);
    setSortBy("startDate");

    toast.info("Filters reset");
  };

  // =========================================================================
  // BORAD FUNCTIONS
  // =========================================================================

  const getBoardColumns = () => {
    const allTasks = Object.values(filteredStageTasks).flat();
    const columns = {};

    // =========================
    // GROUP BY STATUS
    // =========================
    if (boardGroupBy === "status") {
      const statusList = [
        "Not Started",
        "In Progress",
        "On Hold",
        "Completed",
        "Cancelled",
        "No Status",
      ];

      statusList.forEach((status) => {
        columns[status] = [];
      });

      allTasks.forEach((task) => {
        const key = task.taskStatus || "No Status";
        if (columns[key]) {
          columns[key].push(task);
        }
      });
    }

    // =========================
    // GROUP BY PRIORITY
    // =========================
    if (boardGroupBy === "priority") {
      const priorityList = ["High", "Medium", "Low", "No Priority"];

      priorityList.forEach((priority) => {
        columns[priority] = [];
      });

      allTasks.forEach((task) => {
        const key = task.taskPriority || "No Priority";
        if (columns[key]) {
          columns[key].push(task);
        }
      });
    }

    // =========================
    // GROUP BY ASSIGNEE
    // =========================
    if (boardGroupBy === "assignee") {
      const assigneeList = [
        "Unassigned",
        ...teamMemberDetails.map((user) => user.username),
      ];

      assigneeList.forEach((name) => {
        columns[name] = [];
      });

      allTasks.forEach((task) => {
        const key = task.assignedTo
          ? getUsernameFromId(task.assignedTo)
          : "Unassigned";

        if (columns[key]) {
          columns[key].push(task);
        }
      });
    }

    // =========================
    // GROUP BY STAGE
    // =========================
    if (boardGroupBy === "stage") {
      stages.forEach((stage) => {
        columns[stage.stageName] = filteredStageTasks[stage.stageId] || [];
      });

      // Always show No Stage column
      columns["No Stage"] = filteredStageTasks["no-stage"] || [];
    }

    return columns;
  };

  // =========================================================================
  // Building Block FUNCTIONS
  // =========================================================================

  const handleBlockChange = (field, value) => {
    setBlockForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const loadBuildingBlocks = async () => {
    try {
      setSummaryLoading(true); // 🔥 START LOADER

      const data = await getBuildingBlocksByOrgAndProject(
        String(orgId),
        String(project.projectId),
      );

      setBuildingBlocks(data);

      const summaryMap = {};

      for (const block of data) {
        const summary = await getBlockSummary(
          block.buildingBlockId,
          blockViewType,
        );
        summaryMap[block.buildingBlockId] = summary;
      }

      setBlockSummaries(summaryMap);
    } catch (error) {
      toast.error("Failed to load building blocks");
    } finally {
      setSummaryLoading(false); // 🔥 STOP LOADER
    }
  };

  useEffect(() => {
    if (activeTab === "BuildingBlock" && orgId) {
      loadBuildingBlocks();
    }
  }, [activeTab, orgId]);

  useEffect(() => {
    if (activeTab === "BuildingBlock") {
      loadBuildingBlocks();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "BuildingBlock") {
      loadBuildingBlocks();
    }
  }, [blockViewType]);

  const handleSaveBlock = async () => {
    if (!blockForm.buildingBlockName.trim()) {
      toast.error("Please enter building block name");
      return;
    }

    try {
      const payload = {
        buildingBlockId: editingBlockId,
        buildingBlockName: blockForm.buildingBlockName,
        buildingBlockStatus: blockForm.buildingBlockStatus,
        buildingBlockDescription: blockForm.buildingBlockDescription,
        buildingBlockProject: String(project.projectId),
        buildingBlockProcessPoc: blockForm.buildingBlockProcessPoc,
        buildingBlockTechPoc: blockForm.buildingBlockTechPoc,
        buildingBlockTypes: blockForm.buildingBlockTypes,
        actualStartDate: blockForm.actualStartDate
          ? new Date(blockForm.actualStartDate).toISOString()
          : null,
        actualEndDate: blockForm.actualEndDate
          ? new Date(blockForm.actualEndDate).toISOString()
          : null,
        editedBy: String(userId),
      };

      if (isEditingBlock) {
        // 🔥 UPDATE
        await updateBuildingBlock(editingBlockId, payload);
        toast.success("Building Block updated successfully");
      } else {
        // CREATE
        await createBuildingBlock({
          ...payload,
          orgId: String(orgId),
          createdBy: String(userId),
        });
        toast.success("Building Block created successfully");
      }

      setShowBlockModal(false);
      setIsEditingBlock(false);
      setEditingBlockId(null);

      setBlockForm({
        buildingBlockName: "",
        buildingBlockStatus: "Not Started",
        buildingBlockDescription: "",
        buildingBlockProcessPoc: "",
        buildingBlockTechPoc: "",
        buildingBlockTypes: "",
        actualStartDate: "",
        actualEndDate: "",
      });

      loadBuildingBlocks();
    } catch (err) {
      console.error(err);
      toast.error("Failed to save building block");
    }
  };

  const resetBlockForm = () => {
    setBlockForm({
      buildingBlockName: "",
      buildingBlockStatus: "Not Started",
      buildingBlockDescription: "",
      buildingBlockProcessPoc: "",
      buildingBlockTechPoc: "",
      buildingBlockTypes: "",
      actualStartDate: "",
      actualEndDate: "",
    });

    setIsEditingBlock(false);
    setEditingBlockId(null);
  };

  const openMapModal = async (block) => {
    setSelectedBlock(block);
    setSelectedTaskIds([]);
    setShowTaskMapModal(true);

    try {
      if (blockViewType === "TASK") {
        const allTasks = await getTasksByProject(project.projectId);
        const mappedTasks = await getTasksByBuildingBlock(
          block.buildingBlockId,
        );

        const mappedIds = (mappedTasks || []).map((t) => t.taskId);

        const filtered = (allTasks || []).filter(
          (t) => !mappedIds.includes(t.taskId),
        );

        setProjectTasksForMapping(filtered);
      } else {
        const allTickets = await getTicketsByProjectId(project.projectId);
        const mappedTickets = await getTicketsByBuildingBlock(
          block.buildingBlockId,
        );

        const mappedIds = (mappedTickets || []).map((t) => t.ticketId);

        const filtered = (allTickets || []).filter(
          (t) => !mappedIds.includes(t.ticketId),
        );

        setProjectTasksForMapping(filtered);
      }
    } catch {
      toast.error("Failed to load data");
    }
  };

  const handleEditBlock = (block) => {
    setIsEditingBlock(true);
    setEditingBlockId(block.buildingBlockId);

    setBlockForm({
      buildingBlockName: block.buildingBlockName || "",
      buildingBlockStatus: block.buildingBlockStatus || "Not Started",
      buildingBlockDescription: block.buildingBlockDescription || "",
      buildingBlockProcessPoc: block.buildingBlockProcessPoc || "",
      buildingBlockTechPoc: block.buildingBlockTechPoc || "",
      buildingBlockTypes: block.buildingBlockTypes || "",
      actualStartDate: block.actualStartDate
        ? moment(block.actualStartDate).format("YYYY-MM-DD")
        : "",
      actualEndDate: block.actualEndDate
        ? moment(block.actualEndDate).format("YYYY-MM-DD")
        : "",
    });

    setShowBlockModal(true);
  };

  const handleTaskSelection = (taskId) => {
    setSelectedTaskIds((prev) =>
      prev.includes(taskId)
        ? prev.filter((id) => id !== taskId)
        : [...prev, taskId],
    );
  };

  const loadBlocksForTicket = async (ticketId) => {
    try {
      // 1️⃣ Get all blocks for this project
      const blocks = await getBuildingBlocksByOrgAndProject(
        String(orgId),
        String(project.projectId),
      );

      setAllBlocks(blocks || []);

      // 2️⃣ Get blocks already mapped to this ticket
      const mappedTickets = [];

      for (const block of blocks) {
        const tickets = await getTicketsByBuildingBlock(block.buildingBlockId);

        if ((tickets || []).some((t) => t.ticketId === ticketId)) {
          mappedTickets.push(block);
        }
      }

      setTicketBlocks(mappedTickets);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load building blocks");
    }
  };

  const BUILDING_BLOCK_STATUS_OPTIONS = [
    "Not Started",
    "In Progress",
    "On Hold",
    "Completed",
    "Cancelled",
  ];

  const handleRemoveItemFromBlock = async (itemId) => {
    if (!selectedBlock?.buildingBlockId) return;

    if (!window.confirm("Are you sure you want to remove this mapping?")) {
      return;
    }

    try {
      setMappingLoading(true);

      if (blockViewType === "TASK") {
        await removeSpecificTaskMapping(itemId, selectedBlock.buildingBlockId);
      } else {
        await removeTicketMapping(itemId, selectedBlock.buildingBlockId);
      }

      toast.success("Mapping removed successfully");

      // 🔄 Refresh block items modal
      await openBlockItemsModal(selectedBlock);

      // 🔄 Refresh summary table
      await loadBuildingBlocks();
    } catch (error) {
      console.error(error);
      toast.error("Failed to remove mapping");
    } finally {
      setMappingLoading(false);
    }
  };

  const availableBlocksForMapping = allBlocks.filter(
    (block) =>
      !ticketBlocks.some(
        (mapped) => mapped.buildingBlockId === block.buildingBlockId,
      ),
  );

  const handleRemoveBlockMapping = async (blockId) => {
    if (!ticketForDialog?.ticketId) return;

    try {
      setBlockMappingLoading(true);

      await removeTicketMapping(ticketForDialog.ticketId, blockId);

      toast.success("Building Block removed successfully");

      // Refresh ticket blocks
      await loadBlocksForTicket(ticketForDialog.ticketId);
    } catch (err) {
      console.error(err);
      toast.error("Failed to remove mapping");
    } finally {
      setBlockMappingLoading(false);
    }
  };

  const handleMapTasks = async () => {
    if (!selectedBlock || selectedTaskIds.length === 0) {
      toast.error("Please select at least one item");
      return;
    }

    try {
      setMappingLoading(true);

      for (const id of selectedTaskIds) {
        if (blockViewType === "TASK") {
          await mapTaskToBuildingBlock({
            buildingBlockId: selectedBlock.buildingBlockId,
            taskId: id,
            orgId: String(orgId),
            createdBy: String(userId),
          });
        } else {
          await mapTicketToBuildingBlock({
            buildingBlockId: selectedBlock.buildingBlockId,
            ticketId: id,
            orgId: String(orgId),
            createdBy: String(userId),
          });
        }
      }

      toast.success(`${blockViewType} mapped successfully`);
      setShowTaskMapModal(false);
      await loadBuildingBlocks();
    } catch {
      toast.error("Mapping failed");
    } finally {
      setMappingLoading(false);
    }
  };

  const openBlockItemsModal = async (block) => {
    try {
      if (blockViewType === "TASK") {
        const tasks = await getTasksByBuildingBlock(block.buildingBlockId);
        setBlockTasks(tasks);
      } else {
        const tickets = await getTicketsByBuildingBlock(block.buildingBlockId);
        setBlockTasks(tickets);
      }

      setSelectedBlock(block);
      setShowBlockTasksModal(true);
    } catch {
      toast.error("Failed to load data");
    }
  };

  // =========================================================================
  // EXCEL UPLOAD FUNCTIONS
  // =========================================================================

  // Handle task creation method selection
  const handleAddTaskClick = () => {
    setShowTaskOptions(true);
  };

  // Handle Excel upload method
  const handleExcelUploadClick = () => {
    setShowTaskOptions(false);
    setShowExcelUploadModal(true);
  };

  // Handle manual task creation
  const handleManualTaskClick = () => {
    setShowTaskOptions(false);
    navigate(`/addTask?projectId=${project.projectId}`);
  };

  // Handle Excel file selection
  // Update the handleExcelFileSelect function
  const handleExcelFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Check file size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      toast.error("File size must be less than 10MB");
      event.target.value = "";
      return;
    }

    // Get file extension
    const fileName = file.name.toLowerCase();
    const isExcel = fileName.endsWith(".xlsx") || fileName.endsWith(".xls");
    const isCSV = fileName.endsWith(".csv");

    if (!isExcel && !isCSV) {
      toast.error("Please select an Excel (.xlsx, .xls) or CSV file");
      event.target.value = "";
      return;
    }

    // If it's a CSV file, convert it to Excel format
    if (isCSV) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const csvContent = e.target.result;

          // Parse CSV
          const workbook = XLSX.read(csvContent, { type: "string" });

          // Convert to XLSX format
          const excelData = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          // Create new Excel file
          const excelBlob = new Blob([excelData], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const excelFileName = file.name.replace(".csv", ".xlsx");
          const excelFile = new File([excelBlob], excelFileName, {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          setExcelFile(excelFile);
          toast.info("CSV file converted to Excel format.");
        } catch (error) {
          console.error("Error converting CSV to Excel:", error);
          toast.error(
            "Failed to convert CSV file. Please upload an Excel file instead.",
          );
          event.target.value = "";
        }
      };
      reader.readAsText(file);
    } else {
      // It's already an Excel file
      setExcelFile(file);
    }
  };
  // In handleExcelUpload function
  const handleExcelUpload = async () => {
    if (!excelFile) {
      toast.error("Please select an Excel file to upload");
      return;
    }

    if (!orgId || !project?.projectId) {
      toast.error("Organization ID or Project ID is missing");
      return;
    }

    setUploadingExcel(true);

    try {
      const formData = new FormData();
      formData.append("excelFile", excelFile);
      formData.append("orgId", orgId);
      formData.append("projectBelong", project.projectId);

      // Add createdBy if needed
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      if (userDetails?.userId) {
        formData.append("createdBy", userDetails.userId);
      }

      // Optional: Add other parameters if needed
      formData.append("taskStatus", "Pending"); // Default status
      formData.append("taskPriority", "Medium"); // Default priority

      console.log("=== FRONTEND DEBUG ===");
      console.log("FormData contents:");
      for (let pair of formData.entries()) {
        console.log(pair[0] + ": ", pair[1]);
      }
      console.log("File details:", {
        name: excelFile.name,
        size: excelFile.size,
        type: excelFile.type,
        lastModified: excelFile.lastModified,
      });

      // Call the Excel upload API
      console.log("Calling API...");
      const response = await createTasksFromExcel(formData);

      console.log("API Response received:", response);

      // Check for success flag
      if (response.success || response.message) {
        const successMessage =
          response.message ||
          `${
            response.createdCount || "Tasks"
          } created successfully from Excel!`;
        toast.success(successMessage);
        setShowExcelUploadModal(false);
        setExcelFile(null);

        // Refresh tasks list
        loadProjectTasks();
      } else {
        toast.error(response.message || "Failed to create tasks from Excel");
      }
    } catch (error) {
      console.error("=== FRONTEND ERROR ===");
      console.error("Full error:", error);
      console.error("Error name:", error.name);
      console.error("Error message:", error.message);
      console.error("Error stack:", error.stack);

      // Show more specific error
      if (error.message.includes("File contains corrupted data")) {
        toast.error(
          "The Excel file format is invalid. Please download and use the template.",
        );
      } else if (error.message.includes("instance of entity type")) {
        toast.error("Database error. Please try again or contact support.");
      } else if (error.message.includes("No response from server")) {
        toast.error(
          "Cannot connect to server. Please check your network connection.",
        );
      } else if (error.message.includes("timeout")) {
        toast.error(
          "Request timed out. The file might be too large or server is busy.",
        );
      } else {
        // Show the actual error message from backend
        toast.error(`Upload failed: ${error.message}`);
      }
    } finally {
      setUploadingExcel(false);
    }
  };

  // Close Excel upload modal
  const handleCloseExcelUploadModal = () => {
    setShowExcelUploadModal(false);
    setExcelFile(null);
  };

  // Download Excel template
  const handleDownloadTemplate = () => {
    // Create sample Excel data
    const templateData = [
      [
        "taskName",
        "taskDescription",
        "assignedTo",
        "taskStartDate",
        "taskEndDate",
        "taskPriority",
        "taskStatus",
      ],
      [
        "Task 1",
        "Description for task 1",
        "user123",
        "2024-01-15",
        "2024-01-20",
        "High",
        "Pending",
      ],
      [
        "Task 2",
        "Description for task 2",
        "user456",
        "2024-01-16",
        "2024-01-22",
        "Medium",
        "In Progress",
      ],
      [
        "Task 3",
        "Description for task 3",
        "",
        "2024-01-17",
        "2024-01-25",
        "Low",
        "Not Started",
      ],
    ];

    // Convert to CSV
    const csvContent = templateData.map((row) => row.join(",")).join("\n");

    // Create download link
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "task_upload_template.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    toast.info("Excel template downloaded. Fill in your tasks and upload.");
  };

  // =========================================================================
  // STAGES TAB FUNCTIONS
  // =========================================================================

  // Load project stages
  const loadProjectStages = async () => {
    if (!projectId) return;

    setStagesLoading(true);
    try {
      const stagesData = await fetchStagesByProject(projectId);
      console.log("Loaded project stages:", stagesData);
      setStages(stagesData || []);
    } catch (error) {
      console.error("Error loading project stages:", error);
      toast.error("Failed to load project stages");
      setStages([]);
    } finally {
      setStagesLoading(false);
    }
  };

  // Stage modal handlers
  const handleCreateStage = () => {
    setEditingStage(null);
    setShowStageModal(true);
  };

  const handleEditStage = (stage) => {
    setEditingStage(stage);
    setShowStageModal(true);
  };

  const handleCloseStageModal = () => {
    setShowStageModal(false);
    setEditingStage(null);
  };

  const handleStageSaved = () => {
    loadProjectStages();
    handleCloseStageModal();
  };

  // Handle stage updates
  const handleUpdateStage = async (stageId, updatedData) => {
    try {
      await updateStage(stageId, updatedData);
      toast.success("Stage updated successfully");
      loadProjectStages();
    } catch (error) {
      console.error("Error updating stage:", error);
      toast.error("Failed to update stage");
    }
  };

  // =========================================================================
  // TEAM TAB FUNCTIONS
  // =========================================================================

  // Fetch user details for team members
  const fetchTeamMemberDetails = async (userIds) => {
    if (!userIds || userIds.length === 0) {
      setTeamMemberDetails([]);
      return;
    }

    try {
      setLoadingTeamMembers(true);
      console.log("Fetching user details for team member IDs:", userIds);

      // Convert string IDs to numbers for the API
      const numericUserIds = userIds
        .map((id) => parseInt(id))
        .filter((id) => !isNaN(id));

      if (numericUserIds.length === 0) {
        console.warn("No valid user IDs to fetch for team members");
        setTeamMemberDetails([]);
        return;
      }

      const response = await getUsersByIds(numericUserIds);
      console.log("Fetched Team Member Details:", response);

      if (response && response.users) {
        setTeamMemberDetails(response.users);
      } else {
        setTeamMemberDetails([]);
        console.warn("No user details found for team members");
      }
    } catch (error) {
      console.error("Error fetching team member details:", error);
      toast.error("Error loading team member details");
      setTeamMemberDetails([]);
    } finally {
      setLoadingTeamMembers(false);
    }
  };

  // =========================================================================
  // TICKET TAB FUNCTIONS
  // =========================================================================

  // Load tickets for the project
  const loadProjectTickets = async () => {
    if (!project?.projectId) return;

    setTicketsLoading(true);
    try {
      const ticketsData = await getTicketsByProjectId(project.projectId);
      console.log("Loaded tickets:", ticketsData);
      setTickets(ticketsData);
    } catch (error) {
      console.error("Error loading tickets:", error);
      toast.error("Failed to load project tickets");
    } finally {
      setTicketsLoading(false);
    }
  };

  // Handle converting ticket to task
  const handleConvertToTask = (ticket) => {
    navigate(`/addTask?projectId=${projectId}&ticketId=${ticket.ticketId}`);
  };

  // Load assignments for a ticket
  const refreshAssignments = async (ticketId) => {
    try {
      setAssignmentsLoading(true);
      const data = await getAssignmentsByTicketId(ticketId);
      console.log(data);
      setAssignmentsByTicket((prev) => ({ ...prev, [ticketId]: data || [] }));
    } catch (err) {
      console.error("Error loading assignments:", err);
      // toast.error("Failed to load assignments");
    } finally {
      setAssignmentsLoading(false);
    }
  };

  // Open the small ticket dialog
  /**
   * The function `openTicketDialog` sets up a ticket dialog, assigns a ticket to a user, and refreshes
   * the assignments.
   */
  // const openTicketDialog = async (ticket) => {
  //   setTicketForDialog(ticket);
  //   setShowTicketDialog(true);
  //   setAssignUserId("");
  //   await refreshAssignments(ticket.ticketId);
  // };

  const openTicketDialog = async (ticket) => {
    setTicketForDialog(ticket);
    setShowTicketDialog(true);
    setAssignUserId("");

    await refreshAssignments(ticket.ticketId);
    await loadTicketLogs(ticket.ticketId);

    // 🔥 ADD THIS
    await loadBlocksForTicket(ticket.ticketId);
  };

  const handleMapTicketToBlock = async () => {
    if (!selectedBlockId) {
      toast.error("Please select a Building Block");
      return;
    }

    // 🔥 Check if already mapped
    const alreadyMapped = ticketBlocks.some(
      (b) => b.buildingBlockId === selectedBlockId,
    );

    if (alreadyMapped) {
      toast.warning(
        "This ticket is already assigned to the selected Building Block.",
      );
      return;
    }

    try {
      setBlockMappingLoading(true);

      await mapTicketToBuildingBlock({
        buildingBlockId: selectedBlockId,
        ticketId: ticketForDialog.ticketId,
        orgId: String(orgId),
        createdBy: String(userId),
      });

      toast.success("Ticket mapped successfully");

      setSelectedBlockId("");

      await loadBlocksForTicket(ticketForDialog.ticketId);
    } catch (err) {
      console.error(err);
      toast.error("Failed to map ticket");
    } finally {
      setBlockMappingLoading(false);
    }
  };

  const filteredTickets = tickets.filter((ticket) => {
    const matchesSearch =
      ticket.ticketName?.toLowerCase().includes(searchText.toLowerCase()) ||
      ticket.description?.toLowerCase().includes(searchText.toLowerCase());

    const matchesStatus = statusFilter ? ticket.status === statusFilter : true;

    const matchesPriority = priorityFilter
      ? ticket.priority === priorityFilter
      : true;

    return matchesSearch && matchesStatus && matchesPriority;
  });

  const handleSaveTicketWorkLog = async () => {
    if (!ticketForDialog?.ticketId) {
      toast.error("No ticket selected");
      return;
    }

    if (!ticketWorkUserId || !ticketWorkValue) {
      toast.error("Please select user and enter hours");
      return;
    }

    try {
      setSavingTicketWorkLog(true);

      const payload = {
        ticketId: ticketForDialog.ticketId,
        orgId: orgId,
        effortValue: parseFloat(ticketWorkValue),
        effortUnit: ticketWorkUnit,

        // 🔥 IMPORTANT
        changedBy: ticketWorkUserId, // resource who worked
        createdBy: String(userId), // logged-in user
      };

      await addTicketWorkLog(payload);

      toast.success("Work log added");

      await loadTicketLogs(ticketForDialog.ticketId);

      // reset
      setTicketWorkUserId("");
      setTicketWorkValue("");
      setTicketWorkUnit("HOURS");
    } catch (err) {
      console.error(err);
      toast.error("Failed to add work log");
    } finally {
      setSavingTicketWorkLog(false);
    }
  };

  // Close dialog
  const closeTicketDialog = () => {
    setShowTicketDialog(false);
    setTicketForDialog(null);
    setAssignUserId("");
  };

  // Get the active assignment (if any) for a user on this ticket
  const getActiveAssignmentForUser = (ticketId, userId) => {
    const list = assignmentsByTicket[ticketId] || [];
    return list.find(
      (x) =>
        String(x.assignedUserId) === String(userId) &&
        (x.isActive === true || x.isActive === 1),
    );
  };

  // Assign & start work for the selected team member
  const handleAssignAndStart = async () => {
    if (!ticketForDialog?.ticketId) {
      toast.error("No ticket selected");
      return;
    }
    if (!assignUserId) {
      toast.error("Please select a team member");
      return;
    }

    // Prevent duplicate active sessions
    const active = getActiveAssignmentForUser(
      ticketForDialog.ticketId,
      assignUserId,
    );
    if (active) {
      toast.info("This user already has an active session on this ticket");
      return;
    }
    console.log(orgId);
    try {
      setAssignLoading(true);
      await startWork(ticketForDialog.ticketId, assignUserId, orgId);
      toast.success("Assignment started");
      await refreshAssignments(ticketForDialog.ticketId);
      setAssignUserId("");
    } catch (err) {
      console.error("Start work failed:", err);
      toast.error(
        err?.response?.data || err?.message || "Failed to start assignment",
      );
    } finally {
      setAssignLoading(false);
    }
  };

  const loadTicketName = async (ticketId) => {
    if (!ticketId) return;

    // prevent duplicate API calls
    if (ticketNameMap[ticketId]) return;

    try {
      const ticket = await getTicketByTicketId(ticketId);

      setTicketNameMap((prev) => ({
        ...prev,
        [ticketId]: ticket?.ticketName || ticketId,
      }));
    } catch (err) {
      console.error("Failed to fetch ticket", ticketId, err);

      setTicketNameMap((prev) => ({
        ...prev,
        [ticketId]: ticketId,
      }));
    }
  };

  // Stop an active assignment
  const handleStop = async (assignmentId) => {
    if (!assignmentId) return;

    try {
      await stopWork(assignmentId);
      toast.success("Stopped");
      if (ticketForDialog?.ticketId) {
        await refreshAssignments(ticketForDialog.ticketId);
      }
    } catch (err) {
      console.error("Stop work failed:", err);
      toast.error(err?.response?.data || err?.message || "Failed to stop");
    }
  };

  useEffect(() => {
    if (tickets.length > 0) {
      tickets.forEach((ticket) => refreshAssignments(ticket.ticketId));
    }
  }, [tickets]);

  // Format a duration in hours with 2 decimals
  const fmtHours = (h) => (h == null ? "-" : Number(h).toFixed(2));

  // =========================================================================
  // WORKFLOW TAB FUNCTIONS
  // =========================================================================

  // Load task templates
  const loadTemplates = async () => {
    if (!orgId) return;

    setTemplatesLoading(true);
    try {
      const templatesData = await getTemplatesByOrg(orgId);
      console.log("Loaded templates:", templatesData);
      setTemplates(templatesData || []);
    } catch (error) {
      console.error("Error loading templates:", error);
      toast.error("Failed to load task templates");
      setTemplates([]);
    } finally {
      setTemplatesLoading(false);
    }
  };

  // Task Template Handlers
  const handleCreateTemplate = () => {
    setSelectedTemplate(null);
    setShowTemplateModal(true);
  };

  const handleEditTemplate = (template) => {
    setSelectedTemplate(template);
    setShowTemplateModal(true);
  };

  const handleDeleteTemplate = async (templateId) => {
    if (window.confirm("Are you sure you want to delete this template?")) {
      try {
        await deleteTaskTemplate(templateId);
        toast.success("Template deleted successfully");
        loadTemplates();
      } catch (error) {
        console.error("Error deleting template:", error);
        toast.error("Failed to delete template");
      }
    }
  };

  const handleTemplateSaved = () => {
    loadTemplates();
  };

  // =========================================================================
  // PARTNER TAB FUNCTIONS
  // =========================================================================

  // Load partners for the project
  const loadProjectPartners = async () => {
    if (!projectId) return;

    setPartnersLoading(true);
    try {
      const partnersData = await getPartnersByProject(projectId);
      console.log("Loaded project partners:", partnersData);
      setPartners(partnersData || []);
    } catch (error) {
      console.error("Error loading project partners:", error);
      toast.error("Failed to load project partners");
      setPartners([]);
    } finally {
      setPartnersLoading(false);
    }
  };

  // Partner modal handlers
  const handleCreatePartner = () => {
    setEditingPartner(null);
    setShowPartnerModal(true);
  };

  const handleEditPartner = (partner) => {
    setEditingPartner(partner);
    setShowPartnerModal(true);
  };

  const handleClosePartnerModal = () => {
    setShowPartnerModal(false);
    setEditingPartner(null);
  };

  const handlePartnerSaved = () => {
    loadProjectPartners();
    handleClosePartnerModal();
  };

  const fetchVendorIfNeeded = async (vendorCode) => {
    if (!vendorCode) return;

    // Already fetched → skip API
    if (vendorMap[vendorCode]) return;

    try {
      const vendor = await getVendorById(vendorCode);

      setVendorMap((prev) => ({
        ...prev,
        [vendorCode]: vendor,
      }));
    } catch (error) {
      console.error(`Failed to fetch vendor ${vendorCode}`, error);

      // fallback so UI does not break
      setVendorMap((prev) => ({
        ...prev,
        [vendorCode]: {
          name: vendorCode,
          vendorCode,
        },
      }));
    }
  };

  useEffect(() => {
    if (partners && partners.length > 0) {
      partners.forEach((partner) => {
        // partner.partnerName actually contains vendorCode
        fetchVendorIfNeeded(partner.partnerName);
      });
    }
  }, [partners]);

  const fetchVendorContactsIfNeeded = async (vendorCode) => {
    if (!vendorCode) return;

    // already fetched → skip
    if (vendorContactsMap[vendorCode]) return;

    try {
      setLoadingVendorContacts((prev) => ({
        ...prev,
        [vendorCode]: true,
      }));

      const contacts = await fetchCusVenCpByCusVenType(vendorCode);

      setVendorContactsMap((prev) => ({
        ...prev,
        [vendorCode]: Array.isArray(contacts) ? contacts : [],
      }));
    } catch (error) {
      console.error("Error fetching vendor contacts:", error);

      setVendorContactsMap((prev) => ({
        ...prev,
        [vendorCode]: [],
      }));
    } finally {
      setLoadingVendorContacts((prev) => ({
        ...prev,
        [vendorCode]: false,
      }));
    }
  };

  useEffect(() => {
    if (partners && partners.length > 0) {
      partners.forEach((partner) => {
        // partner.partnerName = vendorCode
        fetchVendorContactsIfNeeded(partner.partnerName);
      });
    }
  }, [partners]);

  // =========================================================================
  // COMMERCIALS TAB FUNCTIONS
  // =========================================================================

  // Load commercials for the project
  const loadProjectCommercials = async () => {
    if (!projectId) return;

    setCommercialsLoading(true);
    try {
      const commercialsData = await getCommercialsByProject(projectId);
      console.log("Loaded project commercials:", commercialsData);
      setCommercials(commercialsData || []);
    } catch (error) {
      console.error("Error loading project commercials:", error);
      toast.error("Failed to load project commercials");
      setCommercials([]);
    } finally {
      setCommercialsLoading(false);
    }
  };

  // Commercial modal handlers
  const handleCreateCommercial = () => {
    setEditingCommercial(null);
    setShowCommercialModal(true);
  };

  const handleEditCommercial = (commercial) => {
    setEditingCommercial(commercial);
    setShowCommercialModal(true);
  };

  const handleCloseCommercialModal = () => {
    setShowCommercialModal(false);
    setEditingCommercial(null);
  };

  const handleCommercialSaved = () => {
    loadProjectCommercials();
    handleCloseCommercialModal();
  };

  // =========================================================================
  // MILESTONE TAB FUNCTIONS
  // =========================================================================

  // Function to fetch task details by IDs
  const fetchTaskDetailsByIds = async (taskIds) => {
    if (!taskIds || taskIds.length === 0) return [];

    try {
      const tasksData = await getTasksByProject(projectId);
      console.log("All project tasks:", tasksData);

      // Filter tasks to only include those in the taskIds array
      const filteredTasks = tasksData.filter((task) =>
        taskIds.includes(task.taskId),
      );
      console.log("Filtered tasks for milestone:", filteredTasks);

      return filteredTasks;
    } catch (error) {
      console.error("Error fetching task details:", error);
      return [];
    }
  };

  // Load milestones for the project
  const loadProjectMilestones = async () => {
    if (!projectId || !orgId) return;

    setMilestonesLoading(true);
    try {
      const milestonesData = await getMilestonesByProjectAndOrg(
        projectId,
        orgId,
      );
      console.log("Loaded project milestones:", milestonesData);

      // Load tasks for each milestone and calculate percentages
      if (milestonesData && milestonesData.length > 0) {
        const tasksMap = {};
        const updatedMilestones = [];

        // Fetch tasks for each milestone and calculate percentage
        for (const milestone of milestonesData) {
          let taskDetails = [];

          if (
            milestone.taskAssignedList &&
            milestone.taskAssignedList.length > 0
          ) {
            taskDetails = await fetchTaskDetailsByIds(
              milestone.taskAssignedList,
            );

            // Calculate percentage based on task status
            const totalTasks = taskDetails.length;
            const completedTasks = taskDetails.filter(
              (task) => task.taskStatus?.toLowerCase() === "completed",
            ).length;

            // Calculate percentage: (completed tasks / total tasks) * 100
            const calculatedPercentage =
              totalTasks > 0
                ? Math.round((completedTasks / totalTasks) * 100)
                : 0;

            // Update milestone with calculated percentage
            const updatedMilestone = {
              ...milestone,
              calculatedPercentage: calculatedPercentage,
              totalTasks: totalTasks,
              completedTasks: completedTasks,
            };

            updatedMilestones.push(updatedMilestone);
          } else {
            // No tasks assigned - percentage is 0
            const updatedMilestone = {
              ...milestone,
              calculatedPercentage: 0,
              totalTasks: 0,
              completedTasks: 0,
            };
            updatedMilestones.push(updatedMilestone);
          }

          tasksMap[milestone.milestoneMavroId] = taskDetails;
        }

        setMilestones(updatedMilestones);
        setMilestoneTasks(tasksMap);
      } else {
        setMilestones(milestonesData || []);
      }
    } catch (error) {
      console.error("Error loading project milestones:", error);
      toast.error("Failed to load project milestones");
      setMilestones([]);
    } finally {
      setMilestonesLoading(false);
    }
  };

  // Milestone modal handlers
  const handleCreateMilestone = () => {
    setEditingMilestone(null);
    setShowMilestoneModal(true);
  };

  const handleEditMilestone = (milestone) => {
    setEditingMilestone(milestone);
    setShowMilestoneModal(true);
  };

  const handleCloseMilestoneModal = () => {
    setShowMilestoneModal(false);
    setEditingMilestone(null);
  };

  const handleMilestoneSaved = () => {
    loadProjectMilestones();
    handleCloseMilestoneModal();
  };

  // Toggle milestone expansion
  const toggleMilestoneExpand = (milestoneId) => {
    setExpandedMilestones((prev) => ({
      ...prev,
      [milestoneId]: !prev[milestoneId],
    }));
  };

  // =========================================================================
  // RESOURCE ALLOCATION TAB FUNCTIONS
  // =========================================================================

  // Load resources for the project
  const loadProjectResources = async () => {
    if (!projectId) return;

    setResourcesLoading(true);
    try {
      const resourcesData = await fetchResourcesByProject(projectId);
      console.log("Loaded project resources:", resourcesData);
      setResources(resourcesData || []);
    } catch (error) {
      console.error("Error loading project resources:", error);
      toast.error("Failed to load project resources");
      setResources([]);
    } finally {
      setResourcesLoading(false);
    }
  };

  // Resource modal handlers
  const handleCreateResource = () => {
    setEditingResource(null);
    setShowResourceModal(true);
  };

  const handleEditResource = (resource) => {
    setEditingResource(resource);
    setShowResourceModal(true);
  };

  const handleCloseResourceModal = () => {
    setShowResourceModal(false);
    setEditingResource(null);
  };

  const handleResourceSaved = () => {
    loadProjectResources();
    handleCloseResourceModal();
    setActiveTab("resourceAllocation");
  };

  // Handle resource deletion
  const handleDeleteResource = async (resourceId) => {
    if (window.confirm("Are you sure you want to delete this resource?")) {
      try {
        await deleteResource(resourceId);
        toast.success("Resource deleted successfully");
        loadProjectResources();
      } catch (error) {
        console.error("Error deleting resource:", error);
        toast.error("Failed to delete resource");
      }
    }
  };

  // Fetch resource details by ID
  const fetchResourceDetails = async (resourceId) => {
    if (!resourceId || resourceDetails[resourceId]) return;

    try {
      setLoadingResourceDetails((prev) => ({
        ...prev,
        [resourceId]: true,
      }));

      const response = await fetchResourceById(resourceId);
      console.log(`Fetched resource details for ${resourceId}:`, response);

      if (response) {
        setResourceDetails((prev) => ({
          ...prev,
          [resourceId]: response,
        }));
      }
    } catch (error) {
      console.error(
        `Error fetching resource details for ${resourceId}:`,
        error,
      );
      // Set a fallback object if fetch fails
      setResourceDetails((prev) => ({
        ...prev,
        [resourceId]: { name: resourceId, role: "Unknown" },
      }));
    } finally {
      setLoadingResourceDetails((prev) => ({
        ...prev,
        [resourceId]: false,
      }));
    }
  };

  // =========================================================================
  // DOCUMENTS TAB FUNCTIONS
  // =========================================================================

  // Load documents for the project
  const loadProjectDocuments = async () => {
    if (!projectId) return;

    setDocumentsLoading(true);
    try {
      const documentsData = await getDocumentsByProject(projectId);
      console.log("Loaded project documents:", documentsData);
      setDocuments(documentsData || []);
    } catch (error) {
      console.error("Error loading project documents:", error);
      toast.error("Failed to load project documents");
      setDocuments([]);
    } finally {
      setDocumentsLoading(false);
    }
  };

  const handleUploadDocuments = async () => {
    if (selectedFiles.length === 0) {
      toast.error("Please select at least one file to upload");
      return;
    }

    if (!documentTitle.trim()) {
      toast.error("Please enter a document title");
      return;
    }

    if (!documentType) {
      toast.error("Please select a document type");
      return;
    }

    setUploadingDocuments(true);
    try {
      // Validate files
      for (const file of selectedFiles) {
        const validation = validateFile(file, 25);
        if (!validation.isValid) {
          toast.error(`Invalid file: ${file.name} - ${validation.error}`);
          return;
        }
      }

      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const createdBy = userDetails?.userId || "unknown";

      // Updated API call with title and type
      await uploadMultipleProjectDocuments(
        orgId,
        projectId,
        createdBy,
        selectedFiles,
        documentTitle,
        documentType,
      );

      toast.success(
        `${selectedFiles.length} document(s) uploaded successfully`,
      );
      setSelectedFiles([]);
      setDocumentTitle("");
      setDocumentType("");
      setShowUploadModal(false);
      loadProjectDocuments();
    } catch (error) {
      console.error("Error uploading documents:", error);
      toast.error("Failed to upload documents");
    } finally {
      setUploadingDocuments(false);
    }
  };

  const getFileNameFromHeaders = (headers, fallback = "download") => {
    const cd = headers["content-disposition"] || headers["Content-Disposition"];
    if (!cd) return fallback;

    // Example: attachment; filename="file.xlsx"; filename*=UTF-8''file.xlsx
    const filenameStarMatch = cd.match(/filename\*\=([^;]+)/i);
    if (filenameStarMatch) {
      try {
        const value = filenameStarMatch[1].trim(); // UTF-8''name
        const idx = value.indexOf("''");
        if (idx !== -1) {
          return decodeURIComponent(value.substring(idx + 2));
        }
        return decodeURIComponent(value.replace(/^UTF-8''/i, ""));
      } catch (_) {
        /* ignore decode errors */
      }
    }

    const filenameMatch = cd.match(/filename\=\"?([^\";]+)\"?/i);
    if (filenameMatch) return filenameMatch[1];

    return fallback;
  };

  // Handle document download
  // Handle document download
  const handleDownloadDocument = async (doc) => {
    try {
      toast.info("Downloading document...");

      // If you have a utility that already does this correctly, keep it.
      // Otherwise, do the robust approach below:
      const response = await downloadDocument(doc.documentId);

      // 1) Extract filename from headers, fallback to title, keep extension if any
      const serverFileName = getFileNameFromHeaders(
        response.headers,
        doc.documentTitle || "document",
      );
      // 2) Use the server content-type to create a proper Blob
      const contentType =
        response.headers["content-type"] ||
        response.headers["Content-Type"] ||
        "application/octet-stream";

      const blob = new Blob([response.data], { type: contentType });

      // 3) Create link and trigger download
      const url = window.URL.createObjectURL(blob);
      const a = window.document.createElement("a"); // IMPORTANT: window.document (not the param)
      a.href = url;
      a.download = serverFileName;
      window.document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Document downloaded successfully");
    } catch (error) {
      console.error("Error downloading document:", error);
      toast.error("Failed to download document. Please try again.");
    }
  };

  // Handle document deletion
  const handleDeleteDocument = async (documentId, documentTitle) => {
    if (window.confirm(`Are you sure you want to delete "${documentTitle}"?`)) {
      try {
        await deleteDocumentWithFile(documentId);
        toast.success("Document deleted successfully");
        loadProjectDocuments(); // Refresh the documents list
      } catch (error) {
        console.error("Error deleting document:", error);
        toast.error("Failed to delete document");
      }
    }
  };

  // Handle file selection
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
  };

  // =========================================================================
  // HELPER FUNCTIONS
  // =========================================================================

  // Helper function to get status description by ID
  const getStatusDescription = (statusId) => {
    if (!statusId) return "Not set";
    const status = projectStatuses.find((s) => s.projectStatusId === statusId);
    return status ? status.projectStatusDesc : statusId;
  };

  // Helper function to get resource name by ID
  const getResourceNameById = (resourceId) => {
    if (!resourceId) return "Not assigned";
    const resource = resourcesByOrg.find(
      (res) => res.resourceId === resourceId,
    );
    return resource ? resource.name : resourceId;
  };

  // Helper function to get user display info
  const getUserDisplayInfo = (userId) => {
    const userDetail = teamMemberDetails.find(
      (user) => user.userId === parseInt(userId),
    );
    if (userDetail) {
      console.log("User Detail Found:", userDetail);
      return {
        name: userDetail.username,
        email: userDetail.email,
      };
    }
    return {
      name: "Unknown User",
      email: "No email",
      role: "Team Member",
    };
  };

  // Helper function to parse partner roles from JSON
  const parsePartnerRoles = (partnerRole) => {
    try {
      if (typeof partnerRole === "string") {
        return JSON.parse(partnerRole);
      }
      return partnerRole || [];
    } catch (error) {
      console.error("Error parsing partner roles:", error);
      return [];
    }
  };

  // Helper function to format roles for display
  const formatRoles = (roles) => {
    if (Array.isArray(roles)) {
      return roles.join(", ");
    }
    return roles || "No roles assigned";
  };

  // Helper function to get field display name
  const getFieldDisplayName = (fieldName) => {
    const fieldConfig = availableFields.find((f) => f.field === fieldName);
    return fieldConfig?.displayName || fieldName;
  };

  // Format currency for display
  const formatCurrencyDisplay = (amount, currency) => {
    if (!amount) return "-";

    const numericAmount = parseFloat(amount);
    if (isNaN(numericAmount)) return amount;

    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      minimumFractionDigits: 2,
    });

    return formatter.format(numericAmount);
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("MMM DD, YYYY");
  };

  // Format datetime for display
  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("MMM DD, YYYY HH:mm");
  };

  // Status badge helpers - update to handle GUIDs
  const getStatusBadge = (statusId) => {
    // If it's a GUID (looks like UUID format), get the status name first
    let statusDesc = statusId;

    // Check if it's a UUID (GUID) format
    const isGuid =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
        statusId,
      );

    if (isGuid) {
      // It's a GUID, get the status name from the map
      statusDesc = getTaskStatusName(statusId);
    } else {
      // It's a status description, get it from project statuses
      const status = projectStatuses.find(
        (s) => s.projectStatusId === statusId,
      );
      statusDesc = status ? status.projectStatusDesc : statusId;
    }

    const statusMap = {
      // Status descriptions
      Idea: "project-view-status-pending",
      Discussion: "project-view-status-pending",
      Proposal: "project-view-status-pending",
      Dev: "project-view-status-active",
      SIT: "project-view-status-active",
      UAT: "project-view-status-active",
      "Go-Live": "project-view-status-active",
      Hypercare: "project-view-status-active",
      Closed: "project-view-status-completed",
      Cancelled: "project-view-status-pending",

      // Status names from task statuses
      New: "project-view-status-pending",
      "Not Started": "project-view-status-pending",
      "In Progress": "project-view-status-active",
      "Dev in Progress": "project-view-status-active",
      "UAT In Progress": "project-view-status-active",
      "Ready for PRD": "project-view-status-active",
      "Moved to PRD": "project-view-status-completed",
      Completed: "project-view-status-completed",
      "On Hold": "project-view-status-pending",
      Cancelled: "project-view-status-pending",

      // Legacy status mappings (keep for backward compatibility)
      Active: "project-view-status-active",
      Completed: "project-view-status-completed",
      Pending: "project-view-status-pending",
      "In Progress": "project-view-status-active",
      open: "project-view-status-active",
      closed: "project-view-status-completed",
      resolved: "project-view-status-completed",
      "in progress": "project-view-status-active",
    };

    return statusMap[statusDesc] || "project-view-status-pending";
  };

  const getPriorityBadge = (priority) => {
    const priorityMap = {
      High: "priority-high",
      Medium: "project-view-priority-medium",
      Low: "project-view-priority-low",
      high: "priority-high",
      medium: "project-view-priority-medium",
      low: "project-view-priority-low",
    };
    return priorityMap[priority] || "project-view-priority-medium";
  };

  // Helper function for resource status badges
  const getResourceStatusBadge = (status) => {
    const statusMap = {
      Active: "bg-success",
      "In Progress": "bg-primary",
      Completed: "bg-secondary",
      "On Hold": "bg-warning",
      Inactive: "bg-danger",
    };
    return statusMap[status] || "bg-secondary";
  };

  // =========================================================================
  // USE EFFECT HOOKS
  // =========================================================================

  // INITIAL LOAD EFFECTS
  useEffect(() => {
    loadProjectDetails();
  }, [projectId]);

  useEffect(() => {
    loadProjectStatuses();
  }, []);

  useEffect(() => {
    if (orgId) {
      loadCustomers();
      loadTeams();
      fetchProjectTypesList();
      loadResourcesByOrg();
    }
  }, [orgId]);

  // OVERVIEW TAB EFFECTS
  useEffect(() => {
    if (project?.prTypes) {
      fetchProjectTypeDescription(project.prTypes);
    }
  }, [project?.prTypes]);

  useEffect(() => {
    if (project?.prClient && customers.length > 0) {
      const customer = customers.find(
        (cust) => cust.customerCode === project.prClient,
      );
      if (customer) {
        setSelectedCustomerName(customer.name);
      } else {
        setSelectedCustomerName(project.prClient);
      }
    } else if (project?.prClient) {
      setSelectedCustomerName(project.prClient);
    } else {
      setSelectedCustomerName("");
    }
  }, [project?.prClient, customers]);

  useEffect(() => {
    if (project) {
      // Fetch project manager name
      if (project.currentProjectManager) {
        fetchProjectManagerName(project.currentProjectManager);
      } else {
        setProjectManagerName("Not assigned");
      }

      // Fetch salesperson name
      if (project.salespersonCode) {
        fetchSalespersonName(project.salespersonCode);
      } else {
        setSalespersonName("Not assigned");
      }
    }
  }, [project]);

  useEffect(() => {
    const fetchTeamData = async () => {
      console.log("inside fetch team data useEffect");
      console.log("project.teamAssigned:", project?.teamAssigned);

      if (project?.teamAssigned) {
        try {
          const teamData = await getTeamById(project.teamAssigned);
          console.log("Fetched team data:", teamData);
          setTeamData(teamData);

          // Fetch user details for team members
          if (teamData.teamMembers && teamData.teamMembers.length > 0) {
            await fetchTeamMemberDetails(teamData.teamMembers);
          } else {
            setTeamMemberDetails([]);
          }
        } catch (error) {
          console.error("Error fetching team data:", error);
          setTeamData(null);
          setTeamMemberDetails([]);
        }
      } else {
        console.log("No teamAssigned found in project data");
        setTeamData(null);
        setTeamMemberDetails([]);
      }
    };

    fetchTeamData();
  }, [project?.teamAssigned]);

  // TASKS TAB EFFECTS
  // TASKS TAB EFFECTS
  useEffect(() => {
    if (activeTab === "tasks" && project?.projectId) {
      loadProjectStages(); // Always load stages when on tasks tab
    }
  }, [activeTab, project?.projectId]);

  useEffect(() => {
    if (activeTab === "tasks" && project?.projectId) {
      if (stages.length > 0) {
        loadProjectTasksByStages();
      } else {
        // If no stages exist, load tasks directly
        loadProjectTasks();
      }
    }
  }, [activeTab, stages, project?.projectId]);

  // useEffect(() => {
  //   if (!tasks || tasks.length === 0) return;

  //   tasks.forEach((task) => {
  //     if (task.taskTicketFor) {
  //       loadTicketName(task.taskTicketFor);
  //     }
  //   });
  // }, [tasks]);

  useEffect(() => {
    if (activeTab === "gantt" && project?.projectId) {
      loadProjectStages();
    }
  }, [activeTab, project?.projectId]);

  useEffect(() => {
    if (activeTab === "gantt" && stages.length > 0) {
      loadProjectTasksByStages();
    }
  }, [activeTab, stages]);

  // const filteredGanttTasks = ganttTasks.filter((task) => {
  //   if (task.type === "project") return true;

  //   const stageId = task.project?.replace("stage-", "");
  //   return !collapsedStages[stageId];
  // });

  useEffect(() => {
    if (!stages || stages.length === 0) return;

    setCollapsedStages((prev) => {
      if (Object.keys(prev).length > 0) return prev;

      const initial = {};
      stages.forEach((stage) => {
        initial[stage.stageId] = false;
      });

      return initial;
    });
  }, [stages]);

  useEffect(() => {
    if (!filteredStageTasks || Object.keys(filteredStageTasks).length === 0) {
      setGanttTasks([]);
      return;
    }

    const transformed = [];

    Object.keys(filteredStageTasks).forEach((stageId) => {
      const stage = stages.find((s) => s.stageId === stageId);

      // Skip if stage not found (except "no-stage")
      if (!stage && stageId !== "no-stage") return;

      let stageStart = null;
      let stageEnd = null;

      if (stage) {
        stageStart = new Date(stage.stageStartDateTime);
        stageEnd = new Date(stage.stageEndDateTime);

        if (!isNaN(stageStart) && !isNaN(stageEnd)) {
          transformed.push({
            id: `stage-${stageId}`,
            name: stage.stageName || "Stage",
            type: "project",
            start: stageStart,
            end: stageEnd,
            progress: 0,
            hideChildren: collapsedStages[stageId] || false,
          });
        }
      }

      (filteredStageTasks[stageId] || []).forEach((task) => {
        if (!task.taskStartDate || !task.taskEndDate) return;

        const taskStart = new Date(task.taskStartDate);
        const taskEnd = new Date(task.taskEndDate);

        if (isNaN(taskStart) || isNaN(taskEnd)) return;

        transformed.push({
          id: task.taskId,
          name: task.taskName,
          start: taskStart,
          end: taskEnd,
          progress: task.taskStatus === "Completed" ? 100 : 50,
          dependencies: task.dependsOn ? task.dependsOn.split(",") : [],
          project: stage ? `stage-${stageId}` : undefined,

          // 🔥 ADD THESE
          taskStatus: task.taskStatus,
          taskPriority: task.taskPriority,
          assignedTo: String(task.assignedTo),

          styles: getGanttTaskStyleByStatus(task.taskStatus),
        });

        // transformed.push({
        //   id: task.taskId,
        //   name: task.taskName,
        //   start: taskStart,
        //   end: taskEnd,
        //   progress: task.taskStatus === "Completed" ? 100 : 50,
        //   dependencies: task.dependsOn ? task.dependsOn.split(",") : [],
        //   project: stage ? `stage-${stageId}` : undefined,
        //   styles: getGanttTaskStyleByStatus(task.taskStatus),
        // });
      });
    });

    setGanttTasks(transformed);
  }, [filteredStageTasks, stages, collapsedStages]);

  // TICKET TAB EFFECTS
  useEffect(() => {
    if (activeTab === "ticket" && project?.projectId) {
      loadProjectTickets();
    }
  }, [activeTab, project?.projectId]);

  useEffect(() => {
    if (activeTab === "remarks" && projectId) {
      loadProjectRemarks();
    }
  }, [activeTab, projectId]);

  useEffect(() => {
    if (!tasks || tasks.length === 0) return;

    tasks.forEach((task) => {
      if (task.taskTicketFor) {
        loadTicketName(task.taskTicketFor);
      }

      if (task.taskEventFor) {
        loadEventName(task.taskEventFor);
      }
    });
  }, [tasks]);

  useEffect(() => {
    if (!tickets || tickets.length === 0) return;

    const map = {};

    tickets.forEach((ticket) => {
      map[ticket.ticketId] = ticket.ticketName;
    });

    setTicketNameMap(map);
  }, [tickets]);

  // Add this useEffect
  useEffect(() => {
    if (orgId) {
      loadAllTaskStatuses();
    }
  }, [orgId]);

  // WORKFLOW TAB EFFECTS
  useEffect(() => {
    if (activeTab === "workflow" && orgId) {
      loadTemplates();
    }
  }, [activeTab, orgId]);

  useEffect(() => {
    if (activeTab === "board" && project?.projectId) {
      loadProjectStages();
    }
  }, [activeTab, project?.projectId]);

  useEffect(() => {
    if (activeTab === "board" && stages.length > 0) {
      loadProjectTasksByStages();
    }
  }, [activeTab, stages]);

  // PARTNER TAB EFFECTS
  useEffect(() => {
    if (activeTab === "partner" && orgId && projectId) {
      loadProjectPartners();
    }
  }, [activeTab, orgId, projectId]);

  // COMMERCIALS TAB EFFECTS
  useEffect(() => {
    if (activeTab === "commercials" && projectId) {
      loadProjectCommercials();
    }
  }, [activeTab, projectId]);

  // MILESTONE TAB EFFECTS
  useEffect(() => {
    if (activeTab === "milestone" && projectId && orgId) {
      loadProjectMilestones();
    }
  }, [activeTab, projectId, orgId]);

  // RESOURCE ALLOCATION TAB EFFECTS
  useEffect(() => {
    if (activeTab === "resourceAllocation" && projectId) {
      loadProjectResources();
    }
  }, [activeTab, projectId]);

  // DOCUMENTS TAB EFFECTS
  useEffect(() => {
    if (activeTab === "documents" && projectId) {
      loadProjectDocuments();
    }
  }, [activeTab, projectId]);

  // =========================================================================
  // RENDER COMPONENTS
  // =========================================================================

  // Milestone Tasks Component
  const MilestoneTasks = ({ tasks, milestoneId }) => {
    if (!tasks || tasks.length === 0) {
      return (
        <div className="text-center py-3 text-muted">
          <small>No tasks assigned to this milestone</small>
        </div>
      );
    }

    return (
      <div className="project-view-milestone-tasks-container">
        <div className="milestone-tasks-list">
          {tasks.map((task) => (
            <div key={task.taskId} className="project-view-milestone-task-item">
              <div className="milestone-task-main">
                <div className="milestone-task-name">
                  <strong>{task.taskName}</strong>
                </div>
                <div className="milestone-task-meta">
                  <span
                    className={`project-view-task-status-badge ${getStatusBadge(
                      task.taskStatus,
                    )}`}
                  >
                    {task.taskStatus}
                  </span>
                  <span
                    className={`project-view-task-priority-badge ${getPriorityBadge(
                      task.taskPriority,
                    )}`}
                  >
                    {task.taskPriority}
                  </span>
                </div>
              </div>
              <div className="milestone-task-details">
                <small className="text-muted">
                  {task.taskDescription
                    ? task.taskDescription.length > 100
                      ? `${task.taskDescription.substring(0, 100)}...`
                      : task.taskDescription
                    : "No description"}
                </small>
              </div>
              <div className="milestone-task-dates">
                <small>
                  Start: {formatDate(task.taskStartDate)} | End:{" "}
                  {formatDate(task.taskEndDate)}
                </small>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Loading and Error States
  if (loading) {
    return (
      <div className="project-view-container">
        <Container>
          <div className="text-center text-white">
            <h3>Loading Project Details...</h3>
          </div>
        </Container>
      </div>
    );
  }

  if (!project) {
    return (
      <div className="project-view-container">
        <Container>
          <div className="text-center text-white">
            <h3>Project Not Found</h3>
            <Button variant="light" onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="project-view-container">
      <Container fluid>
        {/* Project Header */}
        <div className="project-view-card project-view-fade-in">
          <div className="project-view-header">
            <div className="d-flex justify-content-between align-items-start mb-3">
              <Button
                variant="outline-light"
                size="sm"
                onClick={() => navigate("/viewProjects")}
              >
                <FaArrowCircleLeft style={{ fontSize: "20px" }} />
              </Button>

              {/* Editable Project Title */}
              {hasEditPermission() && isEditing ? (
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    value={project.prTitle || ""}
                    onChange={(e) =>
                      handleFieldChange("prTitle", e.target.value)
                    }
                    className="project-title-edit"
                    placeholder="Project Title"
                  />
                </Form.Group>
              ) : (
                <h1
                  className={`project-view-title ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                  onClick={() => hasEditPermission() && setIsEditing(true)}
                  title={hasEditPermission() ? "Click to edit" : ""}
                >
                  {project.prTitle}
                  <span style={{ fontSize: "20px" }}>
                    {" "}
                    ( {project.projectId} ){" "}
                  </span>
                </h1>
              )}

              {hasEditPermission() && isEditing && (
                <div className="project-view-edit-controls">
                  <Button
                    variant="success"
                    size="sm"
                    onClick={handleSave}
                    disabled={saving}
                    className="me-2"
                  >
                    {saving ? (
                      <FaSave style={{ fontSize: "23px" }} />
                    ) : (
                      <FaSave style={{ fontSize: "23px" }} />
                    )}
                  </Button>
                  <Button
                    variant="outline-light"
                    size="sm"
                    onClick={handleCancel}
                    disabled={saving}
                  >
                    <MdCancel style={{ fontSize: "23px" }} />
                  </Button>
                </div>
              )}

              <Button
                variant={project?.isFavourite ? "danger" : "outline-light"}
                size="sm"
                onClick={handleToggleFavorite}
                className="me-2 d-flex align-items-center"
                title={
                  project?.isFavourite
                    ? "Remove from favorites"
                    : "Add to favorites"
                }
              >
                {project?.isFavourite ? (
                  <FaHeart
                    style={{
                      animation: "heartbeat 1s infinite",
                      marginRight: "4px",
                      fontSize: "15px",
                    }}
                  />
                ) : (
                  <CiHeart style={{ marginRight: "4px", fontSize: "30px" }} />
                )}
                {/* <span>{project?.isFavourite ? "Favorited" : "Favorite"}</span> */}
              </Button>
            </div>
          </div>

          {/* Tabs Navigation */}
          <div className="project-view-tabs">
            <ul className="project-tab-nav">
              <li
                className={`project-tab-item ${
                  activeTab === "overview" ? "active" : ""
                }`}
                onClick={() => setActiveTab("overview")}
              >
                <i className="fas fa-chart-pie me-2"></i>
                Overview
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "remarks" ? "active" : ""
                }`}
                onClick={() => setActiveTab("remarks")}
              >
                Comments
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "tasks" ? "active" : ""
                }`}
                onClick={() => setActiveTab("tasks")}
              >
                Task List
              </li>
              <li
                className={`project-tab-item ${activeTab === "events" ? "active" : ""}`}
                onClick={() => setActiveTab("events")}
              >
                Events
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "board" ? "active" : ""
                }`}
                onClick={() => setActiveTab("board")}
              >
                Board
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "sprint" ? "active" : ""
                }`}
                onClick={() => setActiveTab("sprint")}
              >
                Sprint
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "gantt" ? "active" : ""
                }`}
                onClick={() => setActiveTab("gantt")}
              >
                {/* <MdAddChart className="me-2" /> */}
                Gantt
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "BuildingBlock" ? "active" : ""
                }`}
                onClick={() => setActiveTab("BuildingBlock")}
              >
                Building Block
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "team" ? "active" : ""
                }`}
                onClick={() => setActiveTab("team")}
              >
                Team
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "ticket" ? "active" : ""
                }`}
                onClick={() => setActiveTab("ticket")}
              >
                Ticket
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "resourceAllocation" ? "active" : ""
                }`}
                onClick={() => setActiveTab("resourceAllocation")}
              >
                Resource Allocation
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "commercials" ? "active" : ""
                }`}
                onClick={() => setActiveTab("commercials")}
              >
                Commercials
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "workflow" ? "active" : ""
                }`}
                onClick={() => setActiveTab("workflow")}
              >
                Workflow
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "partner" ? "active" : ""
                }`}
                onClick={() => setActiveTab("partner")}
              >
                Partner
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "milestone" ? "active" : ""
                }`}
                onClick={() => setActiveTab("milestone")}
              >
                Milestone
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "documents" ? "active" : ""
                }`}
                onClick={() => setActiveTab("documents")}
              >
                Documents
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "budget" ? "active" : ""
                }`}
                onClick={() => setActiveTab("budget")}
              >
                Budget
              </li>
              {hasProjectAdminRole() && (
                <li
                  className={`project-tab-item ${
                    activeTab === "settings" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("settings")}
                >
                  Settings
                </li>
              )}
            </ul>
          </div>

          {/* Tab Content */}
          <div className="project-tab-content">
            {/* In the Overview tab section, replace the Status field with this updated version */}

            {activeTab === "overview" && (
              <div className="project-view-fade-in">
                <div className="project-overview-single-card">
                  <div className="project-view-overview-grid">
                    <div className="project-view-overview-row">
                      <span className="project-view-overview-label">
                        Project ID:
                      </span>
                      <span className="project-view-overview-value">
                        {project.projectId}
                      </span>
                      <span className="project-view-overview-label">
                        Client:
                      </span>
                      {hasEditPermission() && isEditing ? (
                        customersLoading ? (
                          <div className="d-flex align-items-center">
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            <small className="text-muted">
                              Loading customers...
                            </small>
                          </div>
                        ) : (
                          <Form.Select
                            value={project.prClient || ""}
                            onChange={(e) =>
                              handleCustomerChange(e.target.value)
                            }
                            size="sm"
                            className="project-view-editable-input"
                          >
                            <option value="">Select a client</option>
                            {customers.map((customer) => (
                              <option
                                key={customer.customerCode}
                                value={customer.customerCode}
                              >
                                {customer.name} ({customer.customerCode})
                              </option>
                            ))}
                          </Form.Select>
                        )
                      ) : (
                        <span
                          className={`project-view-overview-value ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                          onClick={() =>
                            hasEditPermission() && setIsEditing(true)
                          }
                          title={hasEditPermission() ? "Click to edit" : ""}
                        >
                          {selectedCustomerName ||
                            project.prClient ||
                            "Not selected"}
                        </span>
                      )}
                    </div>

                    <div className="project-view-overview-row">
                      <span className="project-view-overview-label">
                        Project Type:
                      </span>
                      {hasEditPermission() && isEditing ? (
                        projectTypeLoading ? (
                          <div className="d-flex align-items-center">
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            <small className="text-muted">
                              Loading project types...
                            </small>
                          </div>
                        ) : (
                          <Form.Select
                            value={project.prTypes || ""}
                            onChange={(e) => {
                              const selectedProjectTypeId = e.target.value;
                              handleFieldChange(
                                "prTypes",
                                selectedProjectTypeId,
                              );
                              const selectedProjectType = projectTypes.find(
                                (type) =>
                                  type.projectTypeId === selectedProjectTypeId,
                              );
                              if (selectedProjectType) {
                                setProjectTypeDesc(
                                  selectedProjectType.projectTypeDesc,
                                );
                              }
                            }}
                            size="sm"
                            className="project-view-editable-input"
                          >
                            <option value="">Select Project Type</option>
                            {projectTypes.map((type) => (
                              <option
                                key={type.projectTypeId}
                                value={type.projectTypeId}
                              >
                                {type.projectTypeDesc} ({type.projectTypeId})
                              </option>
                            ))}
                          </Form.Select>
                        )
                      ) : (
                        <span
                          className={`project-view-overview-value ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                          onClick={() =>
                            hasEditPermission() && setIsEditing(true)
                          }
                          title={hasEditPermission() ? "Click to edit" : ""}
                        >
                          {projectTypeDesc || project.prTypes || "Not selected"}
                        </span>
                      )}
                      <span className="project-view-overview-label">
                        Category:
                      </span>
                      {hasEditPermission() && isEditing ? (
                        <Form.Select
                          value={project.projectCategory || ""}
                          onChange={(e) =>
                            handleFieldChange("projectCategory", e.target.value)
                          }
                          size="sm"
                          className="project-view-editable-input"
                        >
                          <option value="">Select Category</option>
                          <option value="Internal">Internal</option>
                          <option value="External">External</option>
                        </Form.Select>
                      ) : (
                        <span
                          className={`project-view-overview-value ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                          onClick={() =>
                            hasEditPermission() && setIsEditing(true)
                          }
                          title={hasEditPermission() ? "Click to edit" : ""}
                        >
                          {project.projectCategory || "-"}
                        </span>
                      )}
                    </div>

                    <div className="project-view-overview-row">
                      <span className="project-view-overview-label">Tags:</span>
                      {hasEditPermission() && isEditing ? (
                        <Form.Control
                          type="text"
                          value={project.prTags || ""}
                          onChange={(e) =>
                            handleFieldChange("prTags", e.target.value)
                          }
                          size="sm"
                          className="project-view-editable-input"
                          placeholder="Comma separated tags"
                        />
                      ) : (
                        <span
                          className={`project-view-overview-value ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                          onClick={() =>
                            hasEditPermission() && setIsEditing(true)
                          }
                          title={hasEditPermission() ? "Click to edit" : ""}
                        >
                          {project.prTags
                            ? project.prTags.split(",").map((tag) => (
                                <Badge
                                  key={tag}
                                  bg="secondary"
                                  className="me-1"
                                >
                                  {tag.trim()}
                                </Badge>
                              ))
                            : "No tags"}
                        </span>
                      )}

                      <span className="project-view-overview-label">
                        Priority
                      </span>
                      {hasEditPermission() && isEditing ? (
                        <Form.Select
                          value={project.projectPriority || ""}
                          onChange={(e) =>
                            handleFieldChange("projectPriority", e.target.value)
                          }
                          size="sm"
                          className="project-view-editable-input"
                          required
                        >
                          <option value="">Select Priority</option>
                          <option value="Very High">Very High</option>
                          <option value="High">High</option>
                          <option value="Medium">Medium</option>
                          <option value="Low">Low</option>
                        </Form.Select>
                      ) : (
                        <span
                          className={`project-view-overview-value ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                          onClick={() =>
                            hasEditPermission() && setIsEditing(true)
                          }
                          title={hasEditPermission() ? "Click to edit" : ""}
                        >
                          {project.projectPriority ? (
                            <Badge bg="secondary" className="me-1">
                              {project.projectPriority}
                            </Badge>
                          ) : (
                            "No Priority"
                          )}
                        </span>
                      )}
                    </div>
                  </div>

                  <h3 className="project-view-overview-section-title mt-4">
                    Timeline
                  </h3>
                  <div className="project-view-overview-grid">
                    <div className="project-view-overview-row">
                      <span className="project-view-overview-label">
                        Start Date:
                      </span>
                      {hasEditPermission() && isEditing ? (
                        <Form.Control
                          type="date"
                          value={
                            project.prStartDate
                              ? moment(project.prStartDate).format("YYYY-MM-DD")
                              : ""
                          }
                          onChange={(e) =>
                            handleFieldChange("prStartDate", e.target.value)
                          }
                          size="sm"
                          className="project-view-editable-input"
                        />
                      ) : (
                        <span
                          className={`project-view-overview-value ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                          onClick={() =>
                            hasEditPermission() && setIsEditing(true)
                          }
                          title={hasEditPermission() ? "Click to edit" : ""}
                        >
                          {moment(project.prStartDate).format("MMMM DD, YYYY")}
                        </span>
                      )}
                      <span className="project-view-overview-label">
                        End Date:
                      </span>
                      {hasEditPermission() && isEditing ? (
                        <Form.Control
                          type="date"
                          value={
                            project.prEndDate
                              ? moment(project.prEndDate).format("YYYY-MM-DD")
                              : ""
                          }
                          onChange={(e) =>
                            handleFieldChange("prEndDate", e.target.value)
                          }
                          size="sm"
                          className="project-view-editable-input"
                        />
                      ) : (
                        <span
                          className={`project-view-overview-value ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                          onClick={() =>
                            hasEditPermission() && setIsEditing(true)
                          }
                          title={hasEditPermission() ? "Click to edit" : ""}
                        >
                          {moment(project.prEndDate).format("MMMM DD, YYYY")}
                        </span>
                      )}
                    </div>
                    <div className="project-view-overview-row">
                      <span className="project-view-overview-label">
                        Duration:
                      </span>
                      <span className="project-view-overview-value">
                        {moment(project.prEndDate).diff(
                          moment(project.prStartDate),
                          "days",
                        )}{" "}
                        days
                      </span>
                      <span className="project-view-overview-label">
                        Days Remaining:
                      </span>
                      <span className="project-view-overview-value">
                        {Math.max(
                          0,
                          moment(project.prEndDate).diff(moment(), "days"),
                        )}{" "}
                        days
                      </span>
                    </div>
                  </div>

                  <h3 className="project-view-overview-section-title mt-4">
                    Team & Contact
                  </h3>
                  <div className="project-view-overview-grid">
                    <div className="project-view-overview-row">
                      <span className="project-view-overview-label">
                        Project Manager:
                      </span>
                      {hasEditPermission() && isEditing ? (
                        resourcesByOrgLoading ? (
                          <div className="d-flex align-items-center">
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            <small className="text-muted">
                              Loading resources...
                            </small>
                          </div>
                        ) : (
                          <Form.Select
                            value={project.currentProjectManager || ""}
                            onChange={(e) =>
                              handleFieldChange(
                                "currentProjectManager",
                                e.target.value,
                              )
                            }
                            size="sm"
                            className="project-view-editable-input"
                          >
                            <option value="">Select Project Manager</option>
                            {resourcesByOrg.map((resource) => (
                              <option
                                key={resource.resourceId}
                                value={resource.resourceId}
                              >
                                {resource.name} ({resource.resourceId})
                              </option>
                            ))}
                          </Form.Select>
                        )
                      ) : (
                        <span
                          className={`project-view-overview-value ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                          onClick={() =>
                            hasEditPermission() && setIsEditing(true)
                          }
                          title={hasEditPermission() ? "Click to edit" : ""}
                        >
                          {loadingManager ? (
                            <div className="d-flex align-items-center">
                              <div
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                              Loading...
                            </div>
                          ) : (
                            getResourceNameById(
                              project.currentProjectManager,
                            ) || "Not assigned"
                          )}
                        </span>
                      )}
                      <span className="project-view-overview-label">
                        Team Assigned:
                      </span>
                      {hasEditPermission() && isEditing ? (
                        <Form.Select
                          value={project.teamId || ""}
                          onChange={(e) => {
                            const selectedTeamId = e.target.value;
                            const selectedTeam = teams.find(
                              (team) => team.teamId === selectedTeamId,
                            );
                            setSelectedTeamId(selectedTeamId);
                            handleFieldChange("teamId", selectedTeamId);
                            handleFieldChange(
                              "teamAssigned",
                              selectedTeam ? selectedTeam.teamName : "",
                            );
                          }}
                          size="sm"
                          className="project-view-editable-input"
                        >
                          <option value="">Select a team</option>
                          {teams.map((team) => (
                            <option key={team.teamId} value={team.teamId}>
                              {team.teamName}
                            </option>
                          ))}
                        </Form.Select>
                      ) : (
                        <span
                          className={`project-view-overview-value ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                          onClick={() =>
                            hasEditPermission() && setIsEditing(true)
                          }
                          title={hasEditPermission() ? "Click to edit" : ""}
                        >
                          {teamData?.teamName ||
                            project.teamAssigned ||
                            "Not assigned"}
                        </span>
                      )}
                    </div>
                    <div className="project-view-overview-row">
                      <span className="project-view-overview-label">
                        Salesperson:
                      </span>
                      {hasEditPermission() && isEditing ? (
                        resourcesByOrgLoading ? (
                          <div className="d-flex align-items-center">
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            <small className="text-muted">
                              Loading resources...
                            </small>
                          </div>
                        ) : (
                          <Form.Select
                            value={project.salespersonCode || ""}
                            onChange={(e) =>
                              handleFieldChange(
                                "salespersonCode",
                                e.target.value,
                              )
                            }
                            size="sm"
                            className="project-view-editable-input"
                          >
                            <option value="">Select Salesperson</option>
                            {resourcesByOrg.map((resource) => (
                              <option
                                key={resource.resourceId}
                                value={resource.resourceId}
                              >
                                {resource.name} ({resource.resourceId})
                              </option>
                            ))}
                          </Form.Select>
                        )
                      ) : (
                        <span
                          className={`project-view-overview-value ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                          onClick={() =>
                            hasEditPermission() && setIsEditing(true)
                          }
                          title={hasEditPermission() ? "Click to edit" : ""}
                        >
                          {loadingSalesperson ? (
                            <div className="d-flex align-items-center">
                              <div
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                              Loading...
                            </div>
                          ) : (
                            getResourceNameById(project.salespersonCode) ||
                            "Not assigned"
                          )}
                        </span>
                      )}
                      <span className="project-view-overview-label">
                        Status:
                      </span>
                      {hasEditPermission() && isEditing ? (
                        projectStatusesLoading ? (
                          <div className="d-flex align-items-center">
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            <small className="text-muted">
                              Loading statuses...
                            </small>
                          </div>
                        ) : (
                          <Form.Select
                            value={project.projectStatus || ""}
                            onChange={(e) =>
                              handleFieldChange("projectStatus", e.target.value)
                            }
                            size="sm"
                            className="project-view-editable-input"
                          >
                            <option value="">Select Status</option>
                            {projectStatuses.map((status) => (
                              <option
                                key={status.projectStatusId}
                                value={status.projectStatusId}
                              >
                                {status.projectStatusDesc}
                              </option>
                            ))}
                          </Form.Select>
                        )
                      ) : (
                        <span
                          className={`project-view-overview-value ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                          onClick={() =>
                            hasEditPermission() && setIsEditing(true)
                          }
                          title={hasEditPermission() ? "Click to edit" : ""}
                        >
                          <span
                            className={`project-status-badge ${getStatusBadge(project.projectStatus)}`}
                          >
                            {getStatusDescription(project.projectStatus)}
                          </span>
                        </span>
                      )}
                    </div>
                  </div>

                  <h3 className="project-view-overview-section-title mt-4">
                    Additional Info
                  </h3>
                  <div className="project-view-overview-grid">
                    <div className="project-view-overview-row">
                      <span className="project-view-overview-label">
                        Comments:
                      </span>
                      {hasEditPermission() && isEditing ? (
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={project.comments || ""}
                          onChange={(e) =>
                            handleFieldChange("comments", e.target.value)
                          }
                          className="project-view-editable-input"
                          placeholder="Add comments..."
                        />
                      ) : (
                        <span
                          className={`project-view-overview-value ${hasEditPermission() ? "project-view-editable-field" : ""}`}
                          onClick={() =>
                            hasEditPermission() && setIsEditing(true)
                          }
                          title={hasEditPermission() ? "Click to edit" : ""}
                        >
                          {project.comments || "No comments"}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "board" && (
              <div className="project-view-fade-in">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex align-items-center">
                    <h5 className="text-white me-3">Board View</h5>

                    <Form.Select
                      size="sm"
                      value={boardGroupBy}
                      onChange={(e) => setBoardGroupBy(e.target.value)}
                      style={{ width: "200px" }}
                    >
                      <option value="status">Group by Status</option>
                      <option value="priority">Group by Priority</option>
                      <option value="assignee">Group by Assignee</option>
                      <option value="stage">Group by Stage</option>
                    </Form.Select>
                  </div>
                </div>

                {/* Board Columns */}
                <div className="project-view-board-container d-flex overflow-auto">
                  {Object.entries(getBoardColumns()).map(
                    ([columnName, columnTasks]) => (
                      <div
                        key={columnName}
                        className="project-view-board-column me-3"
                      >
                        <div className="project-view-board-column-header">
                          <h6>{columnName}</h6>
                          <span className="badge bg-secondary">
                            {columnTasks.length}
                          </span>
                        </div>

                        <div className="project-view-board-column-body">
                          {columnTasks.map((task) => (
                            <Card
                              key={task.taskId}
                              className="project-view-board-task-card mb-2"
                              style={{ cursor: "pointer" }}
                            >
                              <Card.Body>
                                <div className="fw-bold">{task.taskName}</div>

                                <small className="text-muted">
                                  {task.taskDescription || "-"}
                                </small>

                                <div className="mt-2 d-flex justify-content-between">
                                  <Badge
                                    className={getPriorityBadge(
                                      task.taskPriority,
                                    )}
                                  >
                                    {task.taskPriority}
                                  </Badge>

                                  <Badge
                                    className={getStatusBadge(task.taskStatus)}
                                  >
                                    {task.taskStatus}
                                  </Badge>
                                </div>
                              </Card.Body>

                              {/* 🔥 Hover Detail Panel */}
                              <div className="project-view-board-hover-detail">
                                <div className="hover-header d-flex justify-content-between align-items-center">
                                  <h6 className="mb-0">{task.taskName}</h6>

                                  <i
                                    className="fas fa-pencil-alt project-view-edit-icon"
                                    onClick={() => handleEditTask(task.taskId)}
                                  ></i>
                                </div>

                                <hr />

                                <p>
                                  <strong>Description:</strong>{" "}
                                  {task.taskDescription || "No description"}
                                </p>

                                <p>
                                  <strong>Priority:</strong> {task.taskPriority}
                                </p>
                                <p>
                                  <strong>Status:</strong> {task.taskStatus}
                                </p>

                                <p>
                                  <strong>Start:</strong>{" "}
                                  {moment(task.taskStartDate).format(
                                    "MMM DD, YYYY",
                                  )}
                                </p>
                                <p>
                                  <strong>End:</strong>{" "}
                                  {moment(task.taskEndDate).format(
                                    "MMM DD, YYYY",
                                  )}
                                </p>

                                <Button
                                  size="sm"
                                  variant="outline-primary"
                                  onClick={() => handleEditTask(task.taskId)}
                                  className="w-100 mt-2"
                                >
                                  Edit Task
                                </Button>
                              </div>
                            </Card>
                          ))}

                          {columnTasks.length === 0 && (
                            <div className="text-muted text-center py-3">
                              No tasks
                            </div>
                          )}
                        </div>
                      </div>
                    ),
                  )}
                </div>
              </div>
            )}

            {activeTab === "gantt" && (
              <div className="project-view-fade-in" style={{ margin: "10px" }}>
                {/* 🔍 Zoom + Export Controls */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  {/* LEFT SIDE CONTROLS */}
                  <div className="d-flex gap-2 align-items-center">
                    {/* Closed / Active Toggle */}
                    <Button
                      size="sm"
                      variant={!showClosed ? "primary" : "outline-primary"}
                      onClick={() => setShowClosed(false)}
                    >
                      Active
                    </Button>

                    <Button
                      size="sm"
                      variant={showClosed ? "primary" : "outline-primary"}
                      onClick={() => setShowClosed(true)}
                    >
                      Closed
                    </Button>

                    {/* Sort Dropdown */}
                    <Form.Select
                      size="sm"
                      value={sortBy}
                      onChange={(e) => setSortBy(e.target.value)}
                      style={{ width: "160px" }}
                    >
                      {/* <option value="startDate">Start Date</option>
                      <option value="endDate">End Date</option> */}
                      <option value="stageStart">Stage Start Date</option>
                      <option value="stageEnd">Stage End Date</option>
                      <option value="taskStart">Task Start Date</option>
                      <option value="taskEnd">Task End Date</option>
                      <option value="status">Status</option>
                      <option value="priority">Priority</option>
                      <option value="assignee">Assignee</option>
                      <option value="duration">Duration</option>
                    </Form.Select>

                    {/* Filter Button */}
                    <Button
                      size="sm"
                      variant="outline-dark"
                      onClick={() => setShowFilterPanel(!showFilterPanel)}
                    >
                      Filter
                    </Button>

                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={handleResetFilters}
                    >
                      Reset
                    </Button>
                  </div>

                  <div className="d-flex gap-2 align-items-center">
                    <Button
                      size="sm"
                      variant="outline-primary"
                      onClick={scrollToToday}
                    >
                      Today
                    </Button>

                    <Form.Select
                      size="sm"
                      value={timePeriod}
                      onChange={(e) => handleTimePeriodChange(e.target.value)}
                      style={{ width: "150px" }}
                    >
                      <option value="Day">Day</option>
                      <option value="Week">Week</option>
                      <option value="Month">Month</option>
                      <option value="Quarter">Quarter</option>
                      <option value="Year">Year</option>
                      <option value="Flexible">Flexible</option>
                    </Form.Select>

                    <Button
                      size="sm"
                      variant="outline-success"
                      onClick={handleAutoFit}
                    >
                      Auto Fit
                    </Button>

                    <Button
                      size="sm"
                      variant="outline-dark"
                      onClick={exportPNG}
                    >
                      Export PNG
                    </Button>

                    <Button
                      size="sm"
                      variant="outline-dark"
                      onClick={exportPDF}
                    >
                      Export PDF
                    </Button>

                    <Button
                      size="sm"
                      variant="outline-dark"
                      onClick={exportExcel}
                    >
                      Export Excel
                    </Button>
                  </div>

                  <Form.Control
                    type="text"
                    placeholder="Search stage or task..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ width: "20vw", borderRadius: "20px" }}
                  />
                </div>

                {showFilterPanel && (
                  <Card className="mb-3 p-3 shadow-sm">
                    <Row>
                      <Col>
                        <Form.Label>Status</Form.Label>
                        <Form.Select
                          multiple
                          value={filterStatus}
                          onChange={(e) =>
                            setFilterStatus(
                              Array.from(
                                e.target.selectedOptions,
                                (option) => option.value,
                              ),
                            )
                          }
                        >
                          <option>Not Started</option>
                          <option>In Progress</option>
                          <option>On Hold</option>
                          <option>Completed</option>
                          <option>Cancelled</option>
                        </Form.Select>
                      </Col>

                      <Col>
                        <Form.Label>Priority</Form.Label>
                        <Form.Select
                          multiple
                          value={filterPriority}
                          onChange={(e) =>
                            setFilterPriority(
                              Array.from(
                                e.target.selectedOptions,
                                (option) => option.value,
                              ),
                            )
                          }
                        >
                          <option>High</option>
                          <option>Medium</option>
                          <option>Low</option>
                        </Form.Select>
                      </Col>

                      <Col>
                        <Form.Label>Assignee</Form.Label>
                        <Form.Select
                          multiple
                          value={filterAssignee}
                          onChange={(e) =>
                            setFilterAssignee(
                              Array.from(
                                e.target.selectedOptions,
                                (option) => option.value,
                              ),
                            )
                          }
                        >
                          {teamMemberDetails.map((user) => (
                            <option
                              key={user.userId}
                              value={String(user.userId)}
                            >
                              {user.username}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Row>
                  </Card>
                )}

                {/* 📊 Gantt Chart */}
                <div id="gantt-container">
                  <Card className="shadow-sm border-0">
                    <Card.Body>
                      {finalGanttTasks.length === 0 ? (
                        <div className="text-center p-4">
                          No valid tasks for Gantt view
                        </div>
                      ) : (
                        <Gantt
                          tasks={finalGanttTasks}
                          viewMode={viewMode}
                          // columnWidth={viewMode === ViewMode.Month ? 300 : 65}
                          columnWidth={
                            viewMode === ViewMode.Month
                              ? 300
                              : viewMode === ViewMode.Year
                                ? 350 // 👈 wider for yearly view
                                : 65
                          }
                          listCellWidth="200px"
                          onDateChange={handleTaskChange}
                          onExpanderClick={(task) => {
                            if (task.type !== "project") return;

                            const stageId = task.id.replace("stage-", "");

                            setCollapsedStages((prev) => ({
                              ...prev,
                              [stageId]: !prev[stageId],
                            }));
                          }}
                          // onDoubleClick={(task) => {
                          //   if (task.type === "project") {
                          //     const stageId = task.id.replace("stage-", "");

                          //     const stageData = stages.find(
                          //       (s) => String(s.stageId) === String(stageId),
                          //     );

                          //     if (stageData) {
                          //       setEditingStage(stageData); // ✅ use same state as Tasks tab
                          //       setShowStageModal(true);
                          //     }
                          //   }
                          // }}

                          onDoubleClick={(task) => {
                            if (!task) return;

                            // 🔹 If Stage → open Stage Modal
                            if (task.type === "project") {
                              const stageId = task.id.replace("stage-", "");
                              const stageData = stages.find(
                                (s) => String(s.stageId) === String(stageId),
                              );

                              if (stageData) {
                                setEditingStage(stageData);
                                setShowStageModal(true);
                              }

                              return;
                            }

                            // 🔹 If Task → open Task Edit Modal
                            setEditingTaskId(task.id);
                            setShowTaskEditModal(true);
                          }}
                          // onSelect={(task) => {
                          //   if (task.type !== "project") return;

                          //   const stageId = task.id.replace("stage-", "");

                          //   setCollapsedStages((prev) => ({
                          //     ...prev,
                          //     [stageId]: !prev[stageId],
                          //   }));
                          // }}
                          todayColor="#ef4444"
                        />
                      )}

                      <StageModal
                        show={showStageModal}
                        onHide={() => {
                          setShowStageModal(false);
                          setEditingStage(null);
                        }}
                        stage={editingStage} // ✅ use same state
                        projectId={project?.projectId}
                        onStageSaved={() => {
                          loadProjectStages();
                        }}
                      />

                      <TaskEditModal
                        show={showTaskEditModal}
                        onHide={() => {
                          setShowTaskEditModal(false);
                          setEditingTaskId(null);
                        }}
                        taskId={editingTaskId}
                        onTaskUpdated={() => {
                          loadProjectTasksByStages(); // Refresh gantt data
                        }}
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            )}

            {activeTab === "sprint" && (
              <SprintTab
                orgId={orgId}
                projectId={project.projectId}
                userId={userId}
              />
            )}

            {activeTab === "remarks" && (
              <div className="project-view-fade-in">
                <Card>
                  <Card.Body>
                    <h5 className="mb-3">Project Remarks</h5>

                    {/* Add Remark */}
                    <div className="d-flex mb-3">
                      <Form.Control
                        as="textarea"
                        rows={2}
                        placeholder="Add a remark..."
                        value={remarkText}
                        onChange={(e) => setRemarkText(e.target.value)}
                      />
                      <Button
                        variant="primary"
                        className="ms-2"
                        onClick={handleAddRemark}
                        disabled={addingRemark}
                      >
                        {addingRemark ? "Adding..." : "Add"}
                      </Button>
                    </div>

                    {/* Remarks List */}
                    {remarksLoading ? (
                      <p>Loading remarks...</p>
                    ) : remarks.length === 0 ? (
                      <p className="text-muted">No remarks yet.</p>
                    ) : (
                      <div>
                        {(Array.isArray(remarks) ? remarks : []).map(
                          (remark, index) => (
                            <Card key={index} className="mb-2">
                              <Card.Body>
                                <div className="d-flex justify-content-between">
                                  <strong>{remark.createdBy}</strong>
                                  <small className="text-muted">
                                    {moment(
                                      remark.createdOnDate.split("T")[0] +
                                        " " +
                                        remark.createdOnTime,
                                    ).format("DD MMM YYYY HH:mm")}
                                  </small>
                                </div>
                                <div className="mt-2">{remark.remarks}</div>
                              </Card.Body>
                            </Card>
                          ),
                        )}
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </div>
            )}

            {activeTab === "events" && (
              <ProjectEvents orgId={orgId} projectId={projectId} />
            )}

            {activeTab === "tasks" && (
              <div className="project-view-fade-in">
                <div className="task-list-container">
                  <div className="task-list-header">
                    <div className="task-list-filters d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        {hasEditPermission() && (
                          <>
                            <div
                              className="project-dropdowns"
                              style={{ position: "relative" }}
                            >
                              <Button
                                size="sm"
                                onClick={() =>
                                  setShowTaskOptions(!showTaskOptions)
                                }
                                className="me-2"
                              >
                                Add Task
                              </Button>

                              {showTaskOptions && (
                                <>
                                  {/* Click outside overlay */}
                                  <div
                                    className="task-options-overlay"
                                    onClick={() => setShowTaskOptions(false)}
                                    style={{
                                      position: "fixed",
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      bottom: 0,
                                      zIndex: 1040,
                                      background: "transparent",
                                    }}
                                  />

                                  <div className="task-options-dropdown">
                                    <div className="task-options-content">
                                      <div
                                        className="task-option-item"
                                        onClick={handleExcelUploadClick}
                                      >
                                        <span>Task by Excel Upload</span>
                                      </div>
                                      <div
                                        className="task-option-item"
                                        onClick={handleManualTaskClick}
                                      >
                                        <span>Task by User</span>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>

                            <Button size="sm" onClick={handleCreateStage}>
                              Add Stage
                            </Button>
                          </>
                        )}
                      </div>

                      {/* Search input remains visible for all users */}
                      <div className="search-box ms-3 d-flex align-items-center">
                        <input
                          type="text"
                          className="form-control form-control-sm me-2"
                          placeholder="Search tasks by name..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          style={{ width: "220px" }}
                        />

                        {searchQuery && (
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => setSearchQuery("")}
                            title="Reset search"
                          >
                            <i className="fas fa-times"></i> Reset
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                  {tasksLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading tasks...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="stages-tabular-container">
                      {/* Render stages with tasks */}
                      {stages.map((stage) => (
                        <div
                          key={stage.stageId}
                          className="project-view-stage-section"
                        >
                          {/* Stage Header */}
                          <div className="project-view-stage-section-header">
                            <div className="project-view-stage-info">
                              <h4 className="project-view-stage-title">
                                {stage.stageName}
                              </h4>
                            </div>
                            <div className="project-view-stage-meta">
                              <Badge
                                bg="secondary"
                                className="task-count-badge"
                              >
                                {
                                  (filteredStageTasks[stage.stageId] || [])
                                    .length
                                }{" "}
                                tasks
                              </Badge>
                              {hasEditPermission() && (
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  onClick={() => handleEditStage(stage)}
                                  className="ms-2"
                                  title="Edit Stage"
                                >
                                  <i className="fas fa-edit"></i> Edit Stage
                                </Button>
                              )}
                            </div>
                          </div>
                          {/* Tasks Table for this Stage */}
                          <div className="project-view-stage-tasks-table">
                            {tasksLoadingByStage[stage.stageId] ? (
                              <div className="text-center py-3">
                                <div
                                  className="spinner-border spinner-border-sm text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading tasks...
                                  </span>
                                </div>
                              </div>
                            ) : filteredStageTasks[stage.stageId]?.length >
                              0 ? (
                              <div className="table-responsive">
                                <table className="project-view-task-table">
                                  <thead className="project-view-task-table-header">
                                    <tr>
                                      <th>TaskId</th>
                                      <th>Task Name</th>
                                      <th>Description</th>
                                      <th>Assigned To</th>
                                      <th>Ticket</th>
                                      <th>Event</th>
                                      <th>Building Block</th>
                                      <th>Priority</th>
                                      <th>Status</th>
                                      <th>Start Date</th>
                                      <th>End Date</th>

                                      <th>Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody className="project-view-task-table-body">
                                    {filteredStageTasks[stage.stageId].map(
                                      (task) => (
                                        <tr
                                          key={task.taskId}
                                          className="project-view-task-table-row"
                                        >
                                          <td>{task.taskId}</td>
                                          <td className="project-view-task-name-cell">
                                            <div
                                              className="project-view-task-name clickable-task-name"
                                              onClick={() =>
                                                handleTaskNameClick(task.taskId)
                                              }
                                              title="Click to view task details"
                                            >
                                              {task.taskName}
                                            </div>
                                          </td>
                                          <td className="project-view-task-description-cell">
                                            <div className="project-view-task-description">
                                              {task.taskDescription || "-"}
                                            </div>
                                          </td>
                                          <td className="project-view-task-assigned-cell">
                                            <div className="project-view-task-assignedd-flex flex-column gap-1">
                                              {/* Show multiple assignments */}
                                              {(() => {
                                                const currentAssignments =
                                                  getCurrentAssignedUsersForTask(
                                                    task.taskId,
                                                  );

                                                if (
                                                  currentAssignments.length ===
                                                  0
                                                ) {
                                                  return (
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <span className="text-muted">
                                                        Unassigned
                                                      </span>
                                                      <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() =>
                                                          openTaskDialog(task)
                                                        }
                                                        className="ms-2"
                                                        title="Manage Assignments"
                                                      >
                                                        Assign
                                                      </Button>
                                                    </div>
                                                  );
                                                }

                                                return (
                                                  <>
                                                    {currentAssignments.map(
                                                      (assignment, index) => {
                                                        const userDetail =
                                                          teamMemberDetails.find(
                                                            (user) =>
                                                              String(
                                                                user.userId,
                                                              ) ===
                                                              String(
                                                                assignment.assignedUserId,
                                                              ),
                                                          );
                                                        const userName =
                                                          userDetail?.username ||
                                                          assignment.assignedUserId;

                                                        return (
                                                          <div
                                                            key={
                                                              assignment.assignmentId ||
                                                              index
                                                            }
                                                            className="d-flex align-items-center justify-content-between"
                                                          >
                                                            <div className="d-flex align-items-center">
                                                              <span className="me-2">
                                                                {userName}
                                                              </span>
                                                              <Badge
                                                                bg={
                                                                  assignment.isActive
                                                                    ? "success"
                                                                    : "secondary"
                                                                }
                                                                size="sm"
                                                                className="assignment-status-badge"
                                                              >
                                                                {assignment.isPaused
                                                                  ? "Paused"
                                                                  : assignment.isActive
                                                                    ? "Active"
                                                                    : "Not Started"}
                                                              </Badge>
                                                              {assignment.totalHours && (
                                                                <small className="ms-2 text-muted">
                                                                  (
                                                                  {parseFloat(
                                                                    assignment.totalHours,
                                                                  ).toFixed(2)}
                                                                  h)
                                                                </small>
                                                              )}
                                                            </div>
                                                            {index === 0 && ( // Only show assign button on first item
                                                              <Button
                                                                variant="outline-primary"
                                                                size="sm"
                                                                onClick={() =>
                                                                  openTaskDialog(
                                                                    task,
                                                                  )
                                                                }
                                                                className="ms-2"
                                                                title="Manage Assignments"
                                                              >
                                                                Manage
                                                              </Button>
                                                            )}
                                                          </div>
                                                        );
                                                      },
                                                    )}

                                                    {/* Show count if there are more assignments */}
                                                    {taskAssignmentsByTask[
                                                      task.taskId
                                                    ]?.length >
                                                      currentAssignments.length && (
                                                      <small className="text-muted">
                                                        +
                                                        {taskAssignmentsByTask[
                                                          task.taskId
                                                        ].length -
                                                          currentAssignments.length}{" "}
                                                        more assignments
                                                      </small>
                                                    )}
                                                  </>
                                                );
                                              })()}
                                            </div>
                                          </td>
                                          <td>
                                            {task.taskTicketFor ? (
                                              <>
                                                <div className="fw-semibold">
                                                  {ticketNameMap[
                                                    task.taskTicketFor
                                                  ] || "Loading..."}
                                                </div>
                                                <small className="text-muted">
                                                  ({task.taskTicketFor})
                                                </small>
                                              </>
                                            ) : (
                                              "-"
                                            )}
                                          </td>
                                          <td>
                                            {task.taskEventFor ? (
                                              <>
                                                <div className="fw-semibold">
                                                  {eventNameMap[
                                                    task.taskEventFor
                                                  ] || "Loading..."}
                                                </div>
                                                <small className="text-muted">
                                                  ({task.taskEventFor})
                                                </small>
                                              </>
                                            ) : (
                                              "-"
                                            )}
                                          </td>

                                          <td className="project-view-task-buildingblock-cell">
                                            {taskBuildingBlocks[task.taskId] ? (
                                              <div>
                                                <span className="badge bg-info">
                                                  {
                                                    taskBuildingBlocks[
                                                      task.taskId
                                                    ].buildingBlockName
                                                  }
                                                </span>
                                                <br />
                                                <small className="text-muted">
                                                  ID:{" "}
                                                  {
                                                    taskBuildingBlocks[
                                                      task.taskId
                                                    ].buildingBlockId
                                                  }
                                                </small>
                                              </div>
                                            ) : (
                                              <span className="text-muted">
                                                Not assigned
                                              </span>
                                            )}
                                          </td>

                                          <td className="project-view-task-priority-cell">
                                            <span
                                              className={`project-view-task-priority-badge ${getPriorityBadge(
                                                task.taskPriority,
                                              )}`}
                                            >
                                              {task.taskPriority ||
                                                "No Priority"}
                                            </span>
                                          </td>
                                          <td className="project-view-task-status-cell">
                                            <span
                                              className={`project-view-task-status-badge ${getStatusBadge(
                                                getTaskStatusName(
                                                  task.taskStatus,
                                                ),
                                              )}`}
                                            >
                                              {getTaskStatusName(
                                                task.taskStatus,
                                              )}
                                            </span>
                                          </td>
                                          <td className="project-view-task-date-cell">
                                            {moment(task.taskStartDate).format(
                                              "MMM DD, YYYY",
                                            )}
                                          </td>
                                          <td className="project-view-task-date-cell">
                                            {moment(task.taskEndDate).format(
                                              "MMM DD, YYYY",
                                            )}
                                          </td>
                                          <td className="project-view-task-actions-cell">
                                            <div className="project-view-task-actions">
                                              {hasEditPermission() ? (
                                                <>
                                                  <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={() =>
                                                      handleEditTask(
                                                        task.taskId,
                                                      )
                                                    }
                                                    className="me-2"
                                                    title="Edit Task"
                                                  >
                                                    Edit
                                                  </Button>
                                                  <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    title="Delete Task"
                                                  >
                                                    Delete
                                                  </Button>
                                                </>
                                              ) : (
                                                <small className="text-muted">
                                                  View Only
                                                </small>
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            ) : (
                              <div className="text-center py-4 text-muted">
                                <i className="fas fa-tasks fa-2x mb-3"></i>
                                <p>No tasks found in this stage.</p>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}

                      {/* Render "No Stage" section if there are tasks without stage */}
                      {/* Render "No Stage" section if there are tasks without stage */}
                      {filteredStageTasks["no-stage"]?.length > 0 && (
                        <div
                          key="no-stage"
                          className="project-view-stage-section project-view-no-stage-section"
                        >
                          {/* No Stage Header */}
                          <div className="project-view-stage-section-header project-view-no-stage-header">
                            <div className="project-view-stage-info">
                              <h4
                                className="project-view-stage-title"
                                style={{ padding: "10px" }}
                              >
                                <i className="fas fa-question-circle me-2 text-warning"></i>
                                No Stage Assigned
                              </h4>
                            </div>
                            <div className="project-view-stage-meta">
                              <Badge bg="warning" className="task-count-badge">
                                {filteredStageTasks["no-stage"].length} tasks
                              </Badge>
                            </div>
                          </div>

                          {/* Tasks Table for No Stage */}
                          <div className="project-view-stage-tasks-table">
                            {tasksLoadingByStage["no-stage"] ? (
                              <div className="text-center py-3">
                                <div
                                  className="spinner-border spinner-border-sm text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading tasks...
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div className="table-responsive">
                                <table className="project-view-task-table">
                                  <thead className="project-view-task-table-header">
                                    <tr>
                                      <th>TaskId</th>
                                      <th>Task Name</th>
                                      <th>Description</th>
                                      <th>Assigned To</th>
                                      <th>Priority</th>
                                      <th>Status</th>
                                      <th>Start Date</th>
                                      <th>End Date</th>
                                      <th>Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody className="project-view-task-table-body">
                                    {filteredStageTasks["no-stage"].map(
                                      (task) => (
                                        <tr
                                          key={task.taskId}
                                          className="project-view-task-table-row"
                                        >
                                          <td>{task.taskId}</td>
                                          <td className="project-view-task-name-cell">
                                            <div
                                              className="project-view-task-name clickable-task-name"
                                              onClick={() =>
                                                handleTaskNameClick(task.taskId)
                                              }
                                              title="Click to view task details"
                                            >
                                              {task.taskName}
                                            </div>
                                          </td>
                                          <td className="project-view-task-description-cell">
                                            <div className="project-view-task-description">
                                              {task.taskDescription || "-"}
                                            </div>
                                          </td>
                                          <td className="project-view-task-assigned-cell">
                                            <div className="project-view-task-assignedd-flex flex-column gap-1">
                                              {(() => {
                                                const currentAssignments =
                                                  getCurrentAssignedUsersForTask(
                                                    task.taskId,
                                                  );

                                                if (
                                                  currentAssignments.length ===
                                                  0
                                                ) {
                                                  return (
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <span className="text-muted">
                                                        Unassigned
                                                      </span>
                                                      {hasEditPermission() && (
                                                        <Button
                                                          variant="outline-primary"
                                                          size="sm"
                                                          onClick={() =>
                                                            openTaskDialog(task)
                                                          }
                                                          className="ms-2"
                                                          title="Manage Assignments"
                                                        >
                                                          Assign
                                                        </Button>
                                                      )}
                                                    </div>
                                                  );
                                                }

                                                return (
                                                  <>
                                                    {currentAssignments.map(
                                                      (assignment, index) => {
                                                        const userDetail =
                                                          teamMemberDetails.find(
                                                            (user) =>
                                                              String(
                                                                user.userId,
                                                              ) ===
                                                              String(
                                                                assignment.assignedUserId,
                                                              ),
                                                          );
                                                        const userName =
                                                          userDetail?.username ||
                                                          assignment.assignedUserId;

                                                        return (
                                                          <div
                                                            key={
                                                              assignment.assignmentId ||
                                                              index
                                                            }
                                                            className="d-flex align-items-center justify-content-between"
                                                          >
                                                            <div className="d-flex align-items-center">
                                                              <span className="me-2">
                                                                {userName}
                                                              </span>
                                                              <Badge
                                                                bg={
                                                                  assignment.isActive
                                                                    ? "success"
                                                                    : "secondary"
                                                                }
                                                                size="sm"
                                                                className="assignment-status-badge"
                                                              >
                                                                {assignment.isPaused
                                                                  ? "Paused"
                                                                  : assignment.isActive
                                                                    ? "Active"
                                                                    : "Not Started"}
                                                              </Badge>
                                                              {assignment.totalHours && (
                                                                <small className="ms-2 text-muted">
                                                                  (
                                                                  {parseFloat(
                                                                    assignment.totalHours,
                                                                  ).toFixed(2)}
                                                                  h)
                                                                </small>
                                                              )}
                                                            </div>
                                                            {index === 0 &&
                                                              hasEditPermission() && (
                                                                <Button
                                                                  variant="outline-primary"
                                                                  size="sm"
                                                                  onClick={() =>
                                                                    openTaskDialog(
                                                                      task,
                                                                    )
                                                                  }
                                                                  className="ms-2"
                                                                  title="Manage Assignments"
                                                                >
                                                                  Manage
                                                                </Button>
                                                              )}
                                                          </div>
                                                        );
                                                      },
                                                    )}

                                                    {taskAssignmentsByTask[
                                                      task.taskId
                                                    ]?.length >
                                                      currentAssignments.length && (
                                                      <small className="text-muted">
                                                        +
                                                        {taskAssignmentsByTask[
                                                          task.taskId
                                                        ].length -
                                                          currentAssignments.length}{" "}
                                                        more assignments
                                                      </small>
                                                    )}
                                                  </>
                                                );
                                              })()}
                                            </div>
                                          </td>
                                          <td className="project-view-task-priority-cell">
                                            <span
                                              className={`project-view-task-priority-badge ${getPriorityBadge(
                                                task.taskPriority,
                                              )}`}
                                            >
                                              {task.taskPriority ||
                                                "No Priority"}
                                            </span>
                                          </td>
                                          <td className="project-view-task-status-cell">
                                            <span
                                              className={`project-view-task-status-badge ${getStatusBadge(
                                                task.taskStatus, // Pass the GUID directly to getStatusBadge
                                              )}`}
                                            >
                                              {getTaskStatusName(
                                                task.taskStatus,
                                              )}{" "}
                                            </span>
                                          </td>
                                          <td className="project-view-task-date-cell">
                                            {moment(task.taskStartDate).format(
                                              "MMM DD, YYYY",
                                            )}
                                          </td>
                                          <td className="project-view-task-date-cell">
                                            {moment(task.taskEndDate).format(
                                              "MMM DD, YYYY",
                                            )}
                                          </td>
                                          <td className="project-view-task-actions-cell">
                                            <div className="project-view-task-actions">
                                              {hasEditPermission() ? (
                                                <>
                                                  <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={() =>
                                                      handleEditTask(
                                                        task.taskId,
                                                      )
                                                    }
                                                    className="me-2"
                                                    title="Edit Task"
                                                  >
                                                    Edit
                                                  </Button>
                                                  <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    title="Delete Task"
                                                  >
                                                    Delete
                                                  </Button>
                                                </>
                                              ) : (
                                                <small className="text-muted">
                                                  View Only
                                                </small>
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {/* Show message if no stages and no tasks without stage */}
                      {stages.length === 0 &&
                        !filteredStageTasks["no-stage"]?.length && (
                          <div className="text-center py-4 text-muted">
                            <i className="fas fa-columns fa-2x mb-3"></i>
                            <p>No stages found for this project.</p>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={handleCreateStage}
                            >
                              Create First Stage
                            </Button>
                          </div>
                        )}

                      {/* Show message if there are stages but no tasks at all (including no-stage) */}
                      {stages.length > 0 &&
                        !filteredStageTasks["no-stage"]?.length &&
                        stages.every(
                          (stage) => !filteredStageTasks[stage.stageId]?.length,
                        ) && (
                          <div className="text-center py-4 text-muted">
                            <i className="fas fa-tasks fa-2x mb-3"></i>
                            <p>No tasks found in any stage.</p>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() =>
                                navigate(
                                  `/addTask?projectId=${project.projectId}`,
                                )
                              }
                            >
                              Add Your First Task
                            </Button>
                          </div>
                        )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "team" && (
              <div className="project-view-fade-in">
                <div className="project-overview-single-card">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    {/* <h3 className="project-view-overview-section-title">Team Details</h3> */}
                    {loadingTeamMembers && (
                      <div className="text-muted">
                        <small>Loading team members...</small>
                      </div>
                    )}
                  </div>

                  {teamData ? (
                    <div className="project-view-team-details-container">
                      <div className="project-view-overview-grid">
                        <div className="project-view-overview-row">
                          <span className="project-view-overview-label">
                            Team Name:
                          </span>
                          <span className="project-view-overview-value">
                            {teamData.teamName}
                          </span>
                          <span className="project-view-overview-label">
                            Team ID:
                          </span>
                          <span className="project-view-overview-value">
                            {teamData.teamId}
                          </span>
                        </div>

                        {/* Team Members Section */}
                        <div
                          className="project-view-overview-row"
                          style={{ display: "block" }}
                        >
                          <span className="project-view-overview-label">
                            Team Members:
                          </span>
                          <div className="team-members-grid mt-3">
                            {teamData.teamMembers &&
                            teamData.teamMembers.length > 0 ? (
                              teamData.teamMembers.map((memberId, index) => {
                                const userInfo = getUserDisplayInfo(memberId);
                                return (
                                  <div key={index} className="team-member-card">
                                    <div className="project-view-team-member-avatar">
                                      <i className="fas fa-user"></i>
                                    </div>
                                    <div className="team-member-info">
                                      <div className="team-member-name">
                                        {userInfo.name}
                                      </div>
                                      <div className="team-member-email">
                                        {userInfo.email}
                                      </div>
                                      <div className="team-member-id">
                                        <small className="text-muted">
                                          ID: {memberId}
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="text-center py-4 text-muted">
                                <i className="fas fa-users fa-2x mb-3"></i>
                                <p>No team members found</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <div className="no-team-placeholder">
                        <i className="fas fa-users fa-3x text-muted mb-3"></i>
                        <h5 className="text-muted">No Team Assigned</h5>
                        <p className="text-muted mb-3">
                          This project doesn't have a team assigned yet.
                        </p>
                        {/* <Button variant="outline-primary" size="sm">
                          <i className="fas fa-plus me-2"></i>
                          Assign Team
                        </Button> */}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "ticket" && (
              <div className="project-view-fade-in">
                <div className="project-view-ticket-list-container">
                  <div className="ticket-list-header">
                    <h4 className="ticket-list-title">Project Tickets</h4>
                    <div
                      className="ticket-list-filters d-flex gap-2 flex-wrap"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "50vw",
                      }}
                    >
                      <span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search ticket name or description..."
                          style={{ maxWidth: "250px" }}
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                      </span>
                      <span style={{ width: "10vw" }}>
                        <select
                          className="form-select"
                          style={{ maxWidth: "180px" }}
                          value={statusFilter}
                          onChange={(e) => setStatusFilter(e.target.value)}
                        >
                          <option value="">All Status</option>
                          <option value="Open">Open</option>
                          <option value="In Progress">In Progress</option>
                          <option value="Resolved">Resolved</option>
                          <option value="Closed">Closed</option>
                        </select>
                      </span>
                      <span style={{ width: "10vw" }}>
                        <select
                          className="form-select"
                          style={{ maxWidth: "180px" }}
                          value={priorityFilter}
                          onChange={(e) => setPriorityFilter(e.target.value)}
                        >
                          <option value="">All Priority</option>
                          <option value="Low">Low</option>
                          <option value="Medium">Medium</option>
                          <option value="High">High</option>
                          <option value="Critical">Critical</option>
                        </select>
                      </span>

                      {/* CLEAR FILTER */}
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => {
                          setSearchText("");
                          setStatusFilter("");
                          setPriorityFilter("");
                        }}
                      >
                        Clear
                      </Button>
                    </div>
                  </div>

                  {ticketsLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading tickets...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="ticket-table-container">
                      {filteredTickets.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                          <i className="fas fa-ticket-alt fa-3x mb-3"></i>
                          <h5>No Tickets Found</h5>
                          <p className="mb-4">
                            There are no tickets associated with this project.
                          </p>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() =>
                              navigate(
                                `/addTicket?projectId=${project.projectId}`,
                              )
                            }
                          >
                            <i className="fas fa-plus me-2"></i>
                            Create First Ticket
                          </Button>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="project-view-ticket-table">
                            <thead className="project-view-ticket-table-header">
                              <tr>
                                <th>Ticket ID</th>
                                <th>Ticket Name</th>
                                <th>Description</th>
                                <th>Status</th>
                                <th>Priority</th>
                                <th>Created By</th>
                                <th>Assigned To</th>
                                <th>Category</th>
                                <th>Created Date</th>
                                <th>Due Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody className="ticket-table-body">
                              {filteredTickets.map((ticket) => (
                                <tr
                                  key={ticket.ticketId}
                                  className="ticket-table-row"
                                >
                                  <td className="ticket-id-cell">
                                    <div className="ticket-id">
                                      {ticket.ticketId}
                                    </div>
                                  </td>
                                  <td className="ticket-name-cell">
                                    <div className="ticket-name">
                                      {ticket.ticketName}
                                    </div>
                                  </td>
                                  <td className="ticket-description-cell">
                                    <div className="ticket-description">
                                      {ticket.description
                                        ? ticket.description.length > 100
                                          ? `${ticket.description.substring(
                                              0,
                                              100,
                                            )}...`
                                          : ticket.description
                                        : "-"}
                                    </div>
                                  </td>
                                  <td className="ticket-status-cell">
                                    <span
                                      className={`ticket-status-badge ${getStatusBadge(
                                        ticket.status,
                                      )}`}
                                    >
                                      {ticket.status}
                                    </span>
                                  </td>
                                  <td className="ticket-priority-cell">
                                    <span
                                      className={`project-view-ticket-priority-badge ${getPriorityBadge(
                                        ticket.priority,
                                      )}`}
                                    >
                                      {ticket.priority}
                                    </span>
                                  </td>
                                  <td className="ticket-createdby-cell">
                                    <div className="ticket-createdby">
                                      {ticket.createdBy}
                                    </div>
                                  </td>
                                  <td className="ticket-assignedto-cell">
                                    <div className="ticket-assignedto d-flex flex-column gap-1">
                                      {(() => {
                                        const currentAssignments =
                                          assignmentsByTicket[
                                            ticket.ticketId
                                          ] || [];

                                        if (currentAssignments.length === 0) {
                                          return (
                                            <div className="d-flex align-items-center justify-content-between">
                                              <span className="text-muted">
                                                Unassigned
                                              </span>
                                              <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={() =>
                                                  openTicketDialog(ticket)
                                                }
                                                className="ms-2"
                                                title="Assign user"
                                              >
                                                Assign
                                              </Button>
                                            </div>
                                          );
                                        }

                                        return (
                                          <>
                                            {currentAssignments.map(
                                              (assignment, index) => {
                                                const userDetail =
                                                  teamMemberDetails.find(
                                                    (user) =>
                                                      String(user.userId) ===
                                                      String(
                                                        assignment.assignedUserId,
                                                      ),
                                                  );
                                                const userName =
                                                  userDetail?.username ||
                                                  assignment.assignedUserId;

                                                return (
                                                  <div
                                                    key={
                                                      assignment.assignmentId ||
                                                      index
                                                    }
                                                    className="d-flex align-items-center justify-content-between"
                                                  >
                                                    <div className="d-flex align-items-center">
                                                      <span className="me-2">
                                                        {userName}
                                                      </span>
                                                      <Badge
                                                        bg={
                                                          assignment.isActive
                                                            ? "success"
                                                            : "secondary"
                                                        }
                                                        className="assignment-status-badge"
                                                      >
                                                        {assignment.isActive
                                                          ? "Active"
                                                          : "Completed"}
                                                      </Badge>
                                                      {assignment.totalHours && (
                                                        <small className="ms-2 text-muted">
                                                          (
                                                          {parseFloat(
                                                            assignment.totalHours,
                                                          ).toFixed(2)}
                                                          h)
                                                        </small>
                                                      )}
                                                    </div>

                                                    {/* Only show manage button on first user line */}
                                                    {index === 0 && (
                                                      <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() =>
                                                          openTicketDialog(
                                                            ticket,
                                                          )
                                                        }
                                                        className="ms-2"
                                                        title="Manage Assignments"
                                                      >
                                                        Manage
                                                      </Button>
                                                    )}
                                                  </div>
                                                );
                                              },
                                            )}

                                            {currentAssignments.length > 2 && (
                                              <small className="text-muted">
                                                +{currentAssignments.length - 2}{" "}
                                                more assignments
                                              </small>
                                            )}
                                          </>
                                        );
                                      })()}
                                    </div>
                                  </td>

                                  <td className="ticket-category-cell">
                                    <div className="ticket-category">
                                      {ticket.category || "-"}
                                    </div>
                                  </td>
                                  <td className="ticket-date-cell">
                                    {formatDateTime(ticket.ticketTime)}
                                  </td>
                                  <td className="ticket-date-cell">
                                    {formatDate(ticket.dueDate)}
                                  </td>
                                  <td className="ticket-actions-cell">
                                    <div className="ticket-actions">
                                      <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        className="me-1"
                                        onClick={() => openTicketDialog(ticket)}
                                        title="Open Ticket Details"
                                      >
                                        Open
                                      </Button>

                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() =>
                                          handleConvertToTask(ticket)
                                        }
                                        title="Convert to Task"
                                        className="me-1"
                                      >
                                        Convert to Task
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "workflow" && (
              <div className="project-view-fade-in">
                <div className="project-overview-single-card">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="project-view-overview-section-title">
                      Task Templates
                    </h3>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={handleCreateTemplate}
                    >
                      {/* <i className="fas fa-plus me-2"></i> */}
                      Create Template
                    </Button>
                  </div>

                  {/* Task Templates List */}
                  <div className="templates-container">
                    {templatesLoading ? (
                      <div className="text-center py-4">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">
                            Loading templates...
                          </span>
                        </div>
                      </div>
                    ) : templates.length === 0 ? (
                      <div className="text-center py-5 text-muted">
                        <i className="fas fa-clipboard-list fa-3x mb-3"></i>
                        <h5>No Task Templates</h5>
                        <p>
                          Create your first task template to streamline task
                          creation.
                        </p>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={handleCreateTemplate}
                        >
                          {/* <i className="fas fa-plus me-2"></i> */}
                          Create Your First Template
                        </Button>
                      </div>
                    ) : (
                      <div className="row">
                        {templates.map((template) => (
                          <div
                            key={template.templateId}
                            className="col-md-6 mb-3"
                          >
                            <Card className="template-card h-100">
                              <Card.Body>
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                  <Card.Title className="h6 mb-0">
                                    {template.templateName}
                                  </Card.Title>
                                  <div className="template-actions">
                                    <Button
                                      variant="outline-primary"
                                      size="sm"
                                      className="me-1"
                                      onClick={() =>
                                        handleEditTemplate(template)
                                      }
                                      title="Edit Template"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </Button>
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      onClick={() =>
                                        handleDeleteTemplate(
                                          template.templateId,
                                        )
                                      }
                                      title="Delete Template"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </Button>
                                  </div>
                                </div>

                                {template.templateDescription && (
                                  <Card.Text className="text-muted small mb-2">
                                    {template.templateDescription}
                                  </Card.Text>
                                )}

                                <div className="template-fields">
                                  <small className="text-muted">
                                    <strong>Fields included:</strong>{" "}
                                    {
                                      Object.keys(template.includeFields || {})
                                        .length
                                    }
                                  </small>
                                  <div className="field-tags mt-1">
                                    {Object.keys(
                                      template.includeFields || {},
                                    ).map((fieldName) => (
                                      <span
                                        key={fieldName}
                                        className="badge bg-light text-dark me-1 mb-1"
                                      >
                                        {getFieldDisplayName(fieldName)}
                                      </span>
                                    ))}
                                  </div>
                                </div>

                                <div className="template-footer mt-3 pt-2 border-top">
                                  <small className="text-muted">
                                    Created:{" "}
                                    {moment(template.createdOnDate).format(
                                      "MMM DD, YYYY",
                                    )}
                                  </small>
                                </div>
                              </Card.Body>
                            </Card>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {activeTab === "documents" && (
              <div className="project-view-fade-in">
                <div className="project-overview-single-card">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h3 className="project-view-overview-section-title mb-1">
                        Project Documents
                      </h3>
                      <p className="text-muted mb-0">
                        Manage all documents related to this project
                      </p>
                    </div>
                    <Button
                      variant="primary"
                      onClick={() => setShowUploadModal(true)}
                    >
                      {/* <i className="fas fa-upload me-2"></i> */}
                      Upload Documents
                    </Button>
                  </div>

                  {documentsLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading documents...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="documents-container">
                      {documents.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                          <i className="fas fa-folder-open fa-3x mb-3"></i>
                          <h5>No Documents Found</h5>
                          <p className="mb-4">
                            No documents have been uploaded for this project
                            yet.
                          </p>
                          <Button
                            variant="outline-primary"
                            onClick={() => setShowUploadModal(true)}
                          >
                            {/* <i className="fas fa-upload me-2"></i> */}
                            Upload Your First Document
                          </Button>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="project-view-document-table">
                            <thead className="project-view-document-table-header">
                              <tr>
                                <th>Document Name</th>
                                <th>Type</th>
                                <th>Version</th>
                                <th>Uploaded By</th>
                                <th>Upload Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody className="document-table-body">
                              {documents.map((doc) => (
                                <tr
                                  key={doc.documentId}
                                  className="project-view-document-table-row"
                                >
                                  <td className="document-name-cell">
                                    <div className="document-name">
                                      <i className="fas fa-file me-2 text-primary"></i>
                                      {doc.documentTitle}
                                    </div>
                                  </td>
                                  <td className="document-type-cell">
                                    <Badge
                                      bg="secondary"
                                      className="document-type-badge"
                                    >
                                      {doc.documentType}
                                    </Badge>
                                  </td>
                                  <td className="document-version-cell">
                                    <div className="document-version">
                                      v{doc.documentVersion}
                                    </div>
                                  </td>
                                  <td className="document-uploadedby-cell">
                                    <div className="document-uploadedby">
                                      {doc.createdBy || "Unknown"}
                                    </div>
                                  </td>
                                  <td className="document-date-cell">
                                    {doc.createdOnDate
                                      ? moment(doc.createdOnDate).format(
                                          "MMM DD, YYYY",
                                        )
                                      : "-"}
                                  </td>

                                  <td className="document-actions-cell">
                                    <div className="document-actions">
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() =>
                                          handleDownloadDocument(doc)
                                        }
                                        className="me-2"
                                        title="Download Document"
                                      >
                                        Download
                                      </Button>
                                      <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() =>
                                          handleDeleteDocument(
                                            doc.documentId,
                                            doc.documentTitle,
                                          )
                                        }
                                        title="Delete Document"
                                      >
                                        Delete
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Upload Document Modal */}
                <Modal
                  show={showUploadModal}
                  onHide={() => setShowUploadModal(false)}
                  size="lg"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Upload Documents</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <Form.Group className="mb-3">
                        <Form.Label>Document Title</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter document title"
                          value={documentTitle}
                          onChange={(e) => setDocumentTitle(e.target.value)}
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Document Type</Form.Label>
                        <Form.Select
                          value={documentType}
                          onChange={(e) => setDocumentType(e.target.value)}
                        >
                          <option value="">-- Select Document Type --</option>
                          <option value="Report">Report</option>
                          <option value="Invoice">Invoice</option>
                          <option value="Contract">Contract</option>

                          <option value="Presentation">Presentation</option>

                          <option value="PO">PO</option>
                          <option value="SOW">SOW</option>
                          <option value="Proposal">Proposal</option>
                          <option value="WSR">WSR</option>
                          <option value="Project Plan">Project Plan</option>
                          <option value="Other">Other</option>
                        </Form.Select>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Select Files</Form.Label>
                        <Form.Control
                          type="file"
                          multiple
                          onChange={handleFileSelect}
                          accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.txt,.zip,.rar"
                        />
                        <Form.Text className="text-muted">
                          Maximum file size: 25MB per file. Supported formats:
                          PDF, Word, Excel, PowerPoint, Images, Text, Archives
                        </Form.Text>
                      </Form.Group>

                      {selectedFiles.length > 0 && (
                        <div className="selected-files-list">
                          <h6>Selected Files ({selectedFiles.length}):</h6>
                          <ul className="list-group">
                            {selectedFiles.map((file, index) => (
                              <li
                                key={index}
                                className="list-group-item d-flex justify-content-between align-items-center"
                              >
                                <div>
                                  <i className="fas fa-file me-2 text-primary"></i>
                                  {file.name}
                                </div>
                                <Badge bg="light" text="dark">
                                  {(file.size / (1024 * 1024)).toFixed(2)} MB
                                </Badge>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </Form>
                  </Modal.Body>

                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setShowUploadModal(false);
                        setSelectedFiles([]);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      onClick={handleUploadDocuments}
                      disabled={
                        selectedFiles.length === 0 || uploadingDocuments
                      }
                    >
                      {uploadingDocuments ? (
                        <>
                          <div
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          >
                            <span className="visually-hidden">
                              Uploading...
                            </span>
                          </div>
                          Uploading...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-upload me-2"></i>
                          Upload {selectedFiles.length} File(s)
                        </>
                      )}
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            )}

            {activeTab === "partner" && (
              <div className="project-view-fade-in">
                <div className="project-overview-single-card">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h3 className="project-view-overview-section-title mb-1">
                        Project Partners
                      </h3>
                      <p className="text-muted mb-0">
                        Manage partners associated with this project
                      </p>
                    </div>
                    {/* Only show Add button for Admin and Manager */}
                    {(hasProjectAdminRole() || hasProjectManagerRole()) && (
                      <Button variant="primary" onClick={handleCreatePartner}>
                        Add Partner
                      </Button>
                    )}
                  </div>

                  {partnersLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading partners...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="partners-container">
                      {partners.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                          <i className="fas fa-handshake fa-3x mb-3"></i>
                          <h5>No Partners Found</h5>
                          <p className="mb-4">
                            No partners are associated with this project yet.
                          </p>
                          {/* Only show Add button for Admin and Manager */}
                          {(hasProjectAdminRole() ||
                            hasProjectManagerRole()) && (
                            <Button
                              variant="outline-primary"
                              onClick={handleCreatePartner}
                            >
                              <i className="fas fa-plus me-2"></i>
                              Add Your First Partner
                            </Button>
                          )}
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="project-view-partner-table">
                            <thead className="project-view-partner-table-header">
                              <tr>
                                <th>Partner ID</th>
                                <th>Name</th>
                                <th>Contact Persons</th>
                                <th>Created By</th>
                                <th>Created Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody className="project-view-partner-table-body">
                              {partners.map((partner) => (
                                <tr
                                  key={partner.partnerId}
                                  className="partner-table-row"
                                >
                                  <td className="partner-id-cell">
                                    <div className="partner-id">
                                      {partner.partnerId}
                                    </div>
                                  </td>
                                  <td className="partner-name-cell">
                                    <div className="partner-name">
                                      {vendorMap[partner.partnerName]
                                        ? `${
                                            vendorMap[partner.partnerName].name
                                          } (${
                                            vendorMap[partner.partnerName]
                                              .vendorCode
                                          })`
                                        : partner.partnerName}
                                    </div>
                                  </td>

                                  <td className="partner-contacts-cell">
                                    {loadingVendorContacts[
                                      partner.partnerName
                                    ] ? (
                                      <small className="text-muted">
                                        Loading...
                                      </small>
                                    ) : vendorContactsMap[partner.partnerName]
                                        ?.length > 0 ? (
                                      <ul className="list-unstyled mb-0">
                                        {vendorContactsMap[
                                          partner.partnerName
                                        ].map((cp) => (
                                          <li
                                            key={cp.cusVenId}
                                            className="mb-1"
                                          >
                                            <strong>{cp.contactPerName}</strong>
                                            <br />
                                            <small className="text-muted">
                                              📞 {cp.contactPerNumber || "-"} |
                                              ✉️ {cp.contactPerEmail || "-"}
                                            </small>
                                          </li>
                                        ))}
                                      </ul>
                                    ) : (
                                      <small className="text-muted">
                                        No contacts
                                      </small>
                                    )}
                                  </td>

                                  <td className="partner-createdby-cell">
                                    <div className="partner-createdby">
                                      {partner.createdBy || "-"}
                                    </div>
                                  </td>
                                  <td className="partner-date-cell">
                                    {partner.createdOnDate
                                      ? moment(partner.createdOnDate).format(
                                          "MMM DD, YYYY",
                                        )
                                      : "-"}
                                  </td>
                                  <td className="partner-actions-cell">
                                    <div className="partner-actions">
                                      {/* Only show Edit button for Admin and Manager */}
                                      {(hasProjectAdminRole() ||
                                        hasProjectManagerRole()) && (
                                        <Button
                                          variant="outline-primary"
                                          size="sm"
                                          onClick={() =>
                                            handleEditPartner(partner)
                                          }
                                          className="me-2"
                                          title="Edit Partner"
                                        >
                                          Edit
                                        </Button>
                                      )}
                                      {/* Only show Delete button for Admin and Manager */}
                                      {(hasProjectAdminRole() ||
                                        hasProjectManagerRole()) && (
                                        <Button
                                          variant="outline-danger"
                                          size="sm"
                                          title="Delete Partner"
                                        >
                                          Trash
                                        </Button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "commercials" && (
              <div className="project-view-fade-in">
                <div className="project-overview-single-card">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    {/* <div>
          <h3 className="project-view-overview-section-title mb-1">
            Project Commercials
          </h3>
          <p className="text-muted mb-0">
            Manage commercial information and revenue projections
          </p>
        </div> */}
                    {/* Only show Add button for Admin and Manager */}
                    {(hasProjectAdminRole() || hasProjectManagerRole()) && (
                      <Button
                        variant="primary"
                        onClick={handleCreateCommercial}
                      >
                        Add Commercial
                      </Button>
                    )}
                  </div>

                  {commercialsLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading commercials...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="commercials-container">
                      {commercials.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                          <i className="fas fa-chart-line fa-3x mb-3"></i>
                          <h5>No Commercials Found</h5>
                          <p className="mb-4">
                            No commercial information is available for this
                            project yet.
                          </p>
                          {/* Only show Add button for Admin and Manager */}
                          {(hasProjectAdminRole() ||
                            hasProjectManagerRole()) && (
                            <Button
                              variant="outline-primary"
                              onClick={handleCreateCommercial}
                            >
                              Add Your First Commercial
                            </Button>
                          )}
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="project-view-commercial-table">
                            <thead className="project-view-commercial-table-header">
                              <tr>
                                <th>Commercial ID</th>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Planned Revenue</th>
                                <th>Type</th>
                                <th>Currency</th>
                                <th>Created By</th>
                                <th>Created Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody className="project-view-commercial-table-body">
                              {commercials.map((commercial) => (
                                <tr
                                  key={commercial.commercialId}
                                  className="commercial-table-row"
                                >
                                  <td className="commercial-id-cell">
                                    <div className="commercial-id">
                                      {commercial.commercialId}
                                    </div>
                                  </td>
                                  <td className="commercial-title-cell">
                                    <div className="commercial-title">
                                      {commercial.commercialTitle}
                                    </div>
                                  </td>
                                  <td className="commercial-description-cell">
                                    <div className="commercial-description">
                                      {commercial.commercialDescription || "-"}
                                    </div>
                                  </td>

                                  <td className="commercial-revenue-cell">
                                    <div className="commercial-revenue">
                                      {formatCurrencyDisplay(
                                        commercial.commercialPlannedRevenue,
                                        commercial.commercialCurrency,
                                      )}
                                    </div>
                                  </td>
                                  <td className="commercial-type-cell">
                                    <div className="commercial-type">
                                      {commercial.commercialType || "-"}
                                    </div>
                                  </td>
                                  <td className="commercial-currency-cell">
                                    <div className="commercial-currency">
                                      {commercial.commercialCurrency || "-"}
                                    </div>
                                  </td>
                                  <td className="commercial-createdby-cell">
                                    <div className="commercial-createdby">
                                      {commercial.createdBy || "-"}
                                    </div>
                                  </td>
                                  <td className="commercial-date-cell">
                                    {commercial.createdOnDate
                                      ? moment(commercial.createdOnDate).format(
                                          "MMM DD, YYYY",
                                        )
                                      : "-"}
                                  </td>
                                  <td className="commercial-actions-cell">
                                    <div className="commercial-actions">
                                      {/* Only show Edit button for Admin and Manager */}
                                      {(hasProjectAdminRole() ||
                                        hasProjectManagerRole()) && (
                                        <Button
                                          variant="outline-primary"
                                          size="sm"
                                          onClick={() =>
                                            handleEditCommercial(commercial)
                                          }
                                          className="me-2"
                                          title="Edit Commercial"
                                          style={{ padding: "6px" }}
                                        >
                                          Edit
                                        </Button>
                                      )}
                                      {/* Only show Delete button for Admin and Manager */}
                                      {(hasProjectAdminRole() ||
                                        hasProjectManagerRole()) && (
                                        <Button
                                          variant="outline-danger"
                                          size="sm"
                                          title="Delete Commercial"
                                          style={{ padding: "6px" }}
                                        >
                                          Delete
                                        </Button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "milestone" && (
              <div className="project-view-fade-in">
                <div className="project-overview-single-card">
                  <div
                    className="d-flex justify-content-between align-items-center mb-4"
                    style={{ margin: "15px" }}
                  >
                    <div>
                      <h3 className="project-view-overview-section-title mb-1">
                        Project Milestones
                      </h3>
                      <p className="text-muted mb-0">
                        Track and manage project milestones and deliverables
                      </p>
                    </div>
                    {/* Only show Add button for Admin and Manager */}
                    {(hasProjectAdminRole() || hasProjectManagerRole()) && (
                      <Button variant="primary" onClick={handleCreateMilestone}>
                        Add Milestone
                      </Button>
                    )}
                  </div>

                  {milestonesLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading milestones...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="milestones-container">
                      {milestones.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                          <i className="fas fa-flag fa-3x mb-3"></i>
                          <h5>No Milestones Found</h5>
                          <p className="mb-4">
                            No milestones are defined for this project yet.
                          </p>
                          {/* Only show Add button for Admin and Manager */}
                          {(hasProjectAdminRole() ||
                            hasProjectManagerRole()) && (
                            <Button
                              variant="outline-primary"
                              onClick={handleCreateMilestone}
                            >
                              Add Your First Milestone
                            </Button>
                          )}
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="project-view-milestone-table">
                            <thead className="project-view-milestone-table-header">
                              <tr>
                                <th style={{ width: "40px" }}>Drop</th>
                                <th>Milestone ID</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Percentage</th>
                                <th>Planned Dates</th>
                                <th>Actual Dates</th>
                                <th>Status</th>
                                <th>Description</th>
                                <th>Created By</th>
                                <th>Created Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody className="milestone-table-body">
                              {milestones.map((milestone) => (
                                <React.Fragment
                                  key={milestone.milestoneMavroId}
                                >
                                  <tr className="milestone-table-row">
                                    <td className="milestone-expand-cell">
                                      <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        className="expand-btn"
                                        onClick={() =>
                                          toggleMilestoneExpand(
                                            milestone.milestoneMavroId,
                                          )
                                        }
                                        title={
                                          expandedMilestones[
                                            milestone.milestoneMavroId
                                          ]
                                            ? "Collapse tasks"
                                            : "Expand tasks"
                                        }
                                      >
                                        {expandedMilestones[
                                          milestone.milestoneMavroId
                                        ]
                                          ? "down"
                                          : "up"}
                                      </Button>
                                    </td>
                                    <td className="milestone-id-cell">
                                      <div className="milestone-id">
                                        {milestone.milestoneMavroId}
                                      </div>
                                    </td>
                                    <td className="milestone-name-cell">
                                      <div className="milestone-name">
                                        {milestone.name}
                                      </div>
                                    </td>
                                    <td className="milestone-type-cell">
                                      <div className="milestone-type">
                                        {milestone.type || "-"}
                                      </div>
                                    </td>
                                    <td className="milestone-percentage-cell">
                                      <div className="milestone-percentage">
                                        {milestone.calculatedPercentage !==
                                        undefined ? (
                                          <div>
                                            <div className="percentage-value">
                                              {milestone.calculatedPercentage}%
                                            </div>
                                            <div className="percentage-details small text-muted">
                                              {milestone.completedTasks}/
                                              {milestone.totalTasks} tasks
                                            </div>
                                          </div>
                                        ) : milestone.percentage ? (
                                          `${milestone.percentage}%`
                                        ) : (
                                          "-"
                                        )}
                                      </div>
                                    </td>
                                    <td className="milestone-planned-dates-cell">
                                      <div className="milestone-dates">
                                        <div>
                                          <small className="text-muted">
                                            Start:
                                          </small>{" "}
                                          {formatDate(
                                            milestone.plannedStartDate,
                                          )}
                                        </div>
                                        <div>
                                          <small className="text-muted">
                                            End:
                                          </small>{" "}
                                          {formatDate(milestone.plannedEndDate)}
                                        </div>
                                      </div>
                                    </td>
                                    <td className="milestone-actual-dates-cell">
                                      <div className="milestone-dates">
                                        <div>
                                          <small className="text-muted">
                                            Start:
                                          </small>{" "}
                                          {formatDate(
                                            milestone.actualStartDate,
                                          ) || "-"}
                                        </div>
                                        <div>
                                          <small className="text-muted">
                                            End:
                                          </small>{" "}
                                          {formatDate(
                                            milestone.actualEndDate,
                                          ) || "-"}
                                        </div>
                                      </div>
                                    </td>
                                    <td className="milestone-status-cell">
                                      <span
                                        className={`milestone-status-badge ${getStatusBadge(
                                          milestone.status,
                                        )}`}
                                      >
                                        {milestone.status}
                                      </span>
                                    </td>
                                    <td className="milestone-description-cell">
                                      <div className="milestone-description">
                                        {milestone.description
                                          ? milestone.description.length > 50
                                            ? `${milestone.description.substring(
                                                0,
                                                50,
                                              )}...`
                                            : milestone.description
                                          : "-"}
                                      </div>
                                    </td>
                                    <td className="milestone-createdby-cell">
                                      <div className="milestone-createdby">
                                        {milestone.createdBy || "-"}
                                      </div>
                                    </td>
                                    <td className="milestone-date-cell">
                                      {milestone.createdOnDate
                                        ? formatDate(milestone.createdOnDate)
                                        : "-"}
                                    </td>
                                    <td className="milestone-actions-cell">
                                      <div className="milestone-actions">
                                        {/* Only show Edit button for Admin and Manager */}
                                        {(hasProjectAdminRole() ||
                                          hasProjectManagerRole()) && (
                                          <Button
                                            variant="outline-primary"
                                            size="sm"
                                            onClick={() =>
                                              handleEditMilestone(milestone)
                                            }
                                            className="me-2"
                                            title="Edit Milestone"
                                          >
                                            Edit
                                          </Button>
                                        )}
                                        {/* Only show Delete button for Admin and Manager */}
                                        {(hasProjectAdminRole() ||
                                          hasProjectManagerRole()) && (
                                          <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() =>
                                              console.log(
                                                "trying to delete milestone",
                                              )
                                            }
                                            title="Delete Milestone"
                                          >
                                            Delete
                                          </Button>
                                        )}
                                      </div>
                                    </td>
                                  </tr>

                                  {/* Expanded tasks row */}
                                  {expandedMilestones[
                                    milestone.milestoneMavroId
                                  ] && (
                                    <tr className="milestone-tasks-row">
                                      <td
                                        colSpan="12"
                                        className="project-view-milestone-tasks-container"
                                      >
                                        <div className="milestone-tasks-content">
                                          <h6 className="tasks-section-title">
                                            Tasks Assigned to this Milestone
                                            <Badge
                                              bg="secondary"
                                              className="ms-2"
                                            >
                                              {milestoneTasks[
                                                milestone.milestoneMavroId
                                              ]?.length || 0}{" "}
                                              tasks
                                            </Badge>
                                          </h6>

                                          {milestoneTasks[
                                            milestone.milestoneMavroId
                                          ]?.length > 0 ? (
                                            <div className="table-responsive">
                                              <table className="task-subtable">
                                                <thead className="task-subtable-header">
                                                  <tr>
                                                    <th>Task ID</th>
                                                    <th>Task Name</th>
                                                    <th>Description</th>
                                                    <th>Assigned To</th>
                                                    <th>Priority</th>
                                                    <th>Status</th>
                                                    <th>Start Date</th>
                                                    <th>End Date</th>
                                                    <th>Actions</th>
                                                  </tr>
                                                </thead>
                                                <tbody className="task-subtable-body">
                                                  {milestoneTasks[
                                                    milestone.milestoneMavroId
                                                  ].map((task) => (
                                                    <tr
                                                      key={task.taskId}
                                                      className="task-subtable-row"
                                                    >
                                                      <td className="task-id-cell">
                                                        <div className="task-id">
                                                          {task.taskId}
                                                        </div>
                                                      </td>
                                                      <td className="project-view-task-name-cell">
                                                        <div
                                                          className="project-view-task-name clickable-task-name"
                                                          onClick={() =>
                                                            handleTaskNameClick(
                                                              task.taskId,
                                                            )
                                                          }
                                                          title="Click to view task details"
                                                        >
                                                          {task.taskName}
                                                        </div>
                                                      </td>
                                                      <td className="project-view-task-description-cell">
                                                        <div className="project-view-task-description">
                                                          {task.taskDescription ||
                                                            "-"}
                                                        </div>
                                                      </td>
                                                      <td className="project-view-task-assigned-cell">
                                                        <div className="task-assigned">
                                                          {taskAssignedUsers[
                                                            parseInt(
                                                              task.assignedTo,
                                                            )
                                                          ] ||
                                                            task.assignedTo ||
                                                            "Unassigned"}
                                                        </div>
                                                      </td>
                                                      <td className="project-view-task-priority-cell">
                                                        <span
                                                          className={`project-view-task-priority-badge ${getPriorityBadge(
                                                            task.taskPriority,
                                                          )}`}
                                                        >
                                                          {task.taskPriority}
                                                        </span>
                                                      </td>
                                                      <td className="project-view-task-status-cell">
                                                        <span
                                                          className={`project-view-task-status-badge ${getStatusBadge(
                                                            task.taskStatus,
                                                          )}`}
                                                        >
                                                          {task.taskStatus}
                                                        </span>
                                                      </td>
                                                      <td className="project-view-task-date-cell">
                                                        {moment(
                                                          task.taskStartDate,
                                                        ).format(
                                                          "MMM DD, YYYY",
                                                        )}
                                                      </td>
                                                      <td className="project-view-task-date-cell">
                                                        {moment(
                                                          task.taskEndDate,
                                                        ).format(
                                                          "MMM DD, YYYY",
                                                        )}
                                                      </td>
                                                      <td className="project-view-task-actions-cell">
                                                        <div className="project-view-task-actions">
                                                          {hasEditPermission() && (
                                                            <Button
                                                              variant="outline-primary"
                                                              size="sm"
                                                              onClick={() =>
                                                                handleEditTask(
                                                                  task.taskId,
                                                                )
                                                              }
                                                              className="me-2"
                                                              title="Edit Task"
                                                            >
                                                              Edit
                                                            </Button>
                                                          )}
                                                          {hasEditPermission() && (
                                                            <Button
                                                              variant="outline-danger"
                                                              size="sm"
                                                              title="Delete Task"
                                                            >
                                                              Delete
                                                            </Button>
                                                          )}
                                                          {!hasEditPermission() && (
                                                            <small className="text-muted">
                                                              View Only
                                                            </small>
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </table>
                                            </div>
                                          ) : (
                                            <div className="text-center py-3 text-muted">
                                              <i className="fas fa-tasks fa-2x mb-2"></i>
                                              <p>
                                                No tasks assigned to this
                                                milestone
                                              </p>
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "resourceAllocation" && (
              <div className="project-view-fade-in">
                <div className="resource-allocation-section">
                  <div
                    className="d-flex justify-content-between align-items-center mb-4"
                    style={{ margin: "15px" }}
                  >
                    <h4 className="mb-0">Resource Allocation</h4>
                    {/* Only show Add button for Admin and Manager */}
                    {(hasProjectAdminRole() || hasProjectManagerRole()) && (
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={handleCreateResource}
                      >
                        Add Resource
                      </Button>
                    )}
                  </div>

                  {resourcesLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading resources...
                        </span>
                      </div>
                      <p className="mt-2 text-muted">Loading resources...</p>
                    </div>
                  ) : resources.length === 0 ? (
                    <div className="text-center py-5">
                      <i className="fas fa-users fa-3x text-muted mb-3"></i>
                      <h5 className="text-muted">No Resources Allocated</h5>
                      <p className="text-muted">
                        No resources have been allocated to this project yet.
                      </p>
                      {/* Only show Add button for Admin and Manager */}
                      {(hasProjectAdminRole() || hasProjectManagerRole()) && (
                        <Button
                          variant="primary"
                          onClick={handleCreateResource}
                        >
                          Add First Resource
                        </Button>
                      )}
                    </div>
                  ) : (
                    <div className="resource-table-container">
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <thead className="table-resource">
                            <tr>
                              {/* <th>Resource ID</th> */}
                              <th>Member</th>
                              <th>Role</th>
                              <th>Billable</th>
                              <th>Allocation %</th>
                              <th>Start Date</th>
                              <th>End Date</th>
                              <th>Status</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody className="table-resource">
                            {resources.map((resource) => {
                              // Find user details for this resource member
                              const userDetail = teamMemberDetails.find(
                                (user) =>
                                  user.userId ===
                                  parseInt(resource.resourceMember),
                              );

                              // Get display name - username if available, otherwise fallback to ID
                              const displayName = userDetail
                                ? userDetail.username
                                : resource.resourceMember;

                              return (
                                <tr key={resource.resourceId}>
                                  <td>
                                    <strong>{displayName}</strong>
                                    {userDetail && userDetail.email && (
                                      <div className="text-muted small">
                                        {userDetail.email}
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    <span className="resource-role">
                                      {resource.resourceRole}
                                    </span>
                                  </td>
                                  <td>
                                    <Badge
                                      bg={
                                        resource.resourceBillable === "Billable"
                                          ? "success"
                                          : "warning"
                                      }
                                      className="billable-badge"
                                    >
                                      {resource.resourceBillable}
                                    </Badge>
                                  </td>
                                  <td>
                                    <div className="allocation-percentage">
                                      <small className="text-muted">
                                        {resource.resourceAllocaPercentage}%
                                      </small>
                                    </div>
                                  </td>
                                  <td>
                                    {formatDate(resource.resourceStartDate)}
                                  </td>
                                  <td>
                                    {formatDate(resource.resourceEndDate)}
                                  </td>
                                  <td>
                                    <Badge
                                      className={getResourceStatusBadge(
                                        resource.resourceStatus,
                                      )}
                                    >
                                      {resource.resourceStatus}
                                    </Badge>
                                  </td>
                                  <td>
                                    <div className="btn-group" role="group">
                                      {/* Only show Edit button for Admin and Manager */}
                                      {(hasProjectAdminRole() ||
                                        hasProjectManagerRole()) && (
                                        <Button
                                          variant="outline-primary"
                                          size="sm"
                                          onClick={() =>
                                            handleEditResource(resource)
                                          }
                                          title="Edit Resource"
                                          className="me-2"
                                        >
                                          Edit
                                        </Button>
                                      )}
                                      {/* Only show Delete button for Admin and Manager */}
                                      {(hasProjectAdminRole() ||
                                        hasProjectManagerRole()) && (
                                        <Button
                                          variant="outline-danger"
                                          size="sm"
                                          onClick={() =>
                                            handleDeleteResource(
                                              resource.resourceId,
                                            )
                                          }
                                          title="Delete Resource"
                                        >
                                          Delete
                                        </Button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "BuildingBlock" && (
              <div className="project-view-fade-in">
                <div
                  className="d-flex justify-content-between align-items-center mb-3"
                  style={{ padding: "20px" }}
                >
                  <h4>Building Blocks</h4>

                  <div className="d-flex gap-2">
                    {/* Toggle - Visible to all roles */}
                    <Button
                      size="sm"
                      variant={
                        blockViewType === "TASK" ? "primary" : "outline-primary"
                      }
                      onClick={() => setBlockViewType("TASK")}
                    >
                      Tasks
                    </Button>

                    <Button
                      size="sm"
                      variant={
                        blockViewType === "TICKET"
                          ? "primary"
                          : "outline-primary"
                      }
                      onClick={() => setBlockViewType("TICKET")}
                    >
                      Tickets
                    </Button>

                    {/* Add Building Block Button - Only for Admin and Manager */}
                    {(hasProjectAdminRole() || hasProjectManagerRole()) && (
                      <Button onClick={() => setShowBlockModal(true)}>
                        + Add Building Block
                      </Button>
                    )}
                  </div>
                </div>

                {blocksLoading || summaryLoading ? (
                  <div className="text-center py-4">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                    ></div>
                    <p className="mt-2">Loading {blockViewType} summary...</p>
                  </div>
                ) : buildingBlocks.length === 0 ? (
                  <p className="text-muted">No building blocks found</p>
                ) : (
                  <div
                    className="table-responsive"
                    style={{ margin: "0px 14px" }}
                  >
                    <table
                      className="table table-bordered table-hover align-middle"
                      style={{ width: "100vw" }}
                    >
                      <thead className="table-dark">
                        <tr>
                          <th>#</th>
                          <th>Block ID</th>
                          <th>Name</th>
                          <th>Status</th>
                          <th>Type</th>
                          <th>Process POC</th>
                          <th>Tech POC</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Total</th>

                          {blockViewType === "TASK" ? (
                            <>
                              <th>New</th>
                              <th>In Progress</th>
                              <th>Not Started</th>
                              <th>On Hold</th>
                              <th>Completed</th>
                              <th>Cancelled</th>
                            </>
                          ) : (
                            <>
                              <th>Open</th>
                              <th>In Progress</th>
                              <th>Resolved</th>
                              <th>Closed</th>
                            </>
                          )}

                          <th>Progress</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {buildingBlocks.map((block, index) => (
                          <tr key={block.buildingBlockId}>
                            <td>{index + 1}</td>
                            <td>{block.buildingBlockId}</td>
                            <td>{block.buildingBlockName}</td>
                            <td>
                              <span
                                className={`badge ${
                                  block.buildingBlockStatus === "Completed"
                                    ? "bg-success"
                                    : block.buildingBlockStatus ===
                                        "In Progress"
                                      ? "bg-primary"
                                      : "bg-secondary"
                                }`}
                              >
                                {block.buildingBlockStatus || "N/A"}
                              </span>
                            </td>
                            <td>{block.buildingBlockTypes || "-"}</td>
                            <td>
                              {getUsernameFromId(
                                block.buildingBlockProcessPoc,
                              ) || "-"}
                            </td>
                            <td>
                              {getUsernameFromId(block.buildingBlockTechPoc) ||
                                "-"}
                            </td>
                            <td>
                              {block.actualStartDate
                                ? moment(block.actualStartDate).format(
                                    "MMM DD, YYYY",
                                  )
                                : "-"}
                            </td>
                            <td>
                              {block.actualEndDate
                                ? moment(block.actualEndDate).format(
                                    "MMM DD, YYYY",
                                  )
                                : "-"}
                            </td>
                            <td>
                              {blockSummaries[block.buildingBlockId]?.total ||
                                0}
                            </td>

                            {blockViewType === "TASK" ? (
                              <>
                                <td>
                                  {blockSummaries[block.buildingBlockId]?.new ||
                                    0}
                                </td>
                                <td>
                                  {blockSummaries[block.buildingBlockId]
                                    ?.inProgress || 0}
                                </td>
                                <td>
                                  {blockSummaries[block.buildingBlockId]
                                    ?.notStarted || 0}
                                </td>
                                <td>
                                  {blockSummaries[block.buildingBlockId]
                                    ?.onHold || 0}
                                </td>
                                <td>
                                  {blockSummaries[block.buildingBlockId]
                                    ?.completed || 0}
                                </td>
                                <td>
                                  {blockSummaries[block.buildingBlockId]
                                    ?.cancelled || 0}
                                </td>
                              </>
                            ) : (
                              <>
                                <td>
                                  {blockSummaries[block.buildingBlockId]
                                    ?.open || 0}
                                </td>
                                <td>
                                  {blockSummaries[block.buildingBlockId]
                                    ?.inProgress || 0}
                                </td>
                                <td>
                                  {blockSummaries[block.buildingBlockId]
                                    ?.resolved || 0}
                                </td>
                                <td>
                                  {blockSummaries[block.buildingBlockId]
                                    ?.closed || 0}
                                </td>
                              </>
                            )}

                            <td>
                              <div
                                className="progress"
                                style={{ height: "8px" }}
                              >
                                <div
                                  className="progress-bar bg-success"
                                  style={{
                                    width: `${blockSummaries[block.buildingBlockId]?.progressPercent || 0}%`,
                                  }}
                                ></div>
                              </div>
                              <small>
                                {blockSummaries[block.buildingBlockId]
                                  ?.progressPercent || 0}
                                %
                              </small>
                            </td>

                            <td style={{ display: "flex", gap: "6px" }}>
                              {/* Map Button - Only for Admin and Manager */}
                              {(hasProjectAdminRole() ||
                                hasProjectManagerRole()) && (
                                <Button
                                  size="sm"
                                  variant="primary"
                                  onClick={() => openMapModal(block)}
                                  style={{ padding: "10px" }}
                                  title="Map items to this block"
                                >
                                  <MdAddChart style={{ fontSize: "16px" }} />
                                </Button>
                              )}

                              {/* View Button - Visible to all roles */}
                              <Button
                                size="sm"
                                variant="info"
                                onClick={() => openBlockItemsModal(block)}
                                style={{ padding: "10px" }}
                                title="View block items"
                              >
                                <TfiViewListAlt style={{ fontSize: "16px" }} />
                              </Button>

                              {/* Edit Button - Only for Admin and Manager */}
                              {(hasProjectAdminRole() ||
                                hasProjectManagerRole()) && (
                                <Button
                                  size="sm"
                                  variant="warning"
                                  onClick={() => handleEditBlock(block)}
                                  style={{ padding: "10px" }}
                                  title="Edit block"
                                >
                                  <FaEdit style={{ fontSize: "16px" }} />
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {activeTab === "budget" && (
              <div className="project-view-fade-in text-center py-5">
                <h4>Project Budget</h4>
                <p className="text-muted">
                  Budget management features coming soon...
                </p>
              </div>
            )}

            {activeTab === "settings" && (
              <div className="project-view-fade-in p-4">
                <h4>Project Settings</h4>

                <Form.Check
                  type="switch"
                  id="revenue-allowed"
                  label="Revenue Allowed for this Project"
                  checked={project?.revenue === true}
                  onChange={(e) =>
                    handleFieldChange("revenue", e.target.checked)
                  }
                />

                <small className="text-muted d-block mt-2">
                  Enable this if this project is allowed for revenue & invoicing
                </small>
              </div>
            )}
          </div>
        </div>
      </Container>

      {/* Task Edit Modal */}
      <TaskEditModal
        show={showEditModal}
        onHide={handleCloseEditModal}
        taskId={selectedTaskId}
        onTaskUpdated={handleTaskUpdated}
      />

      {/* Task View Sidebar */}
      <TaskViewSidebar
        show={showTaskSidebar}
        onHide={() => setShowTaskSidebar(false)}
        taskId={selectedTaskId}
        onTaskUpdated={() => {
          loadProjectTasks();
        }}
      />

      {/* Task Template Modal */}
      <TaskTemplateModal
        show={showTemplateModal}
        onHide={() => setShowTemplateModal(false)}
        template={selectedTemplate}
        orgId={orgId}
        onTemplateSaved={handleTemplateSaved}
      />

      {/* Partner Modal */}
      <PartnerModal
        show={showPartnerModal}
        onHide={handleClosePartnerModal}
        partner={editingPartner}
        orgId={orgId}
        projectId={projectId}
        onPartnerSaved={handlePartnerSaved}
      />

      {/* Stage Modal */}
      <StageModal
        show={showStageModal}
        onHide={handleCloseStageModal}
        stage={editingStage}
        orgId={orgId}
        projectId={projectId}
        onStageSaved={handleStageSaved}
      />

      {/* Commercial Modal */}
      <CommercialModal
        show={showCommercialModal}
        onHide={handleCloseCommercialModal}
        commercial={editingCommercial}
        projectId={projectId}
        onCommercialSaved={handleCommercialSaved}
      />

      {/* Milestone Modal */}
      <MilestoneModal
        show={showMilestoneModal}
        onHide={handleCloseMilestoneModal}
        milestone={editingMilestone}
        projectId={projectId}
        onMilestoneSaved={handleMilestoneSaved}
      />

      {/* Resource Modal */}
      <ResourceModal
        show={showResourceModal}
        onHide={handleCloseResourceModal}
        resource={editingResource}
        projectId={projectId}
        teamAssigned={project?.teamAssigned}
        onResourceSaved={handleResourceSaved}
      />

      {/* ======================= Ticket close modal ======================= */}

      <Modal
        show={showTicketDialog}
        onHide={closeTicketDialog}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Ticket: {ticketForDialog?.ticketId} •{" "}
            <span style={{ fontWeight: 400 }}>
              {ticketForDialog?.ticketName}
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Important details */}
          <Card className="mb-3">
            <Card.Body>
              <Row className="mb-2">
                <Col xs={6}>
                  <small className="text-muted">Status</small>
                  <div>
                    <span
                      className={`ticket-status-badge ${getStatusBadge(
                        ticketForDialog?.status,
                      )}`}
                    >
                      {ticketForDialog?.status || "-"}
                    </span>
                  </div>
                </Col>
                <Col xs={6}>
                  <small className="text-muted">Priority</small>
                  <div
                    className={`project-view-ticket-priority-badge ${getPriorityBadge(
                      ticketForDialog?.priority,
                    )}`}
                  >
                    {ticketForDialog?.priority || "-"}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <small className="text-muted">Created</small>
                  <div>{formatDateTime(ticketForDialog?.ticketTime)}</div>
                </Col>
                <Col xs={6}>
                  <small className="text-muted">Due</small>
                  <div>{formatDate(ticketForDialog?.dueDate)}</div>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Assign member (team members only) */}
          <Card className="mb-3">
            <Card.Header className="py-2">
              <strong>Assign a team member</strong>
            </Card.Header>
            <Card.Body className="py-3">
              <Row className="g-2">
                <Col xs={8}>
                  <Form.Select
                    value={assignUserId}
                    onChange={(e) => setAssignUserId(e.target.value)}
                    disabled={assignLoading || assignmentsLoading}
                  >
                    <option value="">Select team member...</option>
                    {teamMemberDetails.map((u) => {
                      const active = getActiveAssignmentForUser(
                        ticketForDialog?.ticketId,
                        u.userId,
                      );
                      return (
                        <option key={u.userId} value={u.userId}>
                          {u.username} ({u.userId})
                          {active ? " • Active session running" : ""}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Col>
                <Col xs={4}>
                  <Button
                    variant="primary"
                    className="w-100"
                    onClick={handleAssignAndStart}
                    disabled={assignLoading || !assignUserId}
                  >
                    {assignLoading ? "Starting..." : "Assign & Start"}
                  </Button>
                </Col>
              </Row>
              <small className="text-muted d-block mt-2">
                Only members of the project’s assigned team are listed.
              </small>
            </Card.Body>
          </Card>

          {/* Current assignments list */}
          <Card>
            <Card.Header className="py-2 d-flex justify-content-between align-items-center">
              <strong>Assignments on this ticket</strong>
              {assignmentsLoading && (
                <span className="text-muted" style={{ fontSize: 12 }}>
                  loading...
                </span>
              )}
            </Card.Header>
            <Card.Body className="py-2">
              {(assignmentsByTicket[ticketForDialog?.ticketId] || []).length ===
              0 ? (
                <div className="text-muted">No assignments yet</div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>Hours</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ...(assignmentsByTicket[ticketForDialog?.ticketId] ||
                          []),
                      ]
                        .sort(
                          (a, b) =>
                            new Date(b.startTime || 0) -
                            new Date(a.startTime || 0),
                        )
                        .map((a) => {
                          const userInfo = teamMemberDetails.find(
                            (u) =>
                              String(u.userId) === String(a.assignedUserId),
                          );
                          const name =
                            userInfo?.username || `User ${a.assignedUserId}`;
                          const active =
                            a.isActive === true || a.isActive === 1;

                          return (
                            <tr key={a.assignmentId}>
                              <td>{name}</td>
                              <td>{formatDateTime(a.startTime)}</td>
                              <td>
                                {a.endTime ? formatDateTime(a.endTime) : "-"}
                              </td>
                              <td>{fmtHours(a.totalHours)}</td>
                              <td>
                                {active ? (
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => handleStop(a.assignmentId)}
                                  >
                                    Stop
                                  </Button>
                                ) : (
                                  <Badge bg="secondary">Stopped</Badge>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              )}
            </Card.Body>
          </Card>

          <Card className="mb-3">
            <Card.Header className="py-2">
              <strong>Building Blocks</strong>
            </Card.Header>

            <Card.Body className="py-3">
              {/* Already Assigned Blocks */}
              {ticketBlocks.length === 0 ? (
                <div className="text-muted mb-3">
                  Not assigned to any Building Block
                </div>
              ) : (
                <div className="mb-3">
                  {ticketBlocks.map((block) => (
                    <Badge
                      key={block.buildingBlockId}
                      bg="info"
                      className="me-2 mb-2"
                    >
                      {block.buildingBlockName}
                    </Badge>
                  ))}
                </div>
              )}

              {/* Add New Block */}
              <Row className="g-2 align-items-end">
                <Col xs={8}>
                  <Form.Select
                    value={selectedBlockId}
                    onChange={(e) => setSelectedBlockId(e.target.value)}
                    disabled={blockMappingLoading}
                  >
                    <option value="">Select Building Block...</option>

                    {availableBlocksForMapping.length === 0 ? (
                      <option disabled>No available blocks</option>
                    ) : (
                      availableBlocksForMapping.map((block) => (
                        <option
                          key={block.buildingBlockId}
                          value={block.buildingBlockId}
                        >
                          {block.buildingBlockName}
                        </option>
                      ))
                    )}
                  </Form.Select>
                </Col>

                <Col xs={4}>
                  <Button
                    variant="primary"
                    className="w-100"
                    onClick={handleMapTicketToBlock}
                    disabled={blockMappingLoading}
                  >
                    {blockMappingLoading ? "Adding..." : "Add"}
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <Card className="mb-3">
            <Card.Header className="py-2">
              <strong>Assigned Building Blocks</strong>
            </Card.Header>

            <Card.Body className="py-2">
              {ticketBlocks.length === 0 ? (
                <div className="text-muted">No building blocks assigned</div>
              ) : (
                <ul className="list-group">
                  {ticketBlocks.map((block) => (
                    <li
                      key={block.buildingBlockId}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <span>{block.buildingBlockName}</span>

                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() =>
                          handleRemoveBlockMapping(block.buildingBlockId)
                        }
                      >
                        Remove
                      </Button>
                    </li>
                  ))}
                </ul>
              )}
            </Card.Body>
          </Card>

          <Card className="mb-3">
            <Card.Header className="py-2">
              <strong>Add Work Log (No Closure)</strong>
            </Card.Header>

            <Card.Body className="py-3">
              <Row className="g-2 align-items-end">
                <Col xs={5}>
                  <Form.Select
                    value={ticketWorkUserId}
                    onChange={(e) => setTicketWorkUserId(e.target.value)}
                  >
                    <option value="">Select member</option>
                    {teamMemberDetails.map((u) => (
                      <option key={u.userId} value={u.userId}>
                        {u.username}
                      </option>
                    ))}
                  </Form.Select>
                </Col>

                <Col xs={4}>
                  <Form.Control
                    type="number"
                    step="0.25"
                    min="0"
                    placeholder="Hours"
                    value={ticketWorkValue}
                    onChange={(e) => setTicketWorkValue(e.target.value)}
                  />
                </Col>

                <Col xs={3}>
                  <Button
                    variant="primary"
                    className="w-100"
                    disabled={savingTicketWorkLog}
                    onClick={handleSaveTicketWorkLog}
                  >
                    {savingTicketWorkLog ? "Saving..." : "Add"}
                  </Button>
                </Col>
              </Row>

              <small className="text-muted d-block mt-2">
                This does not close the ticket.
              </small>
            </Card.Body>
          </Card>
          <Card>
            <Card.Header className="py-2">
              <strong>Work & Activity Logs</strong>
            </Card.Header>

            <Card.Body className="py-2">
              {ticketLogsLoading ? (
                <div className="text-muted">Loading logs...</div>
              ) : ticketLogs.length === 0 ? (
                <div className="text-muted">No logs yet</div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>User</th>
                        <th>Hours</th>
                        <th>Date</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ticketLogs.map((log) => (
                        <tr key={log.ticketLogGuid}>
                          <td>
                            <Badge
                              bg={
                                log.actionType === "WORK_LOG"
                                  ? "info"
                                  : "secondary"
                              }
                            >
                              {log.actionType}
                            </Badge>
                          </td>
                          <td>{log.changedBy}</td>
                          <td>
                            {log.effortValue
                              ? `${log.effortValue} ${log.effortUnit}`
                              : "-"}
                          </td>
                          <td>{formatDateTime(log.createdDate)}</td>
                          <td>{log.closureRemarks || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </Card.Body>
          </Card>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeTicketDialog}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ======================= TASK ASSIGNMENT DIALOG ======================= */}
      {/* ======================= TASK ASSIGNMENT DIALOG ======================= */}
      <Modal
        show={showTaskDialog}
        onHide={closeTaskDialog}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Manage Task Assignment</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {taskForDialog ? (
            <>
              <h5>{taskForDialog.taskName}</h5>
              <p className="text-muted">
                {taskForDialog.taskDescription || "No description"}
              </p>

              <div className="mb-3">
                <strong>Planned:</strong>{" "}
                {formatDate(taskForDialog.taskStartDate)} →{" "}
                {formatDate(taskForDialog.taskEndDate)}
              </div>

              {/* Assign Team Member Section - Only Admins/Managers can assign to anyone */}
              <Form.Group className="mb-3">
                <Form.Label>Assign Team Member</Form.Label>
                <Form.Select
                  value={assignTaskUserId}
                  onChange={(e) => setAssignTaskUserId(e.target.value)}
                  disabled={taskAssignLoading}
                >
                  <option value="">Select a team member</option>
                  {teamMemberDetails.map((user) => {
                    // For non-admin/non-manager users, only show themselves in the dropdown
                    if (!hasEditPermission()) {
                      if (String(user.userId) === String(userId)) {
                        return (
                          <option key={user.userId} value={user.userId}>
                            {user.username} (Self)
                          </option>
                        );
                      }
                      return null;
                    }
                    // Admins/Managers see all team members
                    return (
                      <option key={user.userId} value={user.userId}>
                        {user.username}
                      </option>
                    );
                  })}
                </Form.Select>
                {!hasEditPermission() && (
                  <Form.Text className="text-muted">
                    You can only assign the task to yourself
                  </Form.Text>
                )}
              </Form.Group>

              <div className="d-flex gap-2 justify-content-end">
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={handleAssignUserOnly}
                  disabled={taskAssignLoading || !assignTaskUserId}
                >
                  Assign
                </Button>
              </div>

              <hr />

              <h6>Assignment History</h6>
              {taskAssignLoading ? (
                <div className="text-center py-3">
                  <div className="spinner-border spinner-border-sm text-primary" />
                </div>
              ) : taskAssignments.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Total Hours</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {taskAssignments.map((assign) => {
                        const userName = getUsernameFromId(
                          assign.assignedUserId,
                        );
                        const isCurrentUser =
                          String(assign.assignedUserId) === String(userId);

                        return (
                          <tr key={assign.assignmentId}>
                            <td>{userName}</td>
                            <td>{formatDateTime(assign.startTime)}</td>
                            <td>
                              {formatDateTime(assign.endTime) || "Ongoing"}
                            </td>
                            <td>{fmtHours(assign.totalHours)}</td>
                            <td>
                              <Badge
                                bg={
                                  assign.isPaused
                                    ? "warning"
                                    : assign.isActive
                                      ? "success"
                                      : "secondary"
                                }
                              >
                                {assign.isPaused
                                  ? "Paused"
                                  : assign.isActive
                                    ? "Active"
                                    : "Not Started"}
                              </Badge>
                            </td>
                            <td>
                              {/* Start Button - Only show for current user or admin/manager */}
                              {isNotStarted(assign) &&
                                (hasEditPermission() || isCurrentUser) && (
                                  <Button
                                    size="sm"
                                    variant="success"
                                    onClick={async () => {
                                      await startTaskWork(
                                        taskForDialog.taskId,
                                        assign.assignedUserId,
                                        orgId,
                                      );
                                      toast.success("Work started");
                                      await refreshTaskAssignments(
                                        taskForDialog.taskId,
                                      );
                                    }}
                                  >
                                    Start
                                  </Button>
                                )}

                              {/* Pause Button - Only show for current user or admin/manager */}
                              {isActive(assign) &&
                                (hasEditPermission() || isCurrentUser) && (
                                  <Button
                                    size="sm"
                                    variant="warning"
                                    onClick={async () => {
                                      await pauseTaskWork(assign.assignmentId);
                                      toast.info("Work paused");
                                      await refreshTaskAssignments(
                                        taskForDialog.taskId,
                                      );
                                    }}
                                  >
                                    Pause
                                  </Button>
                                )}

                              {/* Resume Button - Only show for current user or admin/manager */}
                              {isPaused(assign) &&
                                (hasEditPermission() || isCurrentUser) && (
                                  <Button
                                    size="sm"
                                    variant="success"
                                    onClick={async () => {
                                      await startTaskWork(
                                        taskForDialog.taskId,
                                        assign.assignedUserId,
                                        orgId,
                                      );
                                      toast.success("Work resumed");
                                      await refreshTaskAssignments(
                                        taskForDialog.taskId,
                                      );
                                    }}
                                  >
                                    Resume
                                  </Button>
                                )}

                              {/* Stop Button - Only show for current user or admin/manager */}
                              {(isActive(assign) || isPaused(assign)) &&
                                (hasEditPermission() || isCurrentUser) && (
                                  <Button
                                    size="sm"
                                    variant="danger"
                                    className="ms-2"
                                    onClick={async () => {
                                      await stopTaskWork(assign.assignmentId);
                                      toast.success("Work stopped");
                                      await refreshTaskAssignments(
                                        taskForDialog.taskId,
                                      );
                                    }}
                                  >
                                    Stop
                                  </Button>
                                )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-muted">
                  No assignment history found for this task.
                </p>
              )}

              <hr />

              {/* Add Manual Work Log Section */}
              <h6>Add Manual Work Log</h6>

              <Row className="align-items-end">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>User</Form.Label>
                    <Form.Select
                      value={workLogUserId}
                      onChange={(e) => setWorkLogUserId(e.target.value)}
                    >
                      <option value="">Select user</option>
                      {teamMemberDetails.map((u) => {
                        // Check if user can add work log for this user
                        let canSelect = false;

                        if (hasEditPermission()) {
                          // Admins/Managers can add work log for anyone
                          canSelect = true;
                        } else if (hasProjectCommercialRole()) {
                          // Commercial can only add work log for themselves
                          canSelect = String(u.userId) === String(userId);
                        } else {
                          // Regular users can only add work log for themselves
                          canSelect = String(u.userId) === String(userId);
                        }

                        return (
                          <option
                            key={u.userId}
                            value={u.userId}
                            disabled={!canSelect}
                          >
                            {u.username} {!canSelect && "(Cannot add work log)"}
                          </option>
                        );
                      })}
                    </Form.Select>
                    {!hasEditPermission() && !hasProjectCommercialRole() && (
                      <Form.Text className="text-muted">
                        You can only add work log for yourself
                      </Form.Text>
                    )}
                    {hasProjectCommercialRole() && !hasEditPermission() && (
                      <Form.Text className="text-muted">
                        Commercial role: You can only add work log for yourself
                      </Form.Text>
                    )}
                    {hasEditPermission() && (
                      <Form.Text className="text-muted">
                        Admin/Manager: You can add work log for any team member
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Work</Form.Label>
                    <Form.Control
                      type="number"
                      min="0"
                      step="0.25"
                      value={workValue}
                      onChange={(e) => setWorkValue(e.target.value)}
                      placeholder="e.g. 2.5"
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Unit</Form.Label>
                    <Form.Select
                      value={workUnit}
                      onChange={(e) => setWorkUnit(e.target.value)}
                    >
                      <option value="HOUR">Hour(s)</option>
                      <option value="DAY">Day(s)</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={2}>
                  <Button
                    variant="primary"
                    size="sm"
                    disabled={savingWorkLog || !workLogUserId || !workValue}
                    onClick={handleSaveWorkLog}
                  >
                    {savingWorkLog ? "Saving..." : "Add"}
                  </Button>
                </Col>
              </Row>

              <hr />

              <h6>Task Log History</h6>

              {taskLogsLoading ? (
                <div className="text-center py-3">
                  <div className="spinner-border spinner-border-sm text-primary" />
                </div>
              ) : taskLogs.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Work</th>
                        <th>Type</th>
                        <th>Description</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {taskLogs.map((log) => {
                        const userName = getUsernameFromId(
                          log.assignedUserId || log.createdBy,
                        );

                        return (
                          <tr key={log.taskLogId}>
                            <td>{userName}</td>
                            <td>
                              {log.workValue
                                ? `${log.workValue} ${log.workUnit}`
                                : "-"}
                            </td>
                            <td>
                              <Badge bg="info">{log.logType}</Badge>
                            </td>
                            <td>{log.logDescription || "-"}</td>
                            <td>
                              {moment(log.createdDate).format("MMM DD, YYYY")}{" "}
                              {moment(log.createdTime, "HH:mm:ss").format(
                                "hh:mm A",
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-muted">No task logs found.</p>
              )}
            </>
          ) : (
            <div className="text-center text-muted">No task selected</div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeTaskDialog}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Excel Upload Modal */}
      <Modal
        show={showExcelUploadModal}
        onHide={handleCloseExcelUploadModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-file-excel me-2 text-success"></i>
            Upload Tasks from Excel
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="excel-upload-container">
            <div className="mb-4">
              <h5>Instructions:</h5>
              <ul className="small">
                <li>Download the template to see the required format</li>
                <li>Supported formats: .xlsx, .xls, .csv</li>
                <li>
                  Required columns: taskName, taskDescription, assignedTo,
                  taskStartDate, taskEndDate
                </li>
                <li>Optional columns: taskPriority, taskStatus, taskType</li>
                <li>Dates should be in YYYY-MM-DD format</li>
              </ul>
            </div>

            <div className="mb-4">
              <Button
                variant="outline-success"
                onClick={handleDownloadTemplate}
                className="mb-3"
              >
                <i className="fas fa-download me-2"></i>
                Download Excel Template
              </Button>
            </div>

            <Form.Group className="mb-4">
              <Form.Label>Select Excel File:</Form.Label>
              <Form.Control
                type="file"
                accept=".xlsx,.xls,.csv"
                onChange={handleExcelFileSelect}
              />
              <Form.Text className="text-muted">
                {excelFile ? `Selected: ${excelFile.name}` : "No file selected"}
              </Form.Text>
            </Form.Group>

            <div className="upload-info-card p-3 bg-light rounded">
              <h6 className="mb-2">Upload Information:</h6>
              <div className="row">
                <div className="col-md-6">
                  <small>
                    <strong>Organization ID:</strong> {orgId}
                  </small>
                </div>
                <div className="col-md-6">
                  <small>
                    <strong>Project ID:</strong> {project?.projectId}
                  </small>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-12">
                  <small>
                    <strong>Project:</strong> {project?.prTitle}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseExcelUploadModal}
            disabled={uploadingExcel}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handleExcelUpload}
            disabled={!excelFile || uploadingExcel}
          >
            {uploadingExcel ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Uploading...
              </>
            ) : (
              <>
                <i className="fas fa-upload me-2"></i>
                Upload & Create Tasks
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ======================= Building block create ======================= */}

      {/* ======================= Building block create ======================= */}
      {(hasProjectAdminRole() || hasProjectManagerRole()) && (
        <Modal
          show={showBlockModal}
          onHide={() => {
            setShowBlockModal(false);
            resetBlockForm();
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isEditingBlock ? "Edit Building Block" : "Create Building Block"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Building Block Name *</Form.Label>
                  <Form.Control
                    type="text"
                    value={blockForm.buildingBlockName}
                    onChange={(e) =>
                      handleBlockChange("buildingBlockName", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    value={blockForm.buildingBlockStatus}
                    onChange={(e) =>
                      handleBlockChange("buildingBlockStatus", e.target.value)
                    }
                  >
                    {BUILDING_BLOCK_STATUS_OPTIONS.map((status) => (
                      <option key={status} value={status}>
                        {status}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={blockForm.buildingBlockDescription}
                    onChange={(e) =>
                      handleBlockChange(
                        "buildingBlockDescription",
                        e.target.value,
                      )
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Process POC</Form.Label>
                  <Form.Select
                    value={blockForm.buildingBlockProcessPoc || ""}
                    onChange={(e) =>
                      handleBlockChange(
                        "buildingBlockProcessPoc",
                        e.target.value,
                      )
                    }
                  >
                    <option value="">Select Process POC</option>
                    {teamMemberDetails.map((member) => (
                      <option key={member.userId} value={member.userId}>
                        {member.username}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Tech POC</Form.Label>
                  <Form.Select
                    value={blockForm.buildingBlockTechPoc || ""}
                    onChange={(e) =>
                      handleBlockChange("buildingBlockTechPoc", e.target.value)
                    }
                  >
                    <option value="">Select Tech POC</option>
                    {teamMemberDetails.map((member) => (
                      <option key={member.userId} value={member.userId}>
                        {member.username}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Type</Form.Label>
                  <Form.Control
                    type="text"
                    value={blockForm.buildingBlockTypes}
                    onChange={(e) =>
                      handleBlockChange("buildingBlockTypes", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={blockForm.actualStartDate}
                    onChange={(e) =>
                      handleBlockChange("actualStartDate", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={blockForm.actualEndDate}
                    onChange={(e) =>
                      handleBlockChange("actualEndDate", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowBlockModal(false);
                resetBlockForm();
              }}
            >
              Cancel
            </Button>

            <Button onClick={handleSaveBlock}>
              {isEditingBlock ? "Update" : "Create"}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* ======================= TASK Map Modal ======================= */}
      <Modal
        show={showTaskMapModal}
        onHide={() => setShowTaskMapModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Add {blockViewType === "TASK" ? "Tasks" : "Tickets"} to{" "}
            {selectedBlock?.buildingBlockName}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {projectTasksForMapping.length === 0 ? (
            <p>No tasks available for this project.</p>
          ) : (
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Task ID</th>
                    <th>Name</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {projectTasksForMapping.map((item) => (
                    <tr
                      key={
                        blockViewType === "TASK" ? item.taskId : item.ticketId
                      }
                    >
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={selectedTaskIds.includes(
                            blockViewType === "TASK"
                              ? item.taskId
                              : item.ticketId,
                          )}
                          onChange={() =>
                            handleTaskSelection(
                              blockViewType === "TASK"
                                ? item.taskId
                                : item.ticketId,
                            )
                          }
                        />
                      </td>

                      <td>
                        {blockViewType === "TASK" ? item.taskId : item.ticketId}
                      </td>

                      <td>
                        {blockViewType === "TASK"
                          ? item.taskName
                          : item.ticketName}
                      </td>

                      <td>
                        {blockViewType === "TASK"
                          ? item.taskStatus
                          : item.status}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowTaskMapModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleMapTasks}
            disabled={mappingLoading}
          >
            {mappingLoading ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ======================= block block modal ======================= */}
      <Modal
        show={showBlockTasksModal}
        onHide={() => setShowBlockTasksModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {blockViewType === "TASK" ? "Tasks" : "Tickets"} -{" "}
            {selectedBlock?.buildingBlockName}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {blockTasks.length === 0 ? (
            <p>No {blockViewType === "TASK" ? "tasks" : "tickets"} mapped.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>

                    {/* 🔥 THIS IS WHERE YOUR LINE GOES */}
                    <th>
                      {blockViewType === "TASK" ? "Task ID" : "Ticket ID"}
                    </th>

                    <th>Name</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {blockTasks.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>

                      {blockViewType === "TASK" ? (
                        <>
                          <td>{item.taskId}</td>
                          <td>{item.taskName}</td>
                          <td>{item.taskStatus}</td>
                        </>
                      ) : (
                        <>
                          <td>{item.ticketId}</td>
                          <td>{item.ticketName}</td>
                          <td>{item.ticketStatus}</td>
                        </>
                      )}

                      <td>
                        <Button
                          size="sm"
                          variant="danger"
                          onClick={() =>
                            handleRemoveItemFromBlock(
                              blockViewType === "TASK"
                                ? item.taskId
                                : item.ticketId,
                            )
                          }
                        >
                          Remove
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowBlockTasksModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProjectView;
